import { useQuery, useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import React, { useState, useRef, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { Button, CircularProgress, TextField, LinearProgress, Link, IconButton, Card, makeStyles, Typography, Divider, Tabs, Tab, Slider, InputAdornment, FormGroup, FormControlLabel, Checkbox, Avatar, Popover, DialogContent, OutlinedInput, Dialog, Menu, MenuItem, withStyles, DialogTitle, DialogActions, RadioGroup, Radio, Snackbar, Paper, Tooltip, Fade, Drawer, useMediaQuery, Badge } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import { max, min, isSameMonth, addMonths, format, startOfWeek, startOfMonth, endOfMonth, isBefore, addDays, isToday, getDate, addYears, differenceInCalendarMonths, isAfter, isSameDay, parseISO, subDays } from 'date-fns';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { KeyboardDatePicker, MuiPickersUtilsProvider, TimePicker } from '@material-ui/pickers';
import SearchIcon from '@material-ui/icons/Search';
import DateFnsUtils from '@date-io/date-fns';
import idLocale from 'date-fns/locale/id';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import { NotificationsNoneOutlined, HomeOutlined, PeopleAltOutlined, EmailOutlined } from '@material-ui/icons';
import TodayIcon from '@material-ui/icons/Today';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import axios from 'axios';
import MenuIcon from '@material-ui/icons/Menu';
import WidgetsIcon from '@material-ui/icons/Widgets';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _templateObject$4;
var GET_MODULE_SETTING = gql(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["query($company:uuid){company_module_settings(where:{company:{_eq:$company}}){id global_module{id name routes}}}"])));

var _templateObject$3;
var GET_MICRO_LEARNING_DAILY = gql(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["query($onlyAfterNow:Boolean){microlearningDaily(onlyAfterNow:$onlyAfterNow){daily_answer_id microlearning{id name icon_url owner{id name avatar}type company_profile{id legal_name brand_name logo}}member_answers{member_answer_id question_id question question_type appears_at possible_answers{id answer}correct_answer_count}}}"])));

var _templateObject$2, _templateObject2;
var GET_TIME_WIDGET = gql(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["query getTimeWidget($company:uuid $self:uuid $date_start_holiday:date $date_end_holiday:date $date_start_event:timestamp $date_end_event:timestamp $date_start_leave:date $date_end_leave:date $date_start_todo:timestamp $date_end_todo:timestamp){holiday:time_holidays(where:{company:{_eq:$company}date:{_gte:$date_start_holiday,_lte:$date_end_holiday}deletedAt:{_is_null:true}}order_by:{date:asc}){id date name description type}event:event_time_schedules(where:{company:{_eq:$company}start_date:{_lte:$date_end_event}end_date:{_gte:$date_start_event}deletedAt:{_is_null:true}event_time_participants:{user:{_eq:$self}}}){id title start_date end_date}leave:people_work_leaves(where:{deletedAt:{_is_null:true}status:{_eq:\"approved\"}datestart:{_lte:$date_end_leave}dateend:{_gte:$date_start_leave}people_work_placement:{company:{_eq:$company}}calendar_id:{_is_null:true}}){id id_display datestart dateend is_half time_leave_policy_child{name}people_work_placement{id global_user{id name}}}todo:todo_list_time(where:{created_by:{_eq:$self}date:{_gte:$date_start_todo,_lt:$date_end_todo}deletedAt:{_is_null:true}}){id title date}}"])));
var GET_TRIP_WIDGET = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["query getTripWidget($company:uuid $date_end_bt:date $date_start_bt:date){trip:people_work_business_trips(where:{deletedAt:{_is_null:true}status:{_eq:\"approved\"}date_start:{_lte:$date_end_bt}date_end:{_gte:$date_start_bt}people_work_placement:{company:{_eq:$company}}}){id id_display date_start date_end people_work_placement{id global_user{id name}}}}"])));

var GetModularSettings = function GetModularSettings(company, skip) {
  var _useQuery = useQuery(GET_MODULE_SETTING, {
      wlb_skipPatch: true,
      variables: {
        company: company
      },
      context: {
        headers: {
          'X-Hasura-Role': 'public'
        }
      },
      fetchPolicy: 'cache-and-network',
      skip: skip
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error,
    refetch = _useQuery.refetch;
  return {
    data: data,
    loading: loading,
    error: error,
    refetch: refetch
  };
};

var _excluded$2 = ["disabled", "multiple", "onChange", "onClick"];
var PrimitiveUploadButton = styled(Button)(["height:70px;width:70px;&.MuiButton-contained{background-color:#ffffff;}input{height:0;width:0;overflow:hidden;visibility:hidden;}"]);
function UploadButton(props) {
  var disabled = props.disabled,
    multiple = props.multiple,
    onChange = props.onChange,
    onClick = props.onClick,
    rest = _objectWithoutPropertiesLoose(props, _excluded$2);
  var inputRef = React.useRef();
  var handleChange = function handleChange(ev) {
    if (onChange) {
      onChange(ev);
    }
    ev.target.value = '';
  };
  var handleClick = function handleClick(ev) {
    if (onClick) {
      onClick(ev);
    }
    if (!ev.defaultPrevented) {
      inputRef.current.click();
    }
  };
  return /*#__PURE__*/React.createElement(PrimitiveUploadButton, _extends({}, rest, {
    onClick: handleClick,
    disabled: disabled,
    variant: "contained"
  }), /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    onChange: handleChange,
    type: "file",
    multiple: multiple,
    disabled: disabled
  }), /*#__PURE__*/React.createElement(AddIcon, {
    fontSize: "large",
    color: "secondary"
  }));
}

var PowerpointIcon = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24.283' height='32.377'%3e%3cpath fill='%23ef4d5e' d='M12.249 17.15a1.622 1.622 0 0 1 1.284.512 2.324 2.324 0 0 1-.013 2.789 1.679 1.679 0 0 1-1.334.538h-1.7V17.15zM23.84 6.64l-6.2-6.2A1.517 1.517 0 0 0 16.568 0h-.379v8.094h8.094v-.385a1.513 1.513 0 0 0-.443-1.069zM14.165 8.6V0H1.518A1.514 1.514 0 0 0 0 1.518V30.86a1.514 1.514 0 0 0 1.518 1.518h21.247a1.514 1.514 0 0 0 1.518-1.518V10.118h-8.6A1.522 1.522 0 0 1 14.165 8.6zm3.352 10.447c0 5.71-5.615 4.907-7.026 4.907v3.617a.761.761 0 0 1-.759.759H7.784a.761.761 0 0 1-.759-.759V14.937a.761.761 0 0 1 .759-.759h5.122a4.523 4.523 0 0 1 4.611 4.869z'/%3e%3c/svg%3e";

var ExcelIcon = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24.658' height='32.878'%3e%3cpath fill='%234caf50' d='M14.384 8.733V0H1.541A1.537 1.537 0 0 0 0 1.541v29.8a1.537 1.537 0 0 0 1.541 1.541h21.576a1.537 1.537 0 0 0 1.541-1.541V10.274h-8.733a1.546 1.546 0 0 1-1.541-1.541zm3.859 6.839-3.859 6 3.859 6a.772.772 0 0 1-.649 1.188h-2.24a.773.773 0 0 1-.681-.4c-1.259-2.325-2.344-4.412-2.344-4.412-.411.95-.642 1.284-2.35 4.418a.763.763 0 0 1-.674.4H7.064a.772.772 0 0 1-.649-1.188l3.872-6-3.872-6a.77.77 0 0 1 .649-1.188H9.3a.773.773 0 0 1 .681.4c1.676 3.134 1.284 2.158 2.35 4.4 0 0 .392-.751 2.35-4.4a.773.773 0 0 1 .681-.4h2.235a.766.766 0 0 1 .649 1.182zm6.415-7.744v.392h-8.219V0h.392a1.54 1.54 0 0 1 1.092.45l6.287 6.293a1.536 1.536 0 0 1 .448 1.085z'/%3e%3c/svg%3e";

var PdfIcon = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='28.787' height='38.382'%3e%3cpath d='M13.636 19.2c-.375-1.2-.367-3.516-.15-3.516.63-.001.57 2.765.15 3.516zm-.127 3.538a34.591 34.591 0 0 1-2.129 4.7A27.6 27.6 0 0 1 16.1 25.8a9.711 9.711 0 0 1-2.586-3.059zm-7.054 9.355c0 .06.99-.4 2.616-3.014-.502.472-2.182 1.837-2.616 3.014zm12.137-20.1h10.2v24.59a1.8 1.8 0 0 1-1.8 1.8H1.8a1.8 1.8 0 0 1-1.8-1.8V1.8A1.8 1.8 0 0 1 1.8 0h14.992v10.2a1.8 1.8 0 0 0 1.799 1.794zm-.6 12.879a7.524 7.524 0 0 1-3.2-4.033c.337-1.387.87-3.493.465-4.813a1.878 1.878 0 0 0-3.583-.51c-.375 1.372-.03 3.306.607 5.772a70.394 70.394 0 0 1-3.059 6.432c-.007 0-.007.007-.015.007-2.032 1.042-5.517 3.336-4.086 5.1a2.329 2.329 0 0 0 1.612.75c1.342 0 2.676-1.349 4.58-4.633a42.731 42.731 0 0 1 5.921-1.744 11.361 11.361 0 0 0 4.8 1.462 1.941 1.941 0 0 0 1.477-3.253c-1.044-1.015-4.073-.723-5.519-.536zm10.27-17L20.915.525A1.8 1.8 0 0 0 19.641 0h-.45v9.6h9.6v-.462a1.793 1.793 0 0 0-.529-1.267zM22.707 27.01c.307-.2-.187-.892-3.209-.675 2.782 1.185 3.209.675 3.209.675z' style='fill:%23ef4d5e'/%3e%3c/svg%3e";

var DocumentIcon = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24.862' height='33.15'%3e%3cpath fill='%23039be5' d='M14.5 8.805V0H1.554A1.55 1.55 0 0 0 0 1.554V31.6a1.55 1.55 0 0 0 1.554 1.55h21.754a1.55 1.55 0 0 0 1.554-1.55V10.359h-8.805A1.558 1.558 0 0 1 14.5 8.805zm3.7 7.769h1.547a.777.777 0 0 1 .758.952L18.045 28.4a.77.77 0 0 1-.758.6h-2.46a.776.776 0 0 1-.751-.589c-1.67-6.7-1.347-5.257-1.657-7.154h-.032c-.071.926-.155 1.127-1.657 7.154a.776.776 0 0 1-.751.589h-2.4a.776.776 0 0 1-.758-.609L4.37 17.52a.774.774 0 0 1 .758-.945h1.586a.776.776 0 0 1 .764.628c1.01 5.05 1.3 7.09 1.36 7.912.1-.66.473-2.117 1.9-7.944a.771.771 0 0 1 .758-.589h1.884a.776.776 0 0 1 .758.6c1.554 6.5 1.865 8.028 1.916 8.378-.013-.725-.168-1.152 1.4-8.365a.751.751 0 0 1 .746-.62zm6.662-8.682v.395h-8.287V0h.395a1.553 1.553 0 0 1 1.1.453L24.409 6.8a1.549 1.549 0 0 1 .453 1.092z'/%3e%3c/svg%3e";

var DefaultIcon = "data:image/svg+xml,%3csvg aria-hidden='true' data-prefix='fas' data-icon='file' class='svg-inline--fa fa-file fa-w-12 icon null' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'%3e%3cpath fill='currentColor' d='M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z'/%3e%3c/svg%3e";

function getFileType(url) {
  if (!url) {
    return null;
  }
  var idx = url.lastIndexOf('.');
  if (idx === -1) {
    return null;
  }
  var lurl = url.toLowerCase();
  var ext = lurl.slice(idx + 1);
  switch (ext) {
    case 'pdf':
      return 'pdf';
    case 'docx':
    case 'doc':
      return 'doc';
    case 'xlsx':
    case 'xls':
      return 'xls';
    case 'pptx':
    case 'ppt':
      return 'ppt';
    case 'png':
    case 'jpeg':
    case 'jpg':
    case 'gif':
    case 'img':
      return 'img';
  }

  // NOTE(intrnl): for handling future cases with multiple dot extensions
  // e.g. .tar.gz archives

  // idx = lurl.lastIndexOf('.', idx - 1)

  // if (idx === -1) {
  //   return null
  // }

  // ext = lurl.slice(idx + 1)

  return null;
}
function getFileIcon(type, url) {
  switch (type) {
    case 'pdf':
      return PdfIcon;
    case 'doc':
      return DocumentIcon;
    case 'xls':
      return ExcelIcon;
    case 'ppt':
      return PowerpointIcon;
    case 'img':
      return url || DefaultIcon;
    default:
      return DefaultIcon;
  }
}

var PrimitiveAttachmentItem = styled.div(["background-color:#eeeeee;display:grid;grid-template-columns:min-content minmax(0,1fr) min-content;grid-gap:8px;padding:8px;border-radius:4px;.icon{height:40px;width:40px;max-width:unset;object-fit:contain;}.filename .MuiOutlinedInput-root{background-color:#ffffff;}.remove{height:16px;width:16px;padding:14px;margin:-4px;}.progress{width:100%;margin:8px 0 7.2px;}.info{display:flex;align-items:center;justify-content:flex-end;font-size:14px;margin-top:8px;}.dot{background-color:#aaaaaa;height:4px;width:4px;margin:0 8px;border-radius:8px;}"]);
function AttachmentItem(props) {
  var className = props.className,
    style = props.style,
    name = props.name,
    _props$size = props.size,
    size = _props$size === void 0 ? 0 : _props$size,
    url = props.url,
    disabled = props.disabled,
    isUploading = props.isUploading,
    progress = props.progress,
    onNameChange = props.onNameChange,
    onRemove = props.onRemove,
    type = props.type;
  var progressValue = Math.floor(progress / size * 100);
  var fieldValue = isUploading ? "Uploading..." + (progress != null ? " (" + progressValue + "%)" : "") : name;
  return /*#__PURE__*/React.createElement(PrimitiveAttachmentItem, {
    className: className,
    style: style
  }, isUploading ? /*#__PURE__*/React.createElement(CircularProgress, null) : /*#__PURE__*/React.createElement("img", {
    src: getFileIcon(type || getFileType(url), url),
    className: "icon"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextField, {
    disabled: isUploading || disabled,
    value: fieldValue,
    onChange: isUploading ? null : onNameChange,
    variant: "outlined",
    size: "small",
    margin: "none",
    color: "secondary",
    fullWidth: true,
    className: "filename"
  }), isUploading ? /*#__PURE__*/React.createElement("div", {
    className: "info"
  }, /*#__PURE__*/React.createElement(LinearProgress, {
    value: progressValue,
    variant: progress != null ? 'determinate' : 'indeterminate',
    className: "progress"
  })) : /*#__PURE__*/React.createElement("div", {
    className: "info"
  }, /*#__PURE__*/React.createElement("span", null, (size / 1024 / 1024).toFixed(2), " MB"), /*#__PURE__*/React.createElement("div", {
    className: "dot"
  }), /*#__PURE__*/React.createElement(Link, {
    target: "_blank",
    href: url,
    color: "secondary"
  }, "Preview"))), /*#__PURE__*/React.createElement(IconButton, {
    disabled: isUploading || disabled,
    onClick: onRemove,
    className: "remove"
  }, /*#__PURE__*/React.createElement(CloseIcon, null)));
}

var PrimitiveAttachmentCard = styled(Card)(["user-select:none;background-color:#fff;font-size:14px;display:inline-grid;align-content:center;justify-items:center;text-align:center;line-height:normal;height:128px;width:128px;padding:8px;margin-bottom:8px;margin-right:8px;position:relative;box-sizing:border-box;.icon{object-fit:contain;height:40px;width:40px;margin-bottom:8px;}.label{word-break:break-all;}.overlay{background-color:rgba(0,0,0,0.35);transition:opacity 0.25s ease;display:flex;justify-content:center;align-items:center;opacity:0;position:absolute;inset:0;.MuiSvgIcon-root{color:#fff;}.MuiSvgIcon-root + .MuiSvgIcon-root{margin-right:8px;}}.overlay:hover,.overlay:focus-within{opacity:1;}"]);
function AttachmentCard(props) {
  var className = props.className,
    style = props.style,
    name = props.name,
    url = props.url,
    onRemove = props.onRemove,
    type = props.type;
  var icon = getFileIcon(type || getFileType(url), url);
  var trim = name.length > 24 ? name.slice(0, 24 - 1) + '…' : name;
  return /*#__PURE__*/React.createElement(PrimitiveAttachmentCard, {
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement("img", {
    src: icon,
    className: "icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "label"
  }, trim), /*#__PURE__*/React.createElement("div", {
    className: "overlay"
  }, onRemove != null && /*#__PURE__*/React.createElement(IconButton, {
    title: "Remove attachment",
    onClick: onRemove
  }, /*#__PURE__*/React.createElement(DeleteOutlinedIcon, null)), /*#__PURE__*/React.createElement(IconButton, {
    component: "a",
    target: "_blank",
    href: url,
    title: "View " + name
  }, /*#__PURE__*/React.createElement(VisibilityOutlinedIcon, null))));
}

var chunks = function chunks(array, size) {
  var result = [];
  var length = Math.ceil(array.length / size);
  for (var i = 0; i < length; i++) {
    result.push(array.slice(i * size, i * size + size));
  }
  return result;
};
var combine = function combine() {
  var str = '';
  for (var idx = 0, len = arguments.length; idx < len; idx++) {
    var val = idx < 0 || arguments.length <= idx ? undefined : arguments[idx];
    if (val) {
      str && (str += ' ');
      str += val;
    }
  }
  return str;
};

// Date
var parseOptionalDate = function parseOptionalDate(date, defaultValue) {
  if (date) {
    var parsed = new Date(date);
    if (!Number.isNaN(parsed)) {
      return parsed;
    }
  }
  return defaultValue;
};
var getValidatedMonths = function getValidatedMonths(range, minDate, maxDate) {
  var startDate = range.startDate,
    endDate = range.endDate;
  if (startDate && endDate) {
    var newStart = max([startDate, minDate]);
    var newEnd = min([endDate, maxDate]);
    return [newStart, isSameMonth(newStart, newEnd) ? addMonths(newStart, 1) : newEnd];
  }
  return [startDate, endDate];
};

var useStyles$j = makeStyles(function (theme) {
  return {
    start: {
      borderTopLeftRadius: '50%',
      borderBottomLeftRadius: '50%'
    },
    end: {
      borderTopRightRadius: '50%',
      borderBottomRightRadius: '50%'
    },
    buttonContainer: {
      display: 'flex'
    },
    button: {
      height: 36,
      width: 36,
      padding: 0
    },
    buttonText: {
      lineHeight: 1.6
    },
    outlined: {
      border: "1px solid " + theme.palette.primary.dark
    },
    filled: {
      backgroundColor: theme.palette.primary.dark,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark
      }
    },
    highlighted: {
      backgroundColor: theme.palette.action.focus,
      '& + &': {
        marginLeft: -4,
        paddingLeft: 4
      }
    },
    contrast: {
      color: theme.palette.primary.contrastText
    }
  };
});
var Day = function Day(props) {
  var disabled = props.disabled,
    highlighted = props.highlighted,
    outlined = props.outlined,
    filled = props.filled,
    start = props.start,
    end = props.end,
    onClick = props.onClick,
    onHover = props.onHover,
    value = props.value,
    style = props.style;
  var classes = useStyles$j();
  return /*#__PURE__*/React.createElement("div", {
    className: combine(classes.buttonContainer, !disabled && highlighted && classes.highlighted, start && classes.start, end && classes.end),
    style: style
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: combine(classes.button, !disabled && outlined && classes.outlined, !disabled && filled && classes.filled),
    color: "primary",
    disabled: disabled,
    onClick: onClick,
    onMouseOver: onHover
  }, /*#__PURE__*/React.createElement(Typography, {
    color: !disabled ? 'textPrimary' : 'textSecondary',
    className: combine(classes.buttonText, !disabled && filled && classes.contrast),
    variant: "body2"
  }, value)));
};

var useStyles$i = makeStyles(function () {
  return {
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '4px'
    },
    button: {
      height: 36,
      width: 36,
      padding: 8
    },
    label: {
      marginTop: 4
    }
  };
});
var Header$2 = function Header(props) {
  var date = props.date,
    locale = props.locale,
    nextDisabled = props.nextDisabled,
    prevDisabled = props.prevDisabled,
    onClickNext = props.onClickNext,
    onClickPrevious = props.onClickPrevious;
  var classes = useStyles$i();
  var label = React.useMemo(function () {
    return format(date, 'MMMM yyyy', {
      locale: locale
    });
  }, [locale, date]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement(IconButton, {
    disabled: prevDisabled,
    onClick: onClickPrevious,
    className: classes.button
  }, /*#__PURE__*/React.createElement(ChevronLeftIcon, null)), /*#__PURE__*/React.createElement(Typography, {
    color: "textSecondary",
    variant: "subtitle2",
    className: classes.label
  }, label), /*#__PURE__*/React.createElement(IconButton, {
    disabled: nextDisabled,
    onClick: onClickNext,
    className: classes.button
  }, /*#__PURE__*/React.createElement(ChevronRightIcon, null)));
};

var NavigationAction = {
  Previous: -1,
  Next: 1
};

var useStyles$h = makeStyles(function () {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(7, 1fr)',
      gridTemplateRows: 'repeat(1, 36px)',
      justifyItems: 'center',
      gap: '4px'
    },
    dayLabel: {
      lineHeight: '36px'
    }
  };
});
var Month = function Month(props) {
  var classes = useStyles$h();
  var helpers = props.helpers,
    handlers = props.handlers,
    date = props.value,
    locale = props.locale,
    marker = props.marker,
    minDate = props.minDate,
    maxDate = props.maxDate;
  var _props$navState = props.navState,
    back = _props$navState[0],
    forward = _props$navState[1];
  var weekDays = React.useMemo(function () {
    var date = startOfWeek(new Date(), {
      locale: locale
    });
    var labels = [];
    for (var i = 0; i < 7; i++) {
      date.setDate(date.getDate() + (i > 0 ? 1 : 0));
      labels.push(format(date, 'eeeeee', {
        locale: locale
      }));
    }
    return labels;
  }, [locale]);
  var weeks = React.useMemo(function () {
    var startWeek = startOfWeek(startOfMonth(date), {
      locale: locale
    });
    var endMonth = endOfMonth(date);
    var arr = [];
    for (var curr = startWeek; isBefore(curr, endMonth);) {
      arr.push(curr);
      curr = addDays(curr, 1);
    }
    var chunked = chunks(arr, 7);
    while (chunked.length < 6) chunked.push([]);
    return chunked;
  }, [locale, date]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Header$2, {
    date: date,
    locale: locale,
    nextDisabled: !forward,
    prevDisabled: !back,
    onClickPrevious: function onClickPrevious() {
      return handlers.onMonthNavigate(marker, NavigationAction.Previous);
    },
    onClickNext: function onClickNext() {
      return handlers.onMonthNavigate(marker, NavigationAction.Next);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.grid
  }, weekDays.map(function (day) {
    return /*#__PURE__*/React.createElement(Typography, {
      color: "textSecondary",
      key: day,
      variant: "caption",
      className: classes.dayLabel
    }, day);
  })), weeks.map(function (week, idx) {
    var end = week.length - 1;
    var offset = 1;
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: classes.grid
    }, week.map(function (day, idx) {
      if (!isSameMonth(date, day)) {
        offset++;
        return null;
      }
      var isStart = helpers.isStartDay(day, false);
      var isEnd = helpers.isEndDay(day, false);
      var highlighted = helpers.inHighlight(day);
      var startPos = offset;
      var isRoundedStart = startPos > 1 || idx === 0;
      var isRoundedEnd = idx === end;
      offset = 0;
      return /*#__PURE__*/React.createElement(Day, {
        key: idx,
        filled: isStart || isEnd,
        outlined: isToday(day),
        highlighted: highlighted,
        disabled: minDate != null && day >= minDate && maxDate != null && day <= maxDate,
        start: isRoundedStart || helpers.isStartDay(day, true),
        end: isRoundedEnd || helpers.isEndDay(day, true),
        onClick: function onClick() {
          return handlers.onDayClick(day);
        },
        onHover: function onHover() {
          return handlers.onDayHover(day);
        },
        value: getDate(day),
        style: startPos > 1 ? {
          gridColumnStart: startPos
        } : null
      });
    }));
  }));
};

var useStyles$g = makeStyles(function () {
  return {
    root: {
      display: 'flex',
      gap: '16px'
    }
  };
});
var MARKERS = {
  FIRST_MONTH: Symbol('firstMonth'),
  SECOND_MONTH: Symbol('secondMonth')
};
var DateRangePicker = function DateRangePicker(props) {
  var initialDateRange = props.initialDateRange,
    minDate = props.minDate,
    maxDate = props.maxDate,
    locale = props.locale,
    onChange = props.onChange;
  var classes = useStyles$g();
  var today = React.useMemo(function () {
    return new Date();
  }, []);
  var minDateValid = parseOptionalDate(minDate, addYears(today, -10));
  var maxDateValid = parseOptionalDate(maxDate, addYears(today, 10));
  var _getValidatedMonths = getValidatedMonths(initialDateRange || {}, minDateValid, maxDateValid),
    intialFirstMonth = _getValidatedMonths[0],
    initialSecondMonth = _getValidatedMonths[1];
  var _React$useState = React.useState(_extends({}, initialDateRange)),
    dateRange = _React$useState[0],
    setDateRange = _React$useState[1];
  var _React$useState2 = React.useState(),
    hoverDay = _React$useState2[0],
    setHoverDay = _React$useState2[1];
  var _React$useState3 = React.useState(intialFirstMonth || today),
    firstMonth = _React$useState3[0],
    setFirstMonth = _React$useState3[1];
  var _React$useState4 = React.useState(initialSecondMonth || addMonths(firstMonth, 1)),
    secondMonth = _React$useState4[0],
    setSecondMonth = _React$useState4[1];
  var startDate = dateRange.startDate,
    endDate = dateRange.endDate;

  // handlers
  var setFirstMonthValidated = function setFirstMonthValidated(date) {
    if (isBefore(date, secondMonth)) {
      setFirstMonth(date);
    }
  };
  var setSecondMonthValidated = function setSecondMonthValidated(date) {
    if (isAfter(date, firstMonth)) {
      setSecondMonth(date);
    }
  };
  var onDayClick = function onDayClick(day) {
    if (startDate && !endDate) {
      var newRange = day < startDate ? {
        startDate: day,
        endDate: startDate
      } : {
        startDate: startDate,
        endDate: day
      };
      newRange.endDate.setHours(23, 59, 59, 999);
      if (onChange) {
        onChange(newRange);
      }
      setDateRange(newRange);
    } else {
      var _newRange = {
        startDate: day,
        endDate: undefined
      };
      if (onChange) {
        onChange(_newRange);
      }
      setDateRange(_newRange);
    }
    setHoverDay(undefined);
  };
  var onMonthNavigate = function onMonthNavigate(marker, action) {
    if (marker === MARKERS.FIRST_MONTH) {
      var firstNew = addMonths(firstMonth, action);
      if (isBefore(firstNew, secondMonth)) {
        setFirstMonth(firstNew);
      }
    } else {
      var secondNew = addMonths(secondMonth, action);
      if (isBefore(firstMonth, secondNew)) {
        setSecondMonth(secondNew);
      }
    }
  };
  var onDayHover = function onDayHover(date) {
    if (startDate && !endDate) {
      if (!hoverDay || !isSameDay(date, hoverDay)) {
        setHoverDay(date);
      }
    }
  };

  // helpers
  var inHighlight = function inHighlight(date) {
    if (!startDate) {
      return false;
    }
    if (endDate) {
      return date >= startDate && date <= endDate;
    }
    if (!hoverDay) {
      return false;
    }
    return date >= startDate && date <= hoverDay || date >= hoverDay && date <= startDate;
  };
  var isStartDay = function isStartDay(date, includeHover) {
    if (includeHover && hoverDay && hoverDay < startDate) {
      return isSameDay(hoverDay, date);
    }
    return startDate && isSameDay(startDate, date);
  };
  var isEndDay = function isEndDay(date, includeHover) {
    if (includeHover && hoverDay) {
      return isSameDay(hoverDay >= startDate ? hoverDay : startDate, date);
    }
    return endDate && isSameDay(endDate, date);
  };
  var helpers = {
    inHighlight: inHighlight,
    isStartDay: isStartDay,
    isEndDay: isEndDay
  };
  var handlers = {
    onDayClick: onDayClick,
    onDayHover: onDayHover,
    onMonthNavigate: onMonthNavigate
  };
  var canNavigateCloser = differenceInCalendarMonths(secondMonth, firstMonth) >= 2;
  var commonProps = {
    locale: locale,
    minDate: minDate,
    maxDate: maxDate,
    helpers: helpers,
    handlers: handlers
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Month, _extends({}, commonProps, {
    value: firstMonth,
    setValue: setFirstMonthValidated,
    navState: [true, canNavigateCloser],
    marker: MARKERS.FIRST_MONTH
  })), /*#__PURE__*/React.createElement(Divider, {
    flexItem: true,
    orientation: "vertical"
  }), /*#__PURE__*/React.createElement(Month, _extends({}, commonProps, {
    value: secondMonth,
    setValue: setSecondMonthValidated,
    navState: [canNavigateCloser, true],
    marker: MARKERS.SECOND_MONTH
  })));
};

var ListFilterWrapper = styled.div(["display:flex;flex-direction:column;justify-content:space-between;width:270px;box-shadow:0 3px 6px 0 rgba(0,0,0,0.16);z-index:1;.list-item{display:flex;flex-direction:column;padding:10px 0px;min-height:180px;max-height:", ";overflow:auto;::-webkit-scrollbar{width:4px;}::-webkit-scrollbar-thumb{background:rgba(0,0,0,0.16);border-radius:5px;}}.footer{display:flex;flex-direction:row;align-items:center;justify-content:space-between;border-top:solid 1px #eff2f4;padding:11px 14px;position:sticky;bottom:0;.btn{line-height:18px;font-size:12px;cursor:pointer;user-select:none;border:none;}.reset-all{color:#000;}.action{display:flex;flex-direction:row;align-items:center;.cancel{color:#a9a8a8;margin-right:15px;}.apply{color:#039be5;}}}"], function (props) {
  return props.maxHeight;
});
var ItemFilterWrapper = styled.div(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;background-color:", ";font-size:12px;padding:0px 14px;cursor:pointer;user-select:none;min-height:30px;.name{color:", ";padding:0px;margin:0px;}.count{display:", ";border-radius:24px;background-color:", ";color:", ";padding:2px 7px;}"], function (props) {
  return props.active ? '#014a62' : '#fff';
}, function (props) {
  return props.active ? '#fff' : '#000';
}, function (props) {
  return props.count === 0 || !props.count ? 'none' : 'flex';
}, function (props) {
  return !props.active && props.count && props.count !== 0 ? '#014a62' : '#fff';
}, function (props) {
  return props.active ? '#014a62' : '#fff';
});
var LabelTab = styled.div(["display:flex;.count{display:", ";border-radius:24px;background-color:", ";color:#fff;padding:0px 10px;margin-left:10px;text-align:center;align-items:center;font-size:10px;}"], function (props) {
  return props.count === 0 || !props.count ? 'none' : 'flex';
}, function (props) {
  return !props.active && props.count && props.count !== 0 ? '#014a62' : '#fff';
});
var TypeFilterWrapper = styled.div(["display:flex;flex-direction:column;justify-content:space-between;width:274px;background-color:#f7f8f9;padding:10px 0px;max-height:25em;overflow:auto;"]);
var CheckboxTypeWrapper = styled.div(["display:flex;flex-direction:column;.action{display:flex;flex-direction:row;justify-content:space-between;padding:0px 17px;margin-bottom:8px;.btn{cursor:pointer;user-select:none;}.select-all{color:#000;font-size:12px;font-weight:600;}.reset{color:#a9a8a8;font-size:12px;}}.list-checkbox{display:flex;flex-direction:column;overflow-y:scroll;::-webkit-scrollbar{width:4px;}::-webkit-scrollbar-thumb{background:rgba(0,0,0,0.16);border-radius:5px;}.empty-list{display:flex;align-items:center;justify-content:center;padding:34px;font-size:12px;}}.more-text{color:#a9a8a8;font-size:12px;padding:4px 12px 6px;font-style:italic;}.divider{border-top:1px solid #e5e5e5;margin:8px 14px 14px;}"]);
var DateTypeWrapper = styled.div(["display:flex;flex-direction:column;.action{display:flex;flex-direction:row;justify-content:space-between;padding:0px 17px;margin-bottom:8px;.btn{cursor:pointer;}.select-all{color:#000;font-size:12px;font-weight:600;}.reset{color:#a9a8a8;font-size:12px;}}.label{font-size:12px;margin:9px 17px 6px 17px;}"]);
var AgeTypeWrapper = styled.div(["display:flex;flex-direction:column;.action{display:flex;flex-direction:row;justify-content:space-between;padding:0px 17px;margin-bottom:12px;.btn{cursor:pointer;}.select-all{color:#000;font-size:12px;font-weight:600;}.reset{color:#a9a8a8;font-size:12px;}}.content{padding:0px 17px;.text-field{display:flex;flex-direction:row;justify-content:space-between;align-items:center;color:#a9a8a8;.strip{margin-top:12px;}.input{width:43%;.wrapper-input{display:flex;align-items:center;justify-content:space-between;}}}}.label{font-size:12px;margin:9px 17px 6px 17px;}"]);
var KeyboardDatePickerStyled = styled(KeyboardDatePicker)(["& > div{padding-right:", ";}"], function (props) {
  return props.space;
});

var word$4 = {
  include: {
    english: 'Include',
    indonesian: 'Masukan'
  },
  exclude: {
    english: 'Exclude',
    indonesian: 'Kecualikan'
  },
  placeholderSearch: {
    english: 'Search',
    indonesian: 'Cari'
  },
  emptyState: {
    english: 'No Selected',
    indonesian: 'Tidak Dipilih'
  },
  hiddenItems: {
    english: 'and [count] hidden items',
    indonesian: 'dan [count] item tersembunyi'
  },
  labelCancelButton: {
    english: 'Cancel',
    indonesian: 'Batalkan'
  },
  labelApplyButton: {
    english: 'Apply',
    indonesian: 'Terapkan'
  },
  labelSelectAll: {
    english: 'Select All',
    indonesian: 'Pilih Semua'
  },
  labelReset: {
    english: 'Reset',
    indonesian: 'Atur Ulang'
  },
  labelResetAll: {
    english: 'Reset All',
    indonesian: 'Atur Ulang Semua'
  },
  pickADate: {
    english: 'Pick a Date',
    indonesian: 'Pilih Tanggal'
  },
  from: {
    english: 'From',
    indonesian: 'Dari'
  },
  to: {
    english: 'To',
    indonesian: 'Sampai'
  },
  chooseDate: {
    english: 'Choose Date',
    indonesian: 'Pilih Tanggal '
  }
};

var formatatSalary = function formatatSalary(salary) {
  if (salary && !Number.isInteger(salary) && salary !== '') {
    // eslint-disable-next-line camelcase
    var number_string = salary.replace(/[^,\d]/g, '').toString();
    var split = number_string.split(',');
    var sisa = split[0].length % 3;
    var rupiah = split[0].substr(0, sisa);
    var ribuan = split[0].substr(sisa).match(/\d{3}/gi);
    if (ribuan) {
      var separator = sisa ? '.' : '';
      rupiah += separator + ribuan.join('.');
    }
    rupiah = split[1] !== undefined ? rupiah + ',' + split[1] : rupiah;
    return rupiah;
  } else {
    return salary;
  }
};
var changeToNumber = function changeToNumber(number) {
  if (number && !Number.isInteger(number)) {
    return parseInt(number.split('.').join(''));
  } else {
    return number;
  }
};
var updateNinVariables = function updateNinVariables(array, item, checked) {
  if (array === void 0) {
    array = [];
  }
  if (checked) {
    return [].concat(array, [item.value]);
  } else {
    return array.filter(function (entry) {
      return entry !== item.value;
    });
  }
};
var updateFilterVariables = function updateFilterVariables(array, item, checked) {
  if (array === void 0) {
    array = [];
  }
  if (checked) {
    return [].concat(array, [item]);
  } else {
    return array.filter(function (entry) {
      return entry.value !== item.value;
    });
  }
};
var getTotalCountChecked = function getTotalCountChecked(checkboxFilter, filterData) {
  if (checkboxFilter === void 0) {
    checkboxFilter = [];
  }
  if (filterData === void 0) {
    filterData = {};
  }
  var countInclude = 0;
  var countExclude = 0;
  checkboxFilter.map(function (res) {
    countInclude = countInclude + (filterData[0] && filterData[0][res.fieldName] && filterData[0][res.fieldName].length || 0);
    countExclude = countExclude + (filterData[1] && filterData[1][res.fieldName] && filterData[1][res.fieldName].length || 0);
  });
  return [countInclude, countExclude];
};

var _excluded$1 = ["name", "count", "active"];
var ItemFilter = function ItemFilter(_ref) {
  var name = _ref.name,
    count = _ref.count,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    child = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  return /*#__PURE__*/React.createElement(ItemFilterWrapper, _extends({}, child, {
    active: active,
    count: count
  }), /*#__PURE__*/React.createElement("span", {
    className: "name"
  }, name), /*#__PURE__*/React.createElement("span", {
    className: "count"
  }, count));
};
function a11yProps(index, tabClass, id) {
  return {
    id: "filter-tab-" + id + "-" + index,
    'aria-controls': "filter-tabpanel-" + id + "-" + index,
    classes: tabClass
  };
}
var useStyles$f = makeStyles({
  tabRoot: {
    minWidth: '50%'
  },
  tabsRoot: {
    backgroundColor: '#f7f8f9',
    position: 'sticky',
    top: 0
  },
  indicator: {
    width: '135px !important',
    backgroundColor: '#039be5',
    height: 4
  }
});
var ListFilter = function ListFilter(_ref2) {
  var includeExclude = _ref2.includeExclude,
    listFilter = _ref2.listFilter,
    setActiveFilter = _ref2.setActiveFilter,
    activeFilter = _ref2.activeFilter,
    filterData = _ref2.filterData,
    language = _ref2.language,
    maxHeight = _ref2.maxHeight,
    onResetAll = _ref2.onResetAll,
    onCancel = _ref2.onCancel,
    onApply = _ref2.onApply,
    setBridge = _ref2.setBridge,
    bridge = _ref2.bridge,
    id = _ref2.id;
  var classes = useStyles$f();
  var checkboxFilter = listFilter.filter(function (res) {
    return res.type === 'checkbox';
  });
  var _getTotalCountChecked = getTotalCountChecked(checkboxFilter, filterData),
    totalInclude = _getTotalCountChecked[0],
    totoalExclude = _getTotalCountChecked[1];
  var handleChange = function handleChange(e, newValue) {
    e.preventDefault();
    setBridge(newValue);
  };
  return /*#__PURE__*/React.createElement(ListFilterWrapper, {
    maxHeight: maxHeight
  }, /*#__PURE__*/React.createElement("div", null, includeExclude && /*#__PURE__*/React.createElement(Tabs, {
    classes: {
      root: classes.tabsRoot,
      indicator: classes.indicator
    },
    value: bridge,
    onChange: handleChange
  }, /*#__PURE__*/React.createElement(Tab, _extends({
    label: /*#__PURE__*/React.createElement(LabelTab, {
      count: totalInclude
    }, word$4.include[language], " ", /*#__PURE__*/React.createElement("span", {
      className: "count"
    }, totalInclude))
  }, a11yProps(0, {
    root: classes.tabRoot
  }, id))), /*#__PURE__*/React.createElement(Tab, _extends({
    label: /*#__PURE__*/React.createElement(LabelTab, {
      count: totoalExclude
    }, word$4.exclude[language], " ", /*#__PURE__*/React.createElement("span", {
      className: "count"
    }, totoalExclude))
  }, a11yProps(1, {
    root: classes.tabRoot
  }, id)))), /*#__PURE__*/React.createElement("div", {
    className: "list-item"
  }, listFilter.map(function (list, i) {
    var length = filterData && filterData[bridge] && filterData[bridge][list.fieldName] && filterData[bridge][list.fieldName].length || 0;
    return /*#__PURE__*/React.createElement(ItemFilter, {
      active: list.fieldName === activeFilter.fieldName,
      onClick: function onClick() {
        return setActiveFilter(list);
      },
      key: i + "-" + list.fieldName,
      name: list.name,
      count: (length > 99 ? '99+' : length) || 0
    });
  }))), /*#__PURE__*/React.createElement("div", {
    className: "footer"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: onResetAll,
    className: "btn reset-all"
  }, word$4.labelResetAll[language]), /*#__PURE__*/React.createElement("div", {
    className: "action"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: onCancel,
    className: "btn cancel"
  }, word$4.labelCancelButton[language]), /*#__PURE__*/React.createElement("span", {
    onClick: onApply,
    className: "btn apply"
  }, word$4.labelApplyButton[language]))));
};

var useStyles$e = makeStyles({
  rootSlider: {
    paddingTop: 21
  },
  rail: {
    color: '#e5e5e5',
    height: 3
  },
  track: {
    color: '#039be5',
    height: 3
  },
  thumb: {
    color: '#039be5'
  }
});
var SliderFilter = function SliderFilter(_ref) {
  var min = _ref.min,
    max = _ref.max,
    value = _ref.value,
    onChange = _ref.onChange;
  var classes = useStyles$e();
  return /*#__PURE__*/React.createElement(Slider, {
    classes: {
      root: classes.rootSlider,
      rail: classes.rail,
      track: classes.track,
      thumb: classes.thumb
    },
    min: min,
    max: max,
    value: value,
    onChange: onChange,
    "aria-labelledby": "range-slider"
  });
};

var useStyles$d = makeStyles({
  wrapperSlider: {
    padding: '0px 17px'
  },
  root: {
    fontSize: 12
  },
  rootInput: {
    fontSize: 12,
    height: 30,
    width: 63,
    padding: '8px 7px',
    backgroundColor: '#fff',
    textAlign: 'right'
  },
  input: {
    padding: '18.5px 2px',
    textAlign: 'right'
  }
});
var TextFieldAge = function TextFieldAge(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    label = _ref.label;
  var classes = useStyles$d();
  return /*#__PURE__*/React.createElement("div", {
    className: "input"
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      color: '#a9a8a8',
      fontSize: 12,
      margin: 0,
      marginBottom: 4
    }
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "wrapper-input"
  }, /*#__PURE__*/React.createElement(TextField, {
    type: "number",
    value: value,
    variant: "outlined",
    onChange: onChange,
    classes: {
      root: classes.root
    },
    InputProps: {
      type: 'number',
      classes: {
        root: classes.rootInput,
        input: classes.input
      }
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      color: '#a9a8a8',
      fontSize: 12,
      margin: 0
    }
  }, "Years")));
};
function AgeType(_ref2) {
  var activeFilter = _ref2.activeFilter,
    setFilterData = _ref2.setFilterData,
    filterData = _ref2.filterData,
    bridge = _ref2.bridge;
  var handleChange = function handleChange(event, newValue) {
    event.preventDefault();
    setFilterData(function (e) {
      var _extends2, _extends3;
      return _extends({}, e, (_extends3 = {}, _extends3[bridge] = _extends({}, e[bridge], (_extends2 = {}, _extends2[activeFilter.fieldName] = {
        min: newValue[0],
        max: newValue[1]
      }, _extends2)), _extends3));
    });
  };
  var setter = function setter(idx, value) {
    setFilterData(function (e) {
      var _extends4, _extends5, _extends6;
      return _extends({}, e, (_extends6 = {}, _extends6[bridge] = _extends({}, e[bridge], (_extends5 = {}, _extends5[activeFilter.fieldName] = _extends({}, e[bridge][activeFilter.fieldName], (_extends4 = {}, _extends4[idx] = value, _extends4)), _extends5)), _extends6));
    });
  };
  var handleReset = function handleReset() {
    setFilterData(function (e) {
      var _extends7, _extends8;
      return _extends({}, e, (_extends8 = {}, _extends8[bridge] = _extends({}, e[bridge], (_extends7 = {}, _extends7[activeFilter.fieldName] = {}, _extends7)), _extends8));
    });
  };
  return /*#__PURE__*/React.createElement(AgeTypeWrapper, null, /*#__PURE__*/React.createElement("div", {
    className: "action"
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn select-all"
  }, "Select a range"), /*#__PURE__*/React.createElement("span", {
    onClick: handleReset,
    className: "btn reset"
  }, "Reset")), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-field"
  }, /*#__PURE__*/React.createElement(TextFieldAge, {
    label: "Min",
    value: filterData && filterData[bridge] && filterData[bridge][activeFilter.fieldName] && filterData[bridge][activeFilter.fieldName].min || false,
    onChange: function onChange(e) {
      var value = e.target.value === '' ? '' : Number(e.target.value);
      setter('min', value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "strip"
  }, "-"), /*#__PURE__*/React.createElement(TextFieldAge, {
    label: "Max",
    value: filterData && filterData[bridge] && filterData[bridge][activeFilter.fieldName] && filterData[bridge][activeFilter.fieldName].max || false,
    onChange: function onChange(e) {
      var value = e.target.value === '' ? '' : Number(e.target.value);
      setter('max', value);
    }
  })), /*#__PURE__*/React.createElement(SliderFilter, {
    min: activeFilter.min,
    max: activeFilter.max,
    value: [filterData && filterData[bridge] && filterData[bridge][activeFilter.fieldName] && filterData[bridge][activeFilter.fieldName].min || 0, filterData && filterData[bridge] && filterData[bridge][activeFilter.fieldName] && filterData[bridge][activeFilter.fieldName].max || 0],
    onChange: handleChange
  })));
}

function LoadingComponent() {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 0px'
    }
  }, /*#__PURE__*/React.createElement(CircularProgress, null));
}

var useDebounced = function useDebounced(value, wait, options) {
  if (options === void 0) {
    options = {
      leading: false
    };
  }
  var _useState = useState(value),
    _value = _useState[0],
    setValue = _useState[1];
  var mountedRef = useRef(false);
  var timeoutRef = useRef(null);
  var cooldownRef = useRef(false);
  var cancel = function cancel() {
    return window.clearTimeout(timeoutRef.current);
  };
  useEffect(function () {
    if (mountedRef.current) {
      if (!cooldownRef.current && options.leading) {
        cooldownRef.current = true;
        setValue(value);
      } else {
        cancel();
        timeoutRef.current = window.setTimeout(function () {
          cooldownRef.current = false;
          setValue(value);
        }, wait);
      }
    }
  }, [value, options.leading, wait]);
  useEffect(function () {
    mountedRef.current = true;
    return cancel;
  }, []);
  return [_value, cancel];
};

var useStyles$c = makeStyles({
  root: {
    fontSize: 12,
    padding: '0px 14px 14px 14px'
  },
  rootInput: {
    fontSize: 12,
    height: 35,
    padding: '8px 7px',
    backgroundColor: '#fff'
  },
  rootCheckbox: {
    display: 'flex',
    margin: 0,
    padding: '0px 12px 7px 12px',
    alignItems: 'flex-start',
    '& .MuiTypography-body1': {
      paddingTop: 3
    }
  },
  labelCheckbox: {
    fontSize: 12
  },
  checkboxRoot: {
    padding: 0,
    marginRight: 8,
    alignSelf: 'center'
  },
  profileContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  labelContainer: {
    display: 'flex',
    justifyContent: 'row',
    alignItems: 'center'
  },
  avatar: {
    alignSelf: 'center',
    height: 32,
    width: 32
  },
  paddingProfile: {
    marginLeft: 8
  },
  textName: {
    marginBottom: 4,
    color: '#333333',
    fontWeight: 400,
    fontSize: 12,
    padding: '0px !important'
  },
  textTitle: {
    color: '#A9A8A8',
    fontWeight: 400,
    fontSize: 12,
    padding: '0px !important'
  },
  labelStyle: {
    width: 24,
    height: 24,
    borderRadius: 5,
    marginRight: 12
  },
  textLabel: {
    fontSize: 12,
    maxWidth: '80%'
  }
});
var Profile = function Profile(dataLabel) {
  var classes = useStyles$c();
  var name = dataLabel.name,
    title = dataLabel.title,
    avatar = dataLabel.avatar;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.profileContainer
  }, /*#__PURE__*/React.createElement(Avatar, {
    src: avatar,
    alt: name,
    className: classes.avatar
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.paddingProfile
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.textName
  }, name != null ? name : '-'), /*#__PURE__*/React.createElement(Typography, {
    className: classes.textTitle
  }, title != null ? title : '-')));
};
var Label = function Label(dataLabel) {
  var classes = useStyles$c();
  var color = dataLabel.color,
    name = dataLabel.name;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.labelContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.labelStyle,
    style: {
      backgroundColor: color
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    gutterBottom: true,
    className: classes.textLabel
  }, name));
};
var renderLabelType = function renderLabelType(type, label) {
  if (type === 'placement') {
    return /*#__PURE__*/React.createElement(Profile, label);
  } else if (type === 'label') {
    return /*#__PURE__*/React.createElement(Label, label);
  } else {
    return label;
  }
};
var CheckboxItem$1 = function CheckboxItem(_ref) {
  var label = _ref.label,
    name = _ref.name,
    onChange = _ref.onChange,
    checked = _ref.checked,
    value = _ref.value,
    checkboxType = _ref.checkboxType;
  var classes = useStyles$c();
  return /*#__PURE__*/React.createElement(FormControlLabel, {
    classes: {
      root: classes.rootCheckbox,
      label: classes.labelCheckbox
    },
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: checked,
      color: "primary",
      classes: {
        root: classes.checkboxRoot
      },
      onChange: onChange,
      value: value,
      name: name
    }),
    label: renderLabelType(checkboxType, label)
  });
};
function CheckboxList(props) {
  var activeFilter = props.activeFilter;
  var _activeFilter$options = activeFilter.options,
    fetch = _activeFilter$options.fetch,
    list = _activeFilter$options.list,
    checkboxType = _activeFilter$options.checkboxType;
  return fetch ? /*#__PURE__*/React.createElement(RemoteCheckboxList, _extends({}, props, {
    key: activeFilter,
    config: fetch,
    checkboxType: checkboxType
  })) : /*#__PURE__*/React.createElement(LocalCheckboxList, _extends({}, props, {
    key: activeFilter,
    config: list,
    checkboxType: checkboxType
  }));
}
function LocalCheckboxList(props) {
  var _filterData$bridge;
  var config = props.config,
    language = props.language,
    checkboxType = props.checkboxType,
    activeFilter = props.activeFilter,
    bridge = props.bridge,
    filterData = props.filterData,
    setFilterData = props.setFilterData,
    globalNin = props.globalNin,
    setGlobalNin = props.setGlobalNin;
  var _useState = useState(''),
    search = _useState[0],
    setSearch = _useState[1];
  var fieldName = activeFilter.fieldName,
    emptyState = activeFilter.emptyState;
  var nin = useMemo(function () {
    return new Set(globalNin[fieldName]);
  }, [globalNin]);
  var shown = useMemo(function () {
    var trimmed = search.trim();
    return config.filter(function (opt) {
      if (nin.has(opt.value)) {
        return false;
      }
      if (checkboxType === 'placement') {
        return opt.label.name.toLowerCase().includes(trimmed) || opt.label.title.toLowerCase().includes(trimmed);
      }
      return opt.label.toString().toLowerCase().includes(trimmed);
    });
  }, [search, nin, config]);
  var selected = ((_filterData$bridge = filterData[bridge]) == null ? void 0 : _filterData$bridge[fieldName]) || [];
  var threshold = Number.POSITIVE_INFINITY;
  var handleSearchInput = function handleSearchInput(event) {
    setSearch(event.target.value);
  };
  var handleCheckboxChange = function handleCheckboxChange(item, checked) {
    setGlobalNin(function (prev) {
      var _extends2;
      return _extends({}, prev, (_extends2 = {}, _extends2[fieldName] = updateNinVariables(prev[fieldName], item, checked), _extends2));
    });
    setFilterData(function (prev) {
      var _prev$bridge, _extends3, _extends4;
      return _extends({}, prev, (_extends4 = {}, _extends4[bridge] = _extends({}, prev[bridge], (_extends3 = {}, _extends3[fieldName] = updateFilterVariables((_prev$bridge = prev[bridge]) == null ? void 0 : _prev$bridge[fieldName], item, checked), _extends3)), _extends4));
    });
  };
  var handleSelectAll = function handleSelectAll() {
    setGlobalNin(function (prev) {
      var _extends5;
      return _extends({}, prev, (_extends5 = {}, _extends5[fieldName] = config.map(function (item) {
        return item.value;
      }), _extends5));
    });
    setFilterData(function (prev) {
      var _extends6, _extends7;
      return _extends({}, prev, (_extends7 = {}, _extends7[bridge] = _extends({}, prev[bridge], (_extends6 = {}, _extends6[fieldName] = config, _extends6)), _extends7));
    });
  };
  var handleReset = function handleReset() {
    var _filterData$bridge2, _filterData$bridge2$f;
    var current = new Set((_filterData$bridge2 = filterData[bridge]) == null ? void 0 : (_filterData$bridge2$f = _filterData$bridge2[fieldName]) == null ? void 0 : _filterData$bridge2$f.map(function (item) {
      return item.value;
    }));
    setGlobalNin(function (prev) {
      var _extends8;
      return _extends({}, prev, (_extends8 = {}, _extends8[fieldName] = (prev[fieldName] || []).filter(function (value) {
        return !current.has(value);
      }), _extends8));
    });
    setFilterData(function (prev) {
      var _extends9, _extends10;
      return _extends({}, prev, (_extends10 = {}, _extends10[bridge] = _extends({}, prev[bridge], (_extends9 = {}, _extends9[fieldName] = [], _extends9)), _extends10));
    });
  };
  return /*#__PURE__*/React.createElement(CheckboxView, {
    data: shown,
    language: language,
    totalCount: config.length,
    selected: selected,
    threshold: threshold,
    emptyState: emptyState,
    search: search,
    onChange: handleCheckboxChange,
    onSearchInput: handleSearchInput,
    onSelectAll: handleSelectAll,
    onReset: handleReset,
    checkboxType: checkboxType
  });
}
var EMPTY_ARRAY$2 = [];
function RemoteCheckboxList(props) {
  var _filterData$bridge3;
  var config = props.config,
    checkboxType = props.checkboxType,
    language = props.language,
    activeFilter = props.activeFilter,
    bridge = props.bridge,
    filterData = props.filterData,
    setFilterData = props.setFilterData,
    globalNin = props.globalNin,
    setGlobalNin = props.setGlobalNin,
    limit = props.limit;
  var _useState2 = useState(''),
    search = _useState2[0],
    setSearch = _useState2[1];
  var _useDebouncedValue = useDebounced(search, 500),
    debouncedSearch = _useDebouncedValue[0];
  var fieldName = activeFilter.fieldName,
    emptyState = activeFilter.emptyState;
  var _useQuery = useQuery(config.query, _extends({}, config.options, {
      wlb_skipPatch: true,
      variables: config.getVariables({
        search: debouncedSearch ? "%" + debouncedSearch + "%" : undefined,
        limit: limit,
        _nin: globalNin[fieldName] || EMPTY_ARRAY$2
      })
    })),
    data = _useQuery.data,
    loading = _useQuery.loading;
  var _useMemo = useMemo(function () {
      return data && config.setData(data) || [];
    }, [data]),
    _useMemo$ = _useMemo[0],
    map = _useMemo$ === void 0 ? [] : _useMemo$,
    _useMemo$2 = _useMemo[1],
    totalCount = _useMemo$2 === void 0 ? 0 : _useMemo$2;
  var selected = ((_filterData$bridge3 = filterData[bridge]) == null ? void 0 : _filterData$bridge3[fieldName]) || [];
  var handleCheckboxChange = function handleCheckboxChange(item, checked) {
    setGlobalNin(function (prev) {
      var _extends11;
      return _extends({}, prev, (_extends11 = {}, _extends11[fieldName] = updateNinVariables(prev[fieldName], item, checked), _extends11));
    });
    setFilterData(function (prev) {
      var _prev$bridge2, _extends12, _extends13;
      return _extends({}, prev, (_extends13 = {}, _extends13[bridge] = _extends({}, prev[bridge], (_extends12 = {}, _extends12[fieldName] = updateFilterVariables((_prev$bridge2 = prev[bridge]) == null ? void 0 : _prev$bridge2[fieldName], item, checked), _extends12)), _extends13));
    });
  };
  var handleSearchInput = function handleSearchInput(event) {
    setSearch(event.target.value);
  };
  var handleSelectAll = function handleSelectAll() {
    setGlobalNin(function (prev) {
      var _extends14;
      return _extends({}, prev, (_extends14 = {}, _extends14[fieldName] = [].concat(prev[fieldName] || [], map.map(function (item) {
        return item.value;
      })), _extends14));
    });
    setFilterData(function (prev) {
      var _prev$bridge3, _extends15, _extends16;
      return _extends({}, prev, (_extends16 = {}, _extends16[bridge] = _extends({}, prev[bridge], (_extends15 = {}, _extends15[fieldName] = [].concat(((_prev$bridge3 = prev[bridge]) == null ? void 0 : _prev$bridge3[fieldName]) || [], map), _extends15)), _extends16));
    });
  };
  var handleReset = function handleReset() {
    var _filterData$bridge4, _filterData$bridge4$f;
    var current = new Set((_filterData$bridge4 = filterData[bridge]) == null ? void 0 : (_filterData$bridge4$f = _filterData$bridge4[fieldName]) == null ? void 0 : _filterData$bridge4$f.map(function (item) {
      return item.value;
    }));
    setGlobalNin(function (prev) {
      var _extends17;
      return _extends({}, prev, (_extends17 = {}, _extends17[fieldName] = (prev[fieldName] || []).filter(function (value) {
        return !current.has(value);
      }), _extends17));
    });
    setFilterData(function (prev) {
      var _extends18, _extends19;
      return _extends({}, prev, (_extends19 = {}, _extends19[bridge] = _extends({}, prev[bridge], (_extends18 = {}, _extends18[fieldName] = [], _extends18)), _extends19));
    });
  };
  return /*#__PURE__*/React.createElement(CheckboxView, {
    loading: loading,
    data: map,
    language: language,
    totalCount: totalCount,
    selected: selected,
    threshold: limit,
    emptyState: emptyState,
    search: search,
    onChange: handleCheckboxChange,
    onSearchInput: handleSearchInput,
    onSelectAll: handleSelectAll,
    onReset: handleReset,
    checkboxType: checkboxType
  });
}
function CheckboxView(props) {
  var _word$hiddenItems$lan, _word$hiddenItems$lan2;
  var loading = props.loading,
    data = props.data,
    totalCount = props.totalCount,
    selected = props.selected,
    threshold = props.threshold,
    emptyState = props.emptyState,
    language = props.language,
    _onChange = props.onChange,
    checkboxType = props.checkboxType,
    search = props.search,
    onSearchInput = props.onSearchInput,
    onSelectAll = props.onSelectAll,
    onReset = props.onReset;
  var styles = useStyles$c();
  var mappedSelected = useMemo(function () {
    return selected.slice(-threshold).reverse().map(function (item, index) {
      return /*#__PURE__*/React.createElement(CheckboxItem$1, {
        key: index + "-" + item.value,
        checked: true,
        onChange: function onChange(event, checked) {
          return _onChange(item, checked, event);
        },
        value: item.value,
        label: item.label,
        checkboxType: checkboxType
      });
    });
  }, [selected]);
  var mappedUnselected = useMemo(function () {
    return data.map(function (item, index) {
      return /*#__PURE__*/React.createElement(CheckboxItem$1, {
        key: index + "-" + item.value,
        checked: false,
        onChange: function onChange(event, checked) {
          return _onChange(item, checked, event);
        },
        value: item.value,
        label: item.label,
        checkboxType: checkboxType
      });
    });
  }, [data, selected]);
  return /*#__PURE__*/React.createElement(CheckboxTypeWrapper, null, /*#__PURE__*/React.createElement(TextField, {
    value: search,
    onChange: onSearchInput,
    placeholder: word$4.placeholderSearch[language],
    classes: {
      root: styles.root
    },
    variant: "outlined",
    InputProps: {
      startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React.createElement(SearchIcon, {
        style: {
          width: 14,
          height: 14,
          color: '#014a62'
        }
      })),
      classes: {
        root: styles.rootInput
      }
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "action"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: onSelectAll,
    className: "btn select-all"
  }, word$4.labelSelectAll[language]), /*#__PURE__*/React.createElement("span", {
    onClick: onReset,
    className: "btn reset"
  }, word$4.labelReset[language])), mappedSelected.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormGroup, {
    className: "list-checkbox"
  }, mappedSelected), selected.length > threshold && /*#__PURE__*/React.createElement("div", {
    className: "more-text"
  }, (_word$hiddenItems$lan = word$4.hiddenItems[language]) == null ? void 0 : _word$hiddenItems$lan.replace('[count]', selected.length - threshold)), /*#__PURE__*/React.createElement("div", {
    className: "divider"
  })), /*#__PURE__*/React.createElement(FormGroup, {
    className: "list-checkbox"
  }, loading ? /*#__PURE__*/React.createElement(LoadingComponent, null) : mappedUnselected.length ? mappedUnselected : /*#__PURE__*/React.createElement("div", {
    className: "empty-list"
  }, emptyState || null)), !loading && totalCount > threshold && /*#__PURE__*/React.createElement("div", {
    className: "more-text"
  }, (_word$hiddenItems$lan2 = word$4.hiddenItems[language]) == null ? void 0 : _word$hiddenItems$lan2.replace('[count]', totalCount - threshold)));
}

var useStyles$b = makeStyles({
  root: {
    height: '35px',
    backgroundColor: '#fff',
    margin: '0px 17px'
  }
});
var LOCALE = {
  english: undefined,
  indonesian: idLocale
};
function DateType(_ref) {
  var utils = _ref.utils,
    activeFilter = _ref.activeFilter,
    setFilterData = _ref.setFilterData,
    filterData = _ref.filterData,
    bridge = _ref.bridge,
    language = _ref.language;
  var handleChangeDate = function handleChangeDate(e, target) {
    var _extends2, _extends3, _extends4;
    if (e) {
      if (target === 'from') {
        e.setHours(0, 0, 0, 0);
      } else if (target === 'to') {
        e.setHours(23, 59, 59, 999);
      }
    }
    setFilterData(_extends({}, filterData, (_extends4 = {}, _extends4[bridge] = _extends({}, filterData[bridge], (_extends3 = {}, _extends3[activeFilter.fieldName] = _extends({}, filterData && filterData[bridge] && filterData[bridge][activeFilter.fieldName], (_extends2 = {}, _extends2[target] = e, _extends2)), _extends3)), _extends4)));
  };
  var handleReset = function handleReset() {
    var _extends5, _extends6;
    setFilterData(_extends({}, filterData, (_extends6 = {}, _extends6[bridge] = _extends({}, filterData[bridge], (_extends5 = {}, _extends5[activeFilter.fieldName] = [], _extends5)), _extends6)));
  };
  var classes = useStyles$b();
  return /*#__PURE__*/React.createElement(DateTypeWrapper, null, /*#__PURE__*/React.createElement("div", {
    className: "action"
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn select-all"
  }, word$4.pickADate[language]), /*#__PURE__*/React.createElement("span", {
    onClick: handleReset,
    className: "btn reset"
  }, word$4.labelReset[language])), /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
    locale: LOCALE[language],
    utils: utils || DateFnsUtils
  }, /*#__PURE__*/React.createElement("span", {
    className: "label"
  }, word$4.from[language]), /*#__PURE__*/React.createElement(KeyboardDatePickerStyled, {
    placeholder: word$4.chooseDate[language],
    cancelLabel: word$4.labelCancelButton[language],
    InputProps: {
      classes: {
        root: classes.root
      },
      readOnly: true,
      style: {
        backgroundColor: '#fff',
        fontSize: 12
      }
    },
    value: filterData && filterData[bridge] && filterData[bridge][activeFilter.fieldName] && filterData[bridge][activeFilter.fieldName].from || null,
    maxDate: filterData && filterData[bridge] && filterData[bridge][activeFilter.fieldName] && filterData[bridge][activeFilter.fieldName].to || undefined,
    inputVariant: "outlined",
    format: "MMMM dd, yyyy",
    size: "small",
    space: "0px",
    onChange: function onChange(e) {
      return handleChangeDate(e, 'from');
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "label"
  }, word$4.to[language]), /*#__PURE__*/React.createElement(KeyboardDatePickerStyled, {
    placeholder: word$4.chooseDate[language],
    cancelLabel: word$4.labelCancelButton[language],
    InputProps: {
      classes: {
        root: classes.root
      },
      readOnly: true,
      style: {
        backgroundColor: '#fff',
        fontSize: 12
      }
    },
    value: filterData && filterData[bridge] && filterData[bridge][activeFilter.fieldName] && filterData[bridge][activeFilter.fieldName].to || null,
    minDate: filterData && filterData[bridge] && filterData[bridge][activeFilter.fieldName] && filterData[bridge][activeFilter.fieldName].from || undefined,
    inputVariant: "outlined",
    format: "MMMM dd, yyyy",
    size: "small",
    space: "0px",
    onChange: function onChange(e) {
      return handleChangeDate(e, 'to');
    }
  })));
}

var useStyles$a = makeStyles({
  wrapperSlider: {
    padding: '0px 17px'
  },
  root: {
    fontSize: 12
  },
  rootInput: {
    fontSize: 12,
    height: 30,
    width: 107,
    padding: '8px 7px',
    backgroundColor: '#fff',
    textAlign: 'right'
  },
  input: {
    fontSize: 12,
    padding: '18.5px 2px',
    textAlign: 'right'
  },
  rootAndroment: {
    '& p': {
      fontSize: 12,
      color: '#a9a8a8'
    }
  },
  currency: {
    margin: 0
  }
});
var TextFieldSalary = function TextFieldSalary(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    label = _ref.label;
  var classes = useStyles$a();
  return /*#__PURE__*/React.createElement("div", {
    className: "input"
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      color: '#a9a8a8',
      fontSize: 12,
      margin: 0,
      marginBottom: 4
    }
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "wrapper-input"
  }, /*#__PURE__*/React.createElement(TextField, {
    value: value,
    variant: "outlined",
    onChange: onChange,
    classes: {
      root: classes.root
    },
    InputProps: {
      classes: {
        root: classes.rootInput,
        input: classes.input
      },
      startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        classes: {
          root: classes.rootAndroment
        },
        position: "start"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          borderRight: '1px solid #d0d4d4',
          paddingRight: 4,
          display: 'flex',
          alignItems: 'center',
          height: 30,
          marginRight: 6
        }
      }, /*#__PURE__*/React.createElement("p", {
        className: classes.currency
      }, "Rp")))
    }
  })));
};
function SalaryType(_ref2) {
  var activeFilter = _ref2.activeFilter,
    setFilterData = _ref2.setFilterData,
    filterData = _ref2.filterData,
    bridge = _ref2.bridge;
  var handleChange = function handleChange(event, newValue) {
    event.preventDefault();
    setFilterData(function (e) {
      var _extends2, _extends3;
      return _extends({}, e, (_extends3 = {}, _extends3[bridge] = _extends({}, e[bridge], (_extends2 = {}, _extends2[activeFilter.fieldName] = {
        min: changeToNumber(newValue[0]),
        max: changeToNumber(newValue[1])
      }, _extends2)), _extends3));
    });
  };
  var setter = function setter(idx, value) {
    setFilterData(function (e) {
      var _extends4, _extends5, _extends6;
      return _extends({}, e, (_extends6 = {}, _extends6[bridge] = _extends({}, e[bridge], (_extends5 = {}, _extends5[activeFilter.fieldName] = _extends({}, e[bridge][activeFilter.fieldName], (_extends4 = {}, _extends4[idx] = value, _extends4)), _extends5)), _extends6));
    });
  };
  var handleReset = function handleReset() {
    setFilterData(function (e) {
      var _extends7, _extends8;
      return _extends({}, e, (_extends8 = {}, _extends8[bridge] = _extends({}, e[bridge], (_extends7 = {}, _extends7[activeFilter.fieldName] = {}, _extends7)), _extends8));
    });
  };
  return /*#__PURE__*/React.createElement(AgeTypeWrapper, null, /*#__PURE__*/React.createElement("div", {
    className: "action"
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn select-all"
  }, "Select a range"), /*#__PURE__*/React.createElement("span", {
    onClick: handleReset,
    className: "btn reset"
  }, "Reset")), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-field"
  }, /*#__PURE__*/React.createElement(TextFieldSalary, {
    label: "Min",
    value: formatatSalary(filterData && filterData[bridge] && filterData[bridge][activeFilter.fieldName] && filterData[bridge][activeFilter.fieldName].min && filterData[bridge][activeFilter.fieldName].min.toString() || '')
    // value={value1 || ''}
    ,
    onChange: function onChange(e) {
      var value = e.target.value === '' ? '' : e.target.value;
      setter('min', changeToNumber(value));
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "strip"
  }, "-"), /*#__PURE__*/React.createElement(TextFieldSalary, {
    label: "Max",
    value: formatatSalary(filterData && filterData[bridge] && filterData[bridge][activeFilter.fieldName] && filterData[bridge][activeFilter.fieldName].max && filterData[bridge][activeFilter.fieldName].max.toString() || '')
    // value={value2 || ''}
    ,
    onChange: function onChange(e) {
      var value = e.target.value === '' ? '' : e.target.value;
      setter('max', changeToNumber(value));
    }
  })), /*#__PURE__*/React.createElement(SliderFilter, {
    min: activeFilter.min,
    max: activeFilter.max,
    value: [filterData && filterData[bridge] && filterData[bridge][activeFilter.fieldName] && filterData[bridge][activeFilter.fieldName].min && filterData[bridge][activeFilter.fieldName].min || 0, filterData && filterData[bridge] && filterData[bridge][activeFilter.fieldName] && filterData[bridge][activeFilter.fieldName].max && filterData[bridge][activeFilter.fieldName].max || 0],
    onChange: handleChange
  })));
}

var useStyles$9 = makeStyles({
  root: {
    fontSize: 12,
    padding: '0px 14px 14px 14px',
    width: '100%',
    boxSizing: 'border-box'
  },
  rootInput: {
    fontSize: 12,
    height: 35,
    padding: '8px 7px',
    backgroundColor: '#fff'
  },
  icon: {
    width: 14,
    height: 14,
    color: '#014a62'
  }
});
var SearchBar = function SearchBar(_ref) {
  var search = _ref.search,
    onChange = _ref.onChange;
  var styles = useStyles$9();
  return /*#__PURE__*/React.createElement(TextField, {
    value: search,
    onChange: onChange,
    placeholder: "Search",
    variant: "outlined",
    classes: {
      root: styles.root
    },
    InputProps: {
      classes: {
        root: styles.rootInput
      },
      startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React.createElement(SearchIcon, {
        className: styles.icon
      }))
    }
  });
};

var TalentTypeWrapper = styled.div(["display:flex;flex-direction:column;margin-bottom:12px;.back{display:flex;flex-direction:row;align-items:center;cursor:pointer;padding:0px 17px 14px;.text-secondary{color:#039be5;}.icon{font-size:12px;margin-right:8px;}.text{font-size:12px;}}.action{display:flex;flex-direction:row;justify-content:space-between;padding:0px 17px;margin-bottom:12px;.btn{cursor:pointer;}.select-all{color:#000;font-size:12px;font-weight:600;}.reset{color:#a9a8a8;font-size:12px;}}.content{padding:0px 17px;.text-field{display:flex;flex-direction:row;justify-content:space-between;align-items:center;color:#a9a8a8;.strip{margin-top:16px;}.input{width:43%;.wrapper-input{display:flex;align-items:center;justify-content:space-between;}}}.talent-version-list{min-height:136px;.list-version{cursor:pointer;margin:0px 0px 12px;font-size:12px;color:#039be5;}}.min-height{min-height:176px;}.list-checkbox{display:flex;flex-direction:column;overflow-y:scroll;::-webkit-scrollbar{width:4px;}::-webkit-scrollbar-thumb{background:rgba(0,0,0,0.16);border-radius:5px;}.empty-list{display:flex;align-items:center;justify-content:center;padding:34px;font-size:12px;}}.more-text{color:#a9a8a8;font-size:12px;padding:4px 12px 6px;font-style:italic;}.divider{border-top:1px solid #e5e5e5;margin:8px 14px 14px;}}.label{font-size:12px;margin:9px 17px 6px 17px;}"]);

var useStyles$8 = makeStyles({
  root: {
    fontSize: 12
  },
  rootInput: {
    fontSize: 12,
    height: 30,
    width: 72,
    padding: '8px 7px',
    backgroundColor: '#fff',
    textAlign: 'right'
  },
  input: {
    fontSize: 12,
    padding: '18.5px 2px',
    textAlign: 'right'
  },
  end: {
    fontSize: 12
  }
});
var RangeSelect = function RangeSelect(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    label = _ref.label;
  var classes = useStyles$8();
  return /*#__PURE__*/React.createElement("div", {
    className: "input"
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      color: '#a9a8a8',
      fontSize: 12,
      margin: 0,
      marginBottom: 4
    }
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "wrapper-input"
  }, /*#__PURE__*/React.createElement(TextField, {
    value: value,
    variant: "outlined",
    onChange: onChange,
    classes: {
      root: classes.root
    },
    onFocus: function onFocus(e) {
      return e.target.select();
    },
    InputProps: {
      classes: {
        root: classes.rootInput,
        input: classes.input
      }
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.end
  }, "Unit")));
};
function ScoreRange(props) {
  var _filterData$bridge, _filterData$bridge$ac;
  var filterData = props.filterData,
    activeFilter = props.activeFilter,
    bridge = props.bridge,
    handleChange = props.handleChange,
    setFilterData = props.setFilterData;
  var _ref2 = (filterData == null ? void 0 : (_filterData$bridge = filterData[bridge]) == null ? void 0 : (_filterData$bridge$ac = _filterData$bridge[activeFilter.fieldName]) == null ? void 0 : _filterData$bridge$ac.range) || {},
    _ref2$min = _ref2.min,
    min = _ref2$min === void 0 ? 0 : _ref2$min,
    _ref2$max = _ref2.max,
    max = _ref2$max === void 0 ? 0 : _ref2$max;
  var setter = function setter(idx, value) {
    if (/^\d+$/.test(value)) {
      setFilterData(function (e) {
        var _extends2, _extends3, _extends4;
        return _extends({}, e, (_extends4 = {}, _extends4[bridge] = _extends({}, e[bridge], (_extends3 = {}, _extends3[activeFilter.fieldName] = _extends({}, e[bridge][activeFilter.fieldName], {
          range: _extends({}, e[bridge][activeFilter.fieldName].range, (_extends2 = {}, _extends2[idx] = changeToNumber(value), _extends2))
        }), _extends3)), _extends4));
      });
    }
  };
  return /*#__PURE__*/React.createElement(TalentTypeWrapper, null, /*#__PURE__*/React.createElement("div", {
    className: "action"
  }, /*#__PURE__*/React.createElement("span", {
    className: "select-all"
  }, "Select Talent Score Range")), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-field"
  }, /*#__PURE__*/React.createElement(RangeSelect, {
    label: "Min",
    value: min,
    onChange: function onChange(e) {
      return setter('min', e.target.value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "strip"
  }, "-"), /*#__PURE__*/React.createElement(RangeSelect, {
    label: "Max",
    value: max,
    onChange: function onChange(e) {
      return setter('max', e.target.value);
    }
  })), /*#__PURE__*/React.createElement(SliderFilter, {
    min: activeFilter.min,
    max: activeFilter.max,
    onChange: handleChange,
    value: [min, max]
  })));
}

function TalentVersionList(_ref) {
  var listVersion = _ref.listVersion,
    onClickVersion = _ref.onClickVersion,
    loading = _ref.loading;
  return /*#__PURE__*/React.createElement(TalentTypeWrapper, null, /*#__PURE__*/React.createElement("div", {
    className: "action"
  }, /*#__PURE__*/React.createElement("span", {
    className: "select-all"
  }, "Select Talent Version")), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "talent-version-list "
  }, !loading && listVersion.map(function (_ref2) {
    var value = _ref2.value,
      label = _ref2.label;
    return /*#__PURE__*/React.createElement("p", {
      key: value,
      onClick: function onClick() {
        return onClickVersion({
          value: value,
          label: label
        });
      },
      className: "list-version"
    }, label);
  }), loading && /*#__PURE__*/React.createElement(LoadingComponent, null))));
}

var useStyles$7 = makeStyles({
  rootCheckbox: {
    display: 'flex',
    margin: '0px 0px 8px',
    alignItems: 'center'
  },
  labelCheckbox: {
    fontSize: 12
  },
  checkboxRoot: {
    padding: 0,
    marginRight: 8
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  },
  avatarLabel: {
    width: 36,
    height: 36,
    marginRight: 12
  },
  img: {
    objectFit: 'contain'
  }
});
function TalentVersionDetail(props) {
  var _config$options, _config$options$varia, _config$options2, _globalNin$fieldName, _globalNin$fieldName$, _filterData$bridge, _filterData$bridge$fi, _filterData$bridge$fi2, _ref, _ref$reverse, _ref$reverse$slice;
  var onBack = props.onBack,
    selectedVersion = props.selectedVersion,
    config = props.config,
    search = props.search,
    activeFilter = props.activeFilter,
    filterData = props.filterData,
    setFilterData = props.setFilterData,
    bridge = props.bridge,
    globalNin = props.globalNin,
    setGlobalNin = props.setGlobalNin;
  var fieldName = activeFilter.fieldName;
  var threshold = ((_config$options = config.options) == null ? void 0 : (_config$options$varia = _config$options.variables) == null ? void 0 : _config$options$varia.limit) || 4;
  var _useQuery = useQuery(config.query, _extends({}, config.options, {
      variables: _extends({}, (_config$options2 = config.options) == null ? void 0 : _config$options2.variables, {
        talent: selectedVersion.value,
        search: "%" + search + "%",
        nin: (globalNin == null ? void 0 : (_globalNin$fieldName = globalNin[fieldName]) == null ? void 0 : (_globalNin$fieldName$ = _globalNin$fieldName.checkbox) == null ? void 0 : _globalNin$fieldName$[selectedVersion.value]) || null
      })
    })),
    data = _useQuery.data,
    loading = _useQuery.loading;
  var selected = ((_filterData$bridge = filterData[bridge]) == null ? void 0 : (_filterData$bridge$fi = _filterData$bridge[fieldName]) == null ? void 0 : (_filterData$bridge$fi2 = _filterData$bridge$fi.checkbox) == null ? void 0 : _filterData$bridge$fi2[selectedVersion.value]) || [];
  var _useMemo = useMemo(function () {
      return data && config.setData(data) || [];
    }, [data]),
    _useMemo$ = _useMemo[0],
    map = _useMemo$ === void 0 ? [] : _useMemo$,
    _useMemo$2 = _useMemo[1],
    total = _useMemo$2 === void 0 ? 0 : _useMemo$2;
  var handleCheckboxChange = function handleCheckboxChange(item, checked) {
    setGlobalNin(function (prev) {
      var _prev$fieldName, _prev$fieldName2, _prev$fieldName2$chec, _extends2, _extends3;
      return _extends({}, prev, (_extends3 = {}, _extends3[fieldName] = _extends({}, prev[fieldName], {
        checkbox: _extends({}, (_prev$fieldName = prev[fieldName]) == null ? void 0 : _prev$fieldName.checkbox, (_extends2 = {}, _extends2[selectedVersion.value] = updateNinVariables((_prev$fieldName2 = prev[fieldName]) == null ? void 0 : (_prev$fieldName2$chec = _prev$fieldName2.checkbox) == null ? void 0 : _prev$fieldName2$chec[selectedVersion.value], item, checked), _extends2))
      }), _extends3));
    });
    setFilterData(function (prev) {
      var _prev$bridge, _prev$bridge2, _prev$bridge2$fieldNa, _prev$bridge3, _prev$bridge3$fieldNa, _prev$bridge3$fieldNa2, _extends4, _extends5, _extends6;
      return _extends({}, prev, (_extends6 = {}, _extends6[bridge] = _extends({}, prev[bridge], (_extends5 = {}, _extends5[fieldName] = _extends({}, (_prev$bridge = prev[bridge]) == null ? void 0 : _prev$bridge[fieldName], {
        checkbox: _extends({}, (_prev$bridge2 = prev[bridge]) == null ? void 0 : (_prev$bridge2$fieldNa = _prev$bridge2[fieldName]) == null ? void 0 : _prev$bridge2$fieldNa.checkbox, (_extends4 = {}, _extends4[selectedVersion.value] = updateFilterVariables((_prev$bridge3 = prev[bridge]) == null ? void 0 : (_prev$bridge3$fieldNa = _prev$bridge3[fieldName]) == null ? void 0 : (_prev$bridge3$fieldNa2 = _prev$bridge3$fieldNa.checkbox) == null ? void 0 : _prev$bridge3$fieldNa2[selectedVersion.value], item, checked), _extends4))
      }), _extends5)), _extends6));
    });
  };
  var handleReset = function handleReset() {
    setGlobalNin(function (prev) {
      var _prev$fieldName3, _extends7, _extends8;
      return _extends({}, prev, (_extends8 = {}, _extends8[fieldName] = _extends({}, prev[fieldName], {
        checkbox: _extends({}, (_prev$fieldName3 = prev[fieldName]) == null ? void 0 : _prev$fieldName3.checkbox, (_extends7 = {}, _extends7[selectedVersion.value] = [], _extends7))
      }), _extends8));
    });
    setFilterData(function (prev) {
      var _prev$bridge4, _prev$bridge5, _extends9, _extends10, _extends11;
      return _extends({}, prev, (_extends11 = {}, _extends11[bridge] = _extends({}, prev[bridge], (_extends10 = {}, _extends10[fieldName] = _extends({}, (_prev$bridge4 = prev[bridge]) == null ? void 0 : _prev$bridge4[fieldName], {
        checkbox: _extends({}, (_prev$bridge5 = prev[bridge]) == null ? void 0 : _prev$bridge5[fieldName].checkbox, (_extends9 = {}, _extends9[selectedVersion.value] = [], _extends9))
      }), _extends10)), _extends11));
    });
  };
  var handleSelectAll = function handleSelectAll() {
    setGlobalNin(function (prev) {
      var _prev$fieldName4, _prev$fieldName5, _prev$fieldName5$chec, _extends12, _extends13;
      return _extends({}, prev, (_extends13 = {}, _extends13[fieldName] = _extends({}, prev == null ? void 0 : prev[fieldName], {
        checkbox: _extends({}, prev == null ? void 0 : (_prev$fieldName4 = prev[fieldName]) == null ? void 0 : _prev$fieldName4.checkbox, (_extends12 = {}, _extends12[selectedVersion.value] = [].concat((prev == null ? void 0 : (_prev$fieldName5 = prev[fieldName]) == null ? void 0 : (_prev$fieldName5$chec = _prev$fieldName5.checkbox) == null ? void 0 : _prev$fieldName5$chec[selectedVersion.value]) || [], map == null ? void 0 : map.map(function (item) {
          return item.value;
        })), _extends12))
      }), _extends13));
    });
    setFilterData(function (prev) {
      var _prev$bridge6, _prev$bridge7, _prev$bridge7$fieldNa, _prev$bridge8, _prev$bridge8$fieldNa, _prev$bridge8$fieldNa2, _extends14, _extends15, _extends16;
      return _extends({}, prev, (_extends16 = {}, _extends16[bridge] = _extends({}, prev[bridge], (_extends15 = {}, _extends15[fieldName] = _extends({}, (prev == null ? void 0 : (_prev$bridge6 = prev[bridge]) == null ? void 0 : _prev$bridge6[fieldName]) || {}, {
        checkbox: _extends({}, (prev == null ? void 0 : (_prev$bridge7 = prev[bridge]) == null ? void 0 : (_prev$bridge7$fieldNa = _prev$bridge7[fieldName]) == null ? void 0 : _prev$bridge7$fieldNa.checkbox) || {}, (_extends14 = {}, _extends14[selectedVersion.value] = [].concat((prev == null ? void 0 : (_prev$bridge8 = prev[bridge]) == null ? void 0 : (_prev$bridge8$fieldNa = _prev$bridge8[fieldName]) == null ? void 0 : (_prev$bridge8$fieldNa2 = _prev$bridge8$fieldNa.checkbox) == null ? void 0 : _prev$bridge8$fieldNa2[selectedVersion.value]) || [], map), _extends14))
      }), _extends15)), _extends16));
    });
  };
  return /*#__PURE__*/React.createElement(TalentTypeWrapper, null, /*#__PURE__*/React.createElement("div", {
    onClick: onBack,
    className: "back"
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, {
    className: "icon text-secondary"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text text-secondary"
  }, " Back to Talent Version")), /*#__PURE__*/React.createElement("div", {
    className: "action"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: handleSelectAll,
    className: "btn select-all"
  }, "Select All"), /*#__PURE__*/React.createElement("span", {
    onClick: handleReset,
    className: "btn reset"
  }, "Reset")), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement(FormGroup, {
    className: "list-checkbox"
  }, (_ref = [].concat(selected)) == null ? void 0 : (_ref$reverse = _ref.reverse()) == null ? void 0 : (_ref$reverse$slice = _ref$reverse.slice(0, threshold)) == null ? void 0 : _ref$reverse$slice.map(function (item) {
    return /*#__PURE__*/React.createElement(CheckboxItem, _extends({}, item, {
      checked: true,
      key: item.value,
      onChange: function onChange(event, checked) {
        return handleCheckboxChange(item, checked);
      }
    }));
  })), (selected == null ? void 0 : selected.length) > threshold && /*#__PURE__*/React.createElement("div", {
    className: "more-text"
  }, "and ", (selected == null ? void 0 : selected.length) - threshold, " hidden items"), (selected == null ? void 0 : selected.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "divider"
  }), /*#__PURE__*/React.createElement(FormGroup, {
    className: "list-checkbox"
  }, !loading && (map == null ? void 0 : map.map(function (item) {
    return /*#__PURE__*/React.createElement(CheckboxItem, _extends({}, item, {
      key: item.value,
      checked: false,
      onChange: function onChange(event, checked) {
        return handleCheckboxChange(item, checked);
      }
    }));
  })), loading && /*#__PURE__*/React.createElement(LoadingComponent, {
    className: "min-height"
  })), !loading && total > threshold && /*#__PURE__*/React.createElement("div", {
    className: "more-text"
  }, "and ", total - threshold, " hidden items")));
}
var CheckboxItem = function CheckboxItem(_ref2) {
  var label = _ref2.label,
    badge = _ref2.badge,
    onChange = _ref2.onChange,
    checked = _ref2.checked,
    value = _ref2.value;
  var classes = useStyles$7();
  return /*#__PURE__*/React.createElement(FormControlLabel, {
    label: /*#__PURE__*/React.createElement(CheckboxLabel, {
      badge: badge,
      label: label
    }),
    classes: {
      root: classes.rootCheckbox,
      label: classes.labelCheckbox
    },
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: checked,
      color: "primary",
      classes: {
        root: classes.checkboxRoot
      },
      onChange: onChange,
      value: value
    })
  });
};
var CheckboxLabel = function CheckboxLabel(_ref3) {
  var badge = _ref3.badge,
    label = _ref3.label;
  var classes = useStyles$7();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.label
  }, /*#__PURE__*/React.createElement(Avatar, {
    variant: "square",
    src: badge,
    alt: label,
    classes: {
      root: classes.avatarLabel,
      img: classes.img
    }
  }), /*#__PURE__*/React.createElement("span", null, label));
};

function TalentType(props) {
  var _activeFilter$options, _activeFilter$options2;
  var activeFilter = props.activeFilter,
    setFilterData = props.setFilterData,
    bridge = props.bridge;
  var _useState = useState(null),
    selectedVersion = _useState[0],
    setSelectedVersion = _useState[1];
  var _useState2 = useState(''),
    search = _useState2[0],
    setSearch = _useState2[1];
  var handleChange = function handleChange(event, newValue) {
    event.preventDefault();
    setFilterData(function (e) {
      var _e$bridge, _extends2, _extends3;
      return _extends({}, e, (_extends3 = {}, _extends3[bridge] = _extends({}, e[bridge], (_extends2 = {}, _extends2[activeFilter.fieldName] = _extends({}, (_e$bridge = e[bridge]) == null ? void 0 : _e$bridge[activeFilter.fieldName], {
        range: {
          min: changeToNumber(newValue[0]),
          max: changeToNumber(newValue[1])
        }
      }), _extends2)), _extends3));
    });
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SearchBar, {
    search: search,
    onChange: function onChange(e) {
      return setSearch(e.target.value);
    }
  }), selectedVersion ? /*#__PURE__*/React.createElement(TalentVersionDetail, _extends({}, props, {
    search: search,
    selectedVersion: selectedVersion,
    config: activeFilter == null ? void 0 : (_activeFilter$options = activeFilter.options) == null ? void 0 : _activeFilter$options.listBadges,
    onBack: function onBack() {
      setSearch('');
      setSelectedVersion(null);
    }
  })) : /*#__PURE__*/React.createElement(TalentVersion, _extends({}, props, {
    search: search,
    handleChange: handleChange,
    config: activeFilter == null ? void 0 : (_activeFilter$options2 = activeFilter.options) == null ? void 0 : _activeFilter$options2.listTalents,
    onClickVersion: function onClickVersion(data) {
      setSearch('');
      setSelectedVersion(data);
    }
  })));
}
var TalentVersion = function TalentVersion(props) {
  var _config$options;
  var config = props.config,
    onClickVersion = props.onClickVersion,
    search = props.search;
  var _useQuery = useQuery(config.query, _extends({}, config.options, {
      variables: _extends({}, (_config$options = config.options) == null ? void 0 : _config$options.variables, {
        search: "%" + search + "%"
      })
    })),
    data = _useQuery.data,
    loading = _useQuery.loading;
  var _useMemo = useMemo(function () {
      return data && config.setData(data) || [];
    }, [data]),
    _useMemo$ = _useMemo[0],
    map = _useMemo$ === void 0 ? [] : _useMemo$;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TalentVersionList, {
    listVersion: map,
    loading: loading,
    onClickVersion: onClickVersion
  }), /*#__PURE__*/React.createElement(ScoreRange, props));
};

function TypeFilter(_ref) {
  var activeFilter = _ref.activeFilter,
    setFilterData = _ref.setFilterData,
    filterData = _ref.filterData,
    bridge = _ref.bridge,
    globalNin = _ref.globalNin,
    setGlobalNin = _ref.setGlobalNin,
    language = _ref.language,
    limit = _ref.limit;
  var renderType = function renderType(_ref2) {
    var activeFilter = _ref2.activeFilter,
      setFilterData = _ref2.setFilterData,
      filterData = _ref2.filterData,
      bridge = _ref2.bridge,
      setGlobalNin = _ref2.setGlobalNin,
      globalNin = _ref2.globalNin;
    var type = activeFilter.type,
      utils = activeFilter.utils;
    switch (type) {
      case 'checkbox':
        return /*#__PURE__*/React.createElement(CheckboxList, {
          language: language,
          activeFilter: activeFilter,
          setFilterData: setFilterData,
          filterData: filterData,
          bridge: bridge,
          setGlobalNin: setGlobalNin,
          globalNin: globalNin,
          limit: limit
        });
      case 'date':
        return /*#__PURE__*/React.createElement(DateType, {
          language: language,
          activeFilter: activeFilter,
          setFilterData: setFilterData,
          filterData: filterData,
          utils: utils,
          bridge: bridge
        });
      case 'age':
        return /*#__PURE__*/React.createElement(AgeType, {
          language: language,
          filterData: filterData,
          activeFilter: activeFilter,
          setFilterData: setFilterData,
          bridge: bridge
        });
      case 'salary':
        return /*#__PURE__*/React.createElement(SalaryType, {
          language: language,
          filterData: filterData,
          activeFilter: activeFilter,
          setFilterData: setFilterData,
          bridge: bridge
        });
      case 'talent':
        return /*#__PURE__*/React.createElement(TalentType, {
          language: language,
          filterData: filterData,
          activeFilter: activeFilter,
          setFilterData: setFilterData,
          bridge: bridge,
          setGlobalNin: setGlobalNin,
          globalNin: globalNin
        });
      default:
        return /*#__PURE__*/React.createElement("p", null);
    }
  };
  return /*#__PURE__*/React.createElement(TypeFilterWrapper, null, renderType({
    activeFilter: activeFilter,
    setFilterData: setFilterData,
    filterData: filterData,
    bridge: bridge,
    globalNin: globalNin,
    setGlobalNin: setGlobalNin
  }));
}

var _excluded = ["listFilter", "id", "language", "onApply", "anchorOrigin", "transformOrigin", "options", "includeExclude", "maxHeight", "limit", "onClose"];
var useStyles$6 = makeStyles({
  paper: {
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
    display: 'flex',
    flexDirection: 'row',
    fontFamily: 'muli',
    borderRadius: 5,
    minHeight: 217
  }
});
var defaultAnchor = {
  vertical: 'bottom',
  horizontal: 'right'
};
var defaultTransform = {
  vertical: 'top',
  horizontal: 'right'
};

// 'include' = 0, 'exclude' = 1
var INITIAL_BRIDGE = 0;
var INITIAL_FILTERDATA = {
  0: {},
  1: {}
};
var INITIAL_GLOBAL_NIN = {};
var DEFAULT_OPTION_PROPS = {
  isSetActiveMenuWhenOpen: false,
  isSetActiveMenuAfterClose: false,
  setActiveMenuToIndex: 0,
  delayResetMenu: 1000
};
function Filter(_ref) {
  var listFilter = _ref.listFilter,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'filter' : _ref$id,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'english' : _ref$language,
    onApply = _ref.onApply,
    _ref$anchorOrigin = _ref.anchorOrigin,
    anchorOrigin = _ref$anchorOrigin === void 0 ? defaultAnchor : _ref$anchorOrigin,
    _ref$transformOrigin = _ref.transformOrigin,
    transformOrigin = _ref$transformOrigin === void 0 ? defaultTransform : _ref$transformOrigin,
    _ref$options = _ref.options,
    baseOptions = _ref$options === void 0 ? null : _ref$options,
    _ref$includeExclude = _ref.includeExclude,
    includeExclude = _ref$includeExclude === void 0 ? true : _ref$includeExclude,
    _ref$maxHeight = _ref.maxHeight,
    maxHeight = _ref$maxHeight === void 0 ? '570px' : _ref$maxHeight,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? 6 : _ref$limit,
    onClose = _ref.onClose,
    children = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useState = useState(INITIAL_BRIDGE),
    bridge = _useState[0],
    setBridge = _useState[1];
  var classes = useStyles$6();
  var _useState2 = useState(null),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  var _useState3 = useState(listFilter[0]),
    activeFilter = _useState3[0],
    setActiveFilter = _useState3[1];
  var _useState4 = useState(INITIAL_FILTERDATA),
    filterData = _useState4[0],
    setFilterData = _useState4[1];
  var _useState5 = useState(INITIAL_GLOBAL_NIN),
    globalNin = _useState5[0],
    setGlobalNin = _useState5[1];
  var options = _extends({}, DEFAULT_OPTION_PROPS, baseOptions);
  var _resetActiveMenu = function _resetActiveMenu(action) {
    var isSetActiveMenuAfterClose = options.isSetActiveMenuAfterClose,
      isSetActiveMenuWhenOpen = options.isSetActiveMenuWhenOpen,
      setActiveMenuToIndex = options.setActiveMenuToIndex,
      delayResetMenu = options.delayResetMenu;
    if (isSetActiveMenuAfterClose && action === 'close') {
      setTimeout(function () {
        setActiveFilter(listFilter[setActiveMenuToIndex]);
      }, delayResetMenu);
    }
    if (isSetActiveMenuWhenOpen && action === 'open') {
      setActiveFilter(listFilter[setActiveMenuToIndex]);
    }
  };
  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
    _resetActiveMenu('open');
  };
  var handleClose = function handleClose() {
    setAnchorEl(null);
    _resetActiveMenu('close');
    if (onClose) {
      onClose();
    }
  };
  var handleResetAll = function handleResetAll() {
    setFilterData(INITIAL_FILTERDATA);
    setGlobalNin(INITIAL_GLOBAL_NIN);
  };
  var handleApply = function handleApply() {
    onApply(filterData);
    handleClose();
  };
  var open = Boolean(anchorEl);
  var idTarget = open ? id : undefined;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", _extends({
    "aria-describedby": idTarget,
    style: {
      display: 'inline-flex',
      fontFamily: 'muli'
    },
    onClick: handleClick
  }, children)), /*#__PURE__*/React.createElement(Popover, {
    id: idTarget,
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    classes: {
      paper: classes.paper
    },
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin
  }, /*#__PURE__*/React.createElement(ListFilter, {
    id: id,
    language: language,
    bridge: bridge,
    setBridge: setBridge,
    activeFilter: activeFilter,
    setActiveFilter: setActiveFilter,
    listFilter: listFilter,
    filterData: filterData,
    onResetAll: handleResetAll,
    onCancel: handleClose,
    onApply: handleApply,
    includeExclude: includeExclude,
    maxHeight: maxHeight
  }), /*#__PURE__*/React.createElement(TypeFilter, {
    filterData: filterData,
    language: language,
    setFilterData: setFilterData,
    activeFilter: activeFilter,
    setGlobalNin: setGlobalNin,
    globalNin: globalNin,
    bridge: bridge,
    limit: limit
  })));
}

var BRIDGE_INC = 'include';
var BRIDGE_EXC = 'exclude';
var LANG_ID = 'indonesian';
var LANG_EN = 'english';
var updateSelectionsArray = function updateSelectionsArray(array, item, checked) {
  if (array === void 0) {
    array = [];
  }
  if (checked) {
    return [].concat(array, [item.value]);
  } else {
    return array.filter(function (entry) {
      return entry !== item.value;
    });
  }
};
var updateDataArray = function updateDataArray(array, item, checked) {
  // NOTE(intrnl): we use undefined to mark that the data hasn't been loaded yet
  if (!array) {
    if (!checked) {
      return;
    }
    array = [];
  }
  if (checked) {
    return [].concat(array, [item]);
  } else {
    return array.filter(function (entry) {
      return entry.value !== item.value;
    });
  }
};
var updateSelections = function updateSelections(filter, selections, bridge, item, checked) {
  var field = filter.fieldName;
  if (checked) {
    var _selections$BRIDGE_IN, _extends2, _selections$BRIDGE_EX, _extends3, _ref;
    return _ref = {}, _ref[BRIDGE_INC] = _extends({}, selections[BRIDGE_INC], (_extends2 = {}, _extends2[field] = updateSelectionsArray((_selections$BRIDGE_IN = selections[BRIDGE_INC]) == null ? void 0 : _selections$BRIDGE_IN[field], item, bridge === BRIDGE_INC), _extends2)), _ref[BRIDGE_EXC] = _extends({}, selections[BRIDGE_EXC], (_extends3 = {}, _extends3[field] = updateSelectionsArray((_selections$BRIDGE_EX = selections[BRIDGE_EXC]) == null ? void 0 : _selections$BRIDGE_EX[field], item, bridge === BRIDGE_EXC), _extends3)), _ref;
  } else {
    var _selections$bridge, _extends4, _extends5;
    return _extends({}, selections, (_extends5 = {}, _extends5[bridge] = _extends({}, selections[bridge], (_extends4 = {}, _extends4[field] = updateSelectionsArray((_selections$bridge = selections[bridge]) == null ? void 0 : _selections$bridge[field], item, checked), _extends4)), _extends5));
  }
};
var updateData = function updateData(filter, selections, bridge, item, checked) {
  var field = filter.fieldName;
  if (checked) {
    var _selections$BRIDGE_IN2, _extends6, _selections$BRIDGE_EX2, _extends7, _ref2;
    return _ref2 = {}, _ref2[BRIDGE_INC] = _extends({}, selections[BRIDGE_INC], (_extends6 = {}, _extends6[field] = updateDataArray((_selections$BRIDGE_IN2 = selections[BRIDGE_INC]) == null ? void 0 : _selections$BRIDGE_IN2[field], item, bridge === BRIDGE_INC), _extends6)), _ref2[BRIDGE_EXC] = _extends({}, selections[BRIDGE_EXC], (_extends7 = {}, _extends7[field] = updateDataArray((_selections$BRIDGE_EX2 = selections[BRIDGE_EXC]) == null ? void 0 : _selections$BRIDGE_EX2[field], item, bridge === BRIDGE_EXC), _extends7)), _ref2;
  } else {
    var _selections$bridge2, _extends8, _extends9;
    return _extends({}, selections, (_extends9 = {}, _extends9[bridge] = _extends({}, selections[bridge], (_extends8 = {}, _extends8[field] = updateDataArray((_selections$bridge2 = selections[bridge]) == null ? void 0 : _selections$bridge2[field], item, checked), _extends8)), _extends9));
  }
};

var _LANG_EN$LANG_ID;
var intl = (_LANG_EN$LANG_ID = {}, _LANG_EN$LANG_ID[LANG_EN] = {
  include: 'Include',
  exclude: 'Exclude',
  searchPlaceholder: 'Search',
  headerSelected: function headerSelected(count) {
    return "Selected (" + count + ")";
  },
  headerUnselected: function headerUnselected(count) {
    return "Suggested (" + count + ")";
  },
  buttonUnselectAll: 'Unselect All',
  selectedEmptyState: 'No Selected',
  truncated: function truncated(count) {
    return "and " + count + " hidden items";
  },
  buttonCancel: 'Cancel',
  buttonApply: 'Apply'
}, _LANG_EN$LANG_ID[LANG_ID] = {
  include: 'Masukan',
  exclude: 'Kecualikan',
  searchPlaceholder: 'Cari',
  headerSelected: function headerSelected(count) {
    return "Dipilih (" + count + ")";
  },
  headerUnselected: function headerUnselected(count) {
    return "Disarankan (" + count + ")";
  },
  buttonUnselectAll: 'Batal Pilih Semua',
  selectedEmptyState: 'Tidak Dipilih',
  truncated: function truncated(count) {
    return "dan " + count + " item tersembunyi";
  },
  buttonCancel: 'Batalkan',
  buttonApply: 'Terapkan'
}, _LANG_EN$LANG_ID);

var useStyles$5 = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      padding: 24
    },
    search: {
      fontSize: 14
    },
    sectionHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 8
    },
    sectionTitle: {
      fontSize: 14,
      fontWeight: 600
    },
    sectionLink: {
      fontFamily: 'inherit',
      fontSize: 14,
      color: theme.palette.text.secondary
    },
    sectionContent: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: "0px 8px"
    },
    checkboxLabel: {
      fontSize: 14
    },
    checkboxRoot: {
      padding: "8px 9px"
    },
    emptyScreen: {
      color: theme.palette.text.secondary,
      fontSize: 14,
      minHeight: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    blurb: {
      color: theme.palette.text.secondary,
      fontSize: 14,
      marginTop: 8
    }
  };
});
var BaseCheckboxView = function BaseCheckboxView(props) {
  var language = props.language,
    loadingUnselected = props.loadingUnselected,
    loadingSelected = props.loadingSelected,
    selected = props.selected,
    limit = props.limit,
    data = props.data,
    count = props.count,
    _onChange = props.onChange,
    search = props.search,
    onSearchChange = props.onSearchChange,
    onUnselectAll = props.onUnselectAll;
  var styles = useStyles$5();
  var mappedSelected = React.useMemo(function () {
    return selected.slice(-limit).reverse().map(function (item) {
      return /*#__PURE__*/React.createElement(FormControlLabel, {
        key: item.value,
        label: item.label,
        onChange: function onChange(ev, checked) {
          return _onChange(item, checked, ev);
        },
        checked: true,
        control: /*#__PURE__*/React.createElement(Checkbox, {
          color: "primary",
          className: styles.checkboxRoot
        }),
        classes: {
          label: styles.checkboxLabel
        }
      });
    });
  }, [selected]);
  var mappedUnselected = React.useMemo(function () {
    return data.map(function (item) {
      return /*#__PURE__*/React.createElement(FormControlLabel, {
        key: item.value,
        label: item.label,
        onChange: function onChange(ev, checked) {
          return _onChange(item, checked, ev);
        },
        checked: false,
        control: /*#__PURE__*/React.createElement(Checkbox, {
          color: "primary",
          className: styles.checkboxRoot
        }),
        classes: {
          label: styles.checkboxLabel
        }
      });
    });
  }, [data, selected]);
  return /*#__PURE__*/React.createElement(DialogContent, {
    className: styles.root
  }, /*#__PURE__*/React.createElement(OutlinedInput, {
    value: search,
    onChange: onSearchChange,
    placeholder: intl[language].searchPlaceholder,
    fullWidth: true,
    margin: "dense",
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, /*#__PURE__*/React.createElement(SearchIcon, {
      fontSize: "small",
      color: "primary"
    })),
    className: styles.search
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.sectionHeader
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.sectionTitle
  }, intl[language].headerSelected(selected.length)), selected.length > 0 && /*#__PURE__*/React.createElement(Link, {
    component: "button",
    onClick: onUnselectAll,
    className: styles.sectionLink
  }, intl[language].buttonUnselectAll)), loadingSelected ? /*#__PURE__*/React.createElement("div", {
    className: styles.emptyScreen
  }, /*#__PURE__*/React.createElement(CircularProgress, null)) : selected.length < 1 ? /*#__PURE__*/React.createElement("div", {
    className: styles.emptyScreen
  }, intl[language].selectedEmptyState) : /*#__PURE__*/React.createElement("div", {
    className: styles.sectionContent
  }, mappedSelected), selected.length > limit && /*#__PURE__*/React.createElement("div", {
    className: styles.blurb
  }, intl[language].truncated(selected.length - limit))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.sectionHeader
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.sectionTitle
  }, intl[language].headerUnselected(data.length))), loadingUnselected ? /*#__PURE__*/React.createElement("div", {
    className: styles.emptyScreen
  }, /*#__PURE__*/React.createElement(CircularProgress, null)) : /*#__PURE__*/React.createElement("div", {
    className: styles.sectionContent
  }, mappedUnselected), !loadingUnselected && count > limit && /*#__PURE__*/React.createElement("div", {
    className: styles.blurb
  }, intl[language].truncated(count - limit))));
};

var EMPTY_ARRAY$1 = [];
var LocalCheckboxView = function LocalCheckboxView(props) {
  var _data$bridge;
  var language = props.language,
    filter = props.filter,
    bridge = props.bridge,
    selections = props.selections,
    data = props.data,
    limit = props.limit,
    setSelections = props.setSelections,
    setData = props.setData;
  var _React$useState = React.useState(''),
    search = _React$useState[0],
    setSearch = _React$useState[1];
  var field = filter.fieldName;
  var list = filter.options.list || EMPTY_ARRAY$1;
  var selected = React.useMemo(function () {
    var _selections$bridge;
    return new Set(((_selections$bridge = selections[bridge]) == null ? void 0 : _selections$bridge[field]) || EMPTY_ARRAY$1);
  }, [bridge, selections]);
  var selectedList = React.useMemo(function () {
    return list.filter(function (item) {
      return selected.has(item.value);
    });
  }, [list, selected]);
  var unselectedList = React.useMemo(function () {
    var lowercase = search.toLowerCase();
    return list.filter(function (item) {
      return !selected.has(item.value) && (!lowercase || item.label.toLowerCase().includes(lowercase));
    });
  }, [list, search, selected]);
  var handleSearchChange = function handleSearchChange(ev) {
    setSearch(ev.target.value);
  };
  var handleCheckboxChange = function handleCheckboxChange(item, checked) {
    setSelections(updateSelections(filter, selections, bridge, item, checked));
    setData(updateData(filter, data, bridge, item, checked));
  };
  var handleUnselectAll = function handleUnselectAll() {
    var _extends2, _extends3, _extends4, _extends5;
    setSelections(_extends({}, selections, (_extends3 = {}, _extends3[bridge] = _extends({}, selections[bridge], (_extends2 = {}, _extends2[field] = EMPTY_ARRAY$1, _extends2)), _extends3)));
    setData(_extends({}, data, (_extends5 = {}, _extends5[bridge] = _extends({}, data[bridge], (_extends4 = {}, _extends4[field] = EMPTY_ARRAY$1, _extends4)), _extends5)));
  };
  if (!((_data$bridge = data[bridge]) != null && _data$bridge[field])) {
    var _extends6, _extends7;
    setData(_extends({}, data, (_extends7 = {}, _extends7[bridge] = _extends({}, data[bridge], (_extends6 = {}, _extends6[field] = selectedList, _extends6)), _extends7)));
    return null;
  }
  return /*#__PURE__*/React.createElement(BaseCheckboxView, {
    language: language,
    selected: selectedList,
    limit: limit,
    data: unselectedList,
    count: list.length - selected.size,
    onChange: handleCheckboxChange,
    search: search,
    onSearchChange: handleSearchChange,
    onUnselectAll: handleUnselectAll
  });
};

var EMPTY_ARRAY = [];
var RemoteCheckboxView = function RemoteCheckboxView(props) {
  var _selections$bridge, _data$bridge, _selections$bridge2, _selections$bridge3, _data$bridge2;
  var language = props.language,
    filter = props.filter,
    bridge = props.bridge,
    selections = props.selections,
    data = props.data,
    limit = props.limit,
    setSelections = props.setSelections,
    setData = props.setData;
  var field = filter.fieldName;
  var config = filter.options.fetch;
  var _React$useState = React.useState(''),
    search = _React$useState[0],
    setSearch = _React$useState[1];
  var _useDebouncedValue = useDebounced(search, 500),
    debouncedSearch = _useDebouncedValue[0];

  // NOTE(intrnl): this query should only ever run if:
  // 1. we have a list of selected values, but
  // 2. we don't have any data to show in UI
  var _useQuery = useQuery(config.query, _extends({}, config.options, {
      wlb_skipPatch: true,
      skip: !((_selections$bridge = selections[bridge]) != null && _selections$bridge[field]) || ((_data$bridge = data[bridge]) == null ? void 0 : _data$bridge[field]),
      variables: config.getVariables({
        _in: ((_selections$bridge2 = selections[bridge]) == null ? void 0 : _selections$bridge2[field]) || EMPTY_ARRAY
      }),
      onCompleted: function onCompleted(queryData) {
        var _extends4, _extends5;
        // NOTE(intrnl): either the query has failed, or because this query is
        // paused, this can be confirmed by checking `data[bridge]?.[field]`
        if (!queryData) {
          return;
        }
        var _ref = queryData && config.setData(queryData) || EMPTY_ARRAY,
          next = _ref[0];

        // NOTE(intrnl): some data might not exist anymore
        var values = next.map(function (item) {
          return item.value;
        });
        if (selections[bridge][field].length !== values.length) {
          var _extends2, _extends3;
          setSelections(_extends({}, selections, (_extends3 = {}, _extends3[bridge] = _extends({}, selections[bridge], (_extends2 = {}, _extends2[field] = next.map(function (item) {
            return item.value;
          }), _extends2)), _extends3)));
        }
        setData(_extends({}, data, (_extends5 = {}, _extends5[bridge] = _extends({}, data[bridge], (_extends4 = {}, _extends4[field] = next || EMPTY_ARRAY, _extends4)), _extends5)));
      }
    })),
    loadingSelected = _useQuery.loading;
  var _useQuery2 = useQuery(config.query, _extends({}, config.options, {
      wlb_skipPatch: true,
      variables: config.getVariables({
        search: debouncedSearch ? "%" + debouncedSearch + "%" : undefined,
        limit: limit,
        _nin: ((_selections$bridge3 = selections[bridge]) == null ? void 0 : _selections$bridge3[field]) || EMPTY_ARRAY
      })
    })),
    unselectedData = _useQuery2.data,
    loading = _useQuery2.loading;
  var _React$useMemo = React.useMemo(function () {
      return unselectedData && config.setData(unselectedData) || EMPTY_ARRAY;
    }, [unselectedData]),
    _React$useMemo$ = _React$useMemo[0],
    mappedList = _React$useMemo$ === void 0 ? EMPTY_ARRAY : _React$useMemo$,
    _React$useMemo$2 = _React$useMemo[1],
    totalCount = _React$useMemo$2 === void 0 ? 0 : _React$useMemo$2;
  var handleSearchChange = function handleSearchChange(ev) {
    setSearch(ev.target.value);
  };
  var handleCheckboxChange = function handleCheckboxChange(item, checked) {
    setSelections(updateSelections(filter, selections, bridge, item, checked));
    setData(updateData(filter, data, bridge, item, checked));
  };
  var handleUnselectAll = function handleUnselectAll() {
    var _extends6, _extends7, _extends8, _extends9;
    setSelections(_extends({}, selections, (_extends7 = {}, _extends7[bridge] = _extends({}, selections[bridge], (_extends6 = {}, _extends6[field] = EMPTY_ARRAY, _extends6)), _extends7)));
    setData(_extends({}, data, (_extends9 = {}, _extends9[bridge] = _extends({}, data[bridge], (_extends8 = {}, _extends8[field] = EMPTY_ARRAY, _extends8)), _extends9)));
  };
  return /*#__PURE__*/React.createElement(BaseCheckboxView, {
    language: language,
    loadingSelected: loadingSelected,
    loadingUnselected: loading,
    selected: ((_data$bridge2 = data[bridge]) == null ? void 0 : _data$bridge2[field]) || EMPTY_ARRAY,
    limit: limit,
    data: mappedList,
    count: totalCount,
    onChange: handleCheckboxChange,
    search: search,
    onSearchChange: handleSearchChange,
    onUnselectAll: handleUnselectAll
  });
};

var INITIAL_SELECTIONS = {};
var INITIAL_DATA = {};
var useStyles$4 = makeStyles(function (theme) {
  return {
    dialog: {
      fontFamily: theme.typography.fontFamily
    },
    paper: {
      height: '100%'
    },
    header: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      display: 'flex',
      alignItems: 'center',
      padding: "12px 24px 8px"
    },
    headerButton: {
      color: 'inherit',
      fontWeight: 600,
      height: 38,
      marginLeft: -8
    },
    typeMenuItem: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    count: {
      fontSize: 12,
      fontWeight: 600,
      lineHeight: '20px',
      height: 20,
      minWidth: 20,
      backgroundColor: theme.palette.primary.contrastText,
      color: theme.palette.primary.main,
      boxSizing: 'border-box',
      borderRadius: 9999,
      padding: "0 6px",
      marginLeft: 8
    },
    countInvert: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    grow: {
      flexGrow: 1
    },
    tabs: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      padding: "0 8px"
    },
    tabsIndicator: {
      height: 3
    },
    tab: {
      fontWeight: 600,
      minWidth: 0,
      padding: "6px 16px"
    },
    tabWrapper: {
      flexDirection: 'row'
    },
    actions: {
      display: 'flex',
      justifyContent: 'end',
      gap: '12px',
      padding: "0 24px 24px"
    }
  };
});
var AssignFilter = function AssignFilter(props) {
  var _props$language = props.language,
    language = _props$language === void 0 ? LANG_EN : _props$language,
    filters = props.filters,
    _props$initialSelecti = props.initialSelections,
    initialSelections = _props$initialSelecti === void 0 ? INITIAL_SELECTIONS : _props$initialSelecti,
    _props$limit = props.limit,
    limit = _props$limit === void 0 ? 20 : _props$limit,
    onApply = props.onApply,
    children = props.children;
  var styles = useStyles$4();
  var _React$useState = React.useState(false),
    isOpen = _React$useState[0],
    setIsOpen = _React$useState[1];
  var _React$useState2 = React.useState(),
    typeAnchorEl = _React$useState2[0],
    setTypeAnchorEl = _React$useState2[1];
  var _React$useState3 = React.useState(0),
    viewing = _React$useState3[0],
    setViewing = _React$useState3[1];
  var _React$useState4 = React.useState(initialSelections),
    derivedState = _React$useState4[0],
    setDerivedState = _React$useState4[1];
  var _React$useState5 = React.useState(BRIDGE_INC),
    bridge = _React$useState5[0],
    setBridge = _React$useState5[1];
  var _React$useState6 = React.useState(INITIAL_DATA),
    data = _React$useState6[0],
    setData = _React$useState6[1];
  var _React$useState7 = React.useState(initialSelections),
    selections = _React$useState7[0],
    setSelections = _React$useState7[1];
  var selectedFilter = filters[viewing];
  var _React$useMemo = React.useMemo(function () {
      var totalInclude = 0;
      var totalExclude = 0;
      for (var _iterator = _createForOfIteratorHelperLoose(filters), _step; !(_step = _iterator()).done;) {
        var _selections$BRIDGE_IN, _selections$BRIDGE_IN2, _selections$BRIDGE_EX, _selections$BRIDGE_EX2;
        var filter = _step.value;
        var name = filter.fieldName;
        var includes = ((_selections$BRIDGE_IN = selections[BRIDGE_INC]) == null ? void 0 : (_selections$BRIDGE_IN2 = _selections$BRIDGE_IN[name]) == null ? void 0 : _selections$BRIDGE_IN2.length) || 0;
        var excludes = ((_selections$BRIDGE_EX = selections[BRIDGE_EXC]) == null ? void 0 : (_selections$BRIDGE_EX2 = _selections$BRIDGE_EX[name]) == null ? void 0 : _selections$BRIDGE_EX2.length) || 0;
        totalInclude += includes;
        totalExclude += excludes;
      }
      return [totalInclude, totalExclude];
    }, [selections, filters]),
    totalInclude = _React$useMemo[0],
    totalExclude = _React$useMemo[1];

  // NOTE(intrnl): the state is reset should `initialSelection` ever changes
  // value, `derivedState` keeps track of the derivation
  if (derivedState !== initialSelections) {
    setDerivedState(initialSelections);
    setData(INITIAL_DATA);
    setSelections(initialSelections);
    return;
  }
  var handleTypeSelectClick = function handleTypeSelectClick(ev) {
    setTypeAnchorEl(ev.currentTarget);
  };
  var handleTypeSelectClose = function handleTypeSelectClose() {
    setTypeAnchorEl(undefined);
  };
  var handleTypeSelectChange = function handleTypeSelectChange(next) {
    setBridge(next);
    setTypeAnchorEl(undefined);
  };
  var handleOpen = function handleOpen() {
    setIsOpen(true);
  };
  var handleClose = function handleClose() {
    setIsOpen(false);
  };
  var handleApply = function handleApply() {
    setIsOpen(false);
    if (onApply) {
      onApply(selections);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: handleOpen
  }, children), /*#__PURE__*/React.createElement(Dialog, {
    open: isOpen,
    onClose: handleClose,
    maxWidth: "lg",
    fullWidth: true,
    classes: {
      root: styles.dialog,
      paper: styles.paper
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleTypeSelectClick,
    className: styles.headerButton,
    endIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, bridge === BRIDGE_INC ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, intl[language].include), /*#__PURE__*/React.createElement("span", {
    className: styles.count
  }, totalInclude)) : bridge === BRIDGE_EXC ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, intl[language].exclude), /*#__PURE__*/React.createElement("span", {
    className: styles.count
  }, totalExclude)) : null), /*#__PURE__*/React.createElement(Menu, {
    open: !!typeAnchorEl,
    anchorEl: typeAnchorEl,
    onClose: handleTypeSelectClose
  }, /*#__PURE__*/React.createElement(MenuItem, {
    onClick: function onClick() {
      return handleTypeSelectChange(BRIDGE_INC);
    },
    className: styles.typeMenuItem
  }, /*#__PURE__*/React.createElement("span", null, intl[language].include), /*#__PURE__*/React.createElement("span", {
    className: styles.count + " " + styles.countInvert
  }, totalInclude)), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: function onClick() {
      return handleTypeSelectChange(BRIDGE_EXC);
    },
    className: styles.typeMenuItem
  }, /*#__PURE__*/React.createElement("span", null, intl[language].exclude), /*#__PURE__*/React.createElement("span", {
    className: styles.count + " " + styles.countInvert
  }, totalExclude))), /*#__PURE__*/React.createElement("div", {
    className: styles.grow
  }), /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleClose,
    edge: "end",
    color: "inherit"
  }, /*#__PURE__*/React.createElement(CloseIcon, null))), /*#__PURE__*/React.createElement(Tabs, {
    value: viewing,
    onChange: function onChange(ev, value) {
      return setViewing(value);
    },
    classes: {
      root: styles.tabs,
      indicator: styles.tabsIndicator
    }
  }, filters.map(function (item, idx) {
    var _selections$bridge, _selections$bridge$it;
    return /*#__PURE__*/React.createElement(Tab, {
      key: item.fieldName,
      value: idx,
      label: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, item.name), ((_selections$bridge = selections[bridge]) == null ? void 0 : (_selections$bridge$it = _selections$bridge[item.fieldName]) == null ? void 0 : _selections$bridge$it.length) > 0 && /*#__PURE__*/React.createElement("span", {
        className: styles.count
      }, selections[bridge][item.fieldName].length)),
      classes: {
        root: styles.tab,
        wrapper: styles.tabWrapper
      }
    });
  })), renderView(selectedFilter, {
    language: language,
    bridge: bridge,
    selections: selections,
    data: data,
    limit: limit,
    setSelections: setSelections,
    setData: setData
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClose
  }, intl[language].buttonCancel), /*#__PURE__*/React.createElement(Button, {
    onClick: handleApply,
    variant: "contained",
    color: "primary",
    disableElevation: true
  }, intl[language].buttonApply))));
};
var renderView = function renderView(filter, props) {
  switch (filter.type) {
    case 'checkbox':
      return filter.options.fetch ? /*#__PURE__*/React.createElement(RemoteCheckboxView, _extends({
        key: filter.fieldName,
        filter: filter
      }, props)) : /*#__PURE__*/React.createElement(LocalCheckboxView, _extends({
        key: filter.fieldName,
        filter: filter
      }, props));
    default:
      return null;
  }
};

var Flex = styled.div(["display:flex;flex-direction:", ";justify-content:", ";"], function (props) {
  return props.column ? 'column' : 'row';
}, function (props) {
  return props.between ? 'space-between' : props.around ? 'space-around' : props.center ? 'center' : props.end ? 'flex-end' : 'flex-start';
});
var FormControlLabelStyled = withStyles(function () {
  return {
    root: {
      padding: '1px 5px 2px 5px !important',
      margin: '5px 0px',
      borderRadius: '3px',
      minHeight: '35px',
      width: '100% !important',
      label: {
        margin: 0
      }
    }
  };
})(FormControlLabel);
var styles = {
  textBlackBold: {
    fontWeight: 'bold',
    color: '#000',
    fontSize: '14px'
  },
  textGrey: {
    color: '#A9A8A8'
  },
  textSmall: {
    fontSize: '12px'
  }
};

var _templateObject$1;
var PUT_OFF_QUESTION = gql(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["mutation($dailyMicrolearningId:String!,$to:DateTime!){microlearningPutoff(dailyMicrolearningId:$dailyMicrolearningId,to:$to){success}}"])));

var _templateObject;
var SUBMIT_DAILY_ANSWER = gql(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["mutation($memberAnswerId:String! $microlearningAnswerIds:[String!]! $description:String){microlearningSubmit(memberAnswerId:$memberAnswerId microlearningAnswerIds:$microlearningAnswerIds description:$description){id daily_answer_id question score microlearning_question_answers{id answer is_correct is_chosen}}}"])));

var PutOffDialog = function PutOffDialog(props) {
  var open = props.open,
    setOpen = props.setOpen,
    putOffTime = props.putOffTime,
    setPutOffTime = props.setPutOffTime,
    handleSubmit = props.handleSubmit,
    errorPutOff = props.errorPutOff,
    errorMessage = props.errorMessage;
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "alert-dialog-title"
  }, "Don't want to answer yet?"), /*#__PURE__*/React.createElement(DialogContent, {
    dividers: true
  }, /*#__PURE__*/React.createElement(Typography, null, "This question can only be answer today, please arrange another time to answer. Score will automatic 0 if you can't answer today"), /*#__PURE__*/React.createElement(Typography, {
    style: {
      margin: '20px 0 10px 0'
    }
  }, "Set Time", ' ', /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'red',
      fontStyle: 'italic',
      fontSize: '11px'
    }
  }, errorPutOff && !putOffTime ? '*This field is required' : errorPutOff && errorMessage ? errorMessage : '')), /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
    utils: DateFnsUtils
  }, /*#__PURE__*/React.createElement(TimePicker, {
    autoOk: true,
    value: putOffTime,
    onChange: function onChange(date) {
      return setPutOffTime(date);
    },
    inputVariant: "outlined"
  }))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setOpen(false);
    },
    color: "primary"
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return handleSubmit();
    },
    color: "primary",
    variant: "contained",
    style: {
      marginLeft: '8px'
    }
  }, "Confirm")));
};

var contextOrgStaff = {
  headers: {
    'X-Hasura-Role': 'organization-staff'
  }
};
function MicrolearningPopup() {
  var _question$microlearni, _question$microlearni2, _question$microlearni3, _question$microlearni4;
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  var _useState2 = useState(false),
    openSnackbar = _useState2[0],
    setOpenSnackbar = _useState2[1];
  var _useState3 = useState(false),
    openPutOff = _useState3[0],
    setOpenPutOff = _useState3[1];
  var _useState4 = useState(null),
    putOffTime = _useState4[0],
    setPutOffTime = _useState4[1];
  var _useState5 = useState(false),
    errorPutOff = _useState5[0],
    setErrorPutOFf = _useState5[1];
  var _useState6 = useState(''),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useState7 = useState(false),
    error = _useState7[0],
    setError = _useState7[1];
  var _useState8 = useState(''),
    message = _useState8[0],
    setMessage = _useState8[1];
  var _useState9 = useState(null),
    question = _useState9[0],
    setQuestion = _useState9[1];
  var _useState10 = useState([]),
    answers = _useState10[0],
    setAnswers = _useState10[1];
  var _useState11 = useState([]),
    answer = _useState11[0],
    setAnswer = _useState11[1];
  var _useState12 = useState(''),
    description = _useState12[0],
    setDescription = _useState12[1];
  var _useState13 = useState([]),
    optionCorrection = _useState13[0],
    setOptionCorrection = _useState13[1];
  var _useState14 = useState(false),
    loadingSubmit = _useState14[0],
    setLoadingSubmit = _useState14[1];
  var _useMutation = useMutation(SUBMIT_DAILY_ANSWER),
    mutationSubmitAnswer = _useMutation[0];
  var _useMutation2 = useMutation(PUT_OFF_QUESTION),
    mutationPutoff = _useMutation2[0];
  var _useQuery = useQuery(GET_MICRO_LEARNING_DAILY, {
      variables: {
        onlyAfterNow: true
      },
      context: contextOrgStaff
      // fetchPolicy: 'cache-and-network'
      // pollInterval: 500
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    refetch = _useQuery.refetch;
  useEffect(function () {
    if (data) {
      var _questions = [];
      data.microlearningDaily.map(function (val) {
        val.member_answers.map(function (ques) {
          _questions.push({
            daily_answer_id: val.daily_answer_id,
            microlearning: val.microlearning,
            questions: ques
          });
        });
      });
      if (_questions.length > 0) {
        var currentQuestion = _questions[0];
        if (currentQuestion.questions.question_type === 1) {
          var _answers = [];
          currentQuestion.questions.possible_answers.map(function (val) {
            _answers.push(_extends({}, val, {
              checked: false
            }));
          });
          setAnswers(_answers);
        }
        setQuestion(currentQuestion);
        setOpen(true);
      }
    }
  }, [data]);
  var countChecked = function countChecked() {
    var count = 0;
    if (answers.length > 0) {
      answers.map(function (val) {
        if (val.checked) {
          count++;
        }
      });
    }
    return count;
  };
  var handleSubmit = function handleSubmit() {
    var object = {
      memberAnswerId: question.questions.member_answer_id,
      description: description
    };
    if (question.questions.question_type === 0) {
      object = _extends({}, object, {
        microlearningAnswerIds: answer
      });
    } else {
      var _answers = [];
      answers.map(function (val) {
        if (val.checked) {
          _answers.push(val.id);
        }
      });
      object = _extends({}, object, {
        microlearningAnswerIds: _answers
      });
    }
    if (question.questions.question_type === 0 && answer.length === 0 || question.questions.question_type === 1 && countChecked() !== question.questions.correct_answer_count) {
      setError(true);
    } else {
      setLoadingSubmit(true);
      mutationSubmitAnswer({
        variables: object,
        context: contextOrgStaff
      }).then(function (res) {
        setMessage('Answer Submitted');
        setAnswer([]);
        setError(false);
        setOptionCorrection(res.data.microlearningSubmit.microlearning_question_answers);
      }).catch(function () {
        setMessage('Something went wrong');
      }).finally(function () {
        setOpenSnackbar(true);
        setLoadingSubmit(false);
      });
    }
  };
  var handleChangeAnswer = function handleChangeAnswer(answer_id) {
    var _answers = answer;
    _answers[0] = answer_id;
    setAnswer([].concat(_answers));
  };
  var handleChangeMultiple = function handleChangeMultiple(id) {
    return function (e) {
      var _answers = answers;
      var index = _answers.findIndex(function (item) {
        return item.id === id;
      });
      _answers[index] = _extends({}, _answers[index], {
        checked: e.target.checked
      });
      setAnswers([].concat(_answers));
    };
  };
  var handleSubmitPutOff = function handleSubmitPutOff() {
    if (putOffTime === null) {
      setErrorPutOFf(true);
    } else {
      var d = new Date(putOffTime);
      d.setUTCHours(d.getHours(), d.getMinutes(), 0, 0);
      var variables = {
        dailyMicrolearningId: question.daily_answer_id,
        to: d.toISOString()
      };
      mutationPutoff({
        variables: variables,
        context: contextOrgStaff
      }).then(function () {
        refetch();
        setMessage('Put Off Question Success');
        setOpenPutOff(false);
        setOpen(false);
        setErrorMessage('');
        setErrorPutOFf(false);
        setAnswer([]);
        setError(false);
        setOpen(false);
      }).catch(function (error) {
        setErrorMessage(error.message);
        setErrorPutOFf(true);
        setMessage(error.message);
      }).finally(function () {
        setOpenSnackbar(true);
      });
    }
  };
  var handleConfirm = function handleConfirm() {
    refetch();
    setOptionCorrection([]);
    setOpen(false);
  };
  var correctionComponent = function correctionComponent(val) {
    return /*#__PURE__*/React.createElement(Flex, {
      column: true,
      center: true,
      style: {
        marginLeft: '5px',
        width: '50px'
      }
    }, val.is_chosen ? val.is_correct ? /*#__PURE__*/React.createElement(CheckIcon, {
      style: {
        color: '#67ad5b',
        alignSelf: 'center'
      }
    }) : /*#__PURE__*/React.createElement(ClearIcon, {
      style: {
        color: '#ef4d5e',
        alignSelf: 'center'
      }
    }) : !val.is_chosen && val.is_correct ? /*#__PURE__*/React.createElement(CheckIcon, {
      style: {
        color: '#67ad5b',
        alignSelf: 'center'
      }
    }) : '');
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    maxWidth: "sm",
    fullWidth: true
  }, data && !loading && question && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DialogTitle, null, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Avatar, {
    src: question.microlearning.icon_url,
    variant: "rounded"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: '20px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    style: styles.textBlackBold
  }, question.microlearning.name), /*#__PURE__*/React.createElement(Typography, {
    style: _extends({}, styles.textGrey, styles.textSmall)
  }, question.microlearning.type === 'ORG' ? (_question$microlearni = question.microlearning) == null ? void 0 : (_question$microlearni2 = _question$microlearni.company_profile) == null ? void 0 : _question$microlearni2.brand_name : (_question$microlearni3 = question.microlearning) == null ? void 0 : (_question$microlearni4 = _question$microlearni3.owner) == null ? void 0 : _question$microlearni4.name)))), /*#__PURE__*/React.createElement(DialogContent, {
    dividers: true
  }, /*#__PURE__*/React.createElement(Typography, {
    style: _extends({}, styles.textBlackBold, {
      marginBottom: '10px'
    })
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: question.questions.question
    }
  }), ' ', question.questions.question_type === 1 && countChecked() !== question.questions.correct_answer_count && error && /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'red',
      fontSize: '13px',
      fontWeight: 'normal'
    }
  }, "* Please choose ", question.questions.correct_answer_count, ' ', "answers"), question.questions.question_type === 0 && answer.length === 0 && error && /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'red',
      fontSize: '13px',
      fontWeight: 'normal'
    }
  }, "* Please choose the answer")), loadingSubmit ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      margin: '25px 0px'
    }
  }, /*#__PURE__*/React.createElement(CircularProgress, null)) : question.questions.question_type === 0 ? /*#__PURE__*/React.createElement(RadioGroup, {
    name: "answer",
    value: optionCorrection.length > 0 ? '' : answer[0],
    onChange: function onChange(e) {
      return optionCorrection.length > 0 ? null : handleChangeAnswer(e.target.value);
    },
    style: {
      marginBottom: '20px'
    }
  }, optionCorrection.length > 0 ? optionCorrection.map(function (val, key) {
    return /*#__PURE__*/React.createElement(Flex, {
      between: true,
      key: key
    }, /*#__PURE__*/React.createElement(FormControlLabelStyled, {
      checked: val.is_chosen,
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary"
      }),
      label: val.answer,
      style: {
        border: "1px solid " + (val.is_chosen ? val.is_correct ? '#67ad5b' : '#dd5962' : !val.is_chosen && val.is_correct ? '#67ad5b' : '#0000001F')
      }
    }), correctionComponent(val));
  }) : question.questions.possible_answers.map(function (val) {
    return /*#__PURE__*/React.createElement(FormControlLabelStyled, {
      key: val.id,
      value: val.id,
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary"
      }),
      label: val.answer,
      style: {
        border: '1px solid #0000001F'
      }
    });
  })) : /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '20px',
      display: 'flex',
      flexDirection: 'column'
    }
  }, optionCorrection.length > 0 ? optionCorrection.map(function (val, key) {
    return /*#__PURE__*/React.createElement(Flex, {
      between: true,
      key: key
    }, /*#__PURE__*/React.createElement(FormControlLabelStyled, {
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: val.is_chosen,
        name: "checkedB",
        color: "primary",
        disabled: true
      }),
      label: val.answer,
      style: {
        width: '100% !important',
        border: "1px solid " + (val.is_chosen ? val.is_correct ? '#67ad5b' : '#dd5962' : !val.is_chosen && val.is_correct ? '#67ad5b' : '#0000001F')
      }
    }), correctionComponent(val));
  }) : answers.map(function (val, key) {
    return /*#__PURE__*/React.createElement(FormControlLabelStyled, {
      key: key,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: val.checked,
        onChange: handleChangeMultiple(val.id),
        name: "checkedB",
        color: "primary"
      }),
      label: val.answer
    });
  })), /*#__PURE__*/React.createElement(Typography, {
    style: _extends({}, styles.textGrey, styles.textSmall)
  }, "Description"), /*#__PURE__*/React.createElement(TextField, {
    multiline: true,
    rows: 4,
    placeholder: "Tell your mentor the explanation",
    variant: "outlined",
    fullWidth: true,
    style: {
      marginTop: '10px'
    },
    onChange: function onChange(e) {
      return setDescription(e.target.value);
    }
  })), /*#__PURE__*/React.createElement(DialogActions, null, optionCorrection.length === 0 && /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setOpenPutOff(true);
    },
    color: "primary",
    disabled: loadingSubmit
  }, "Put off"), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return optionCorrection.length > 0 ? handleConfirm() : handleSubmit();
    },
    color: "primary",
    variant: "contained",
    style: {
      marginLeft: '8px'
    },
    disabled: loadingSubmit
  }, optionCorrection.length > 0 ? 'Confirm' : 'Submit'))), /*#__PURE__*/React.createElement(Snackbar, {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    autoHideDuration: 4000,
    open: openSnackbar,
    onClose: function onClose() {
      return setOpenSnackbar(false);
    },
    message: message
  }), /*#__PURE__*/React.createElement(PutOffDialog, {
    open: openPutOff,
    setOpen: setOpenPutOff,
    putOffTime: putOffTime,
    setPutOffTime: setPutOffTime,
    handleSubmit: handleSubmitPutOff,
    errorPutOff: errorPutOff,
    errorMessage: errorMessage
  }));
}

var header = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='29.291' height='29.292'%3e%3cpath d='M0 0h29.292v29.292H0z' data-name='Path 477' style='fill:none'/%3e%3cpath d='M4 8.882h4.882V4H4zm7.323 14.646H16.2v-4.882h-4.877zm-7.323 0h4.882v-4.882H4zM4 16.2h4.882v-4.877H4zm7.323 0H16.2v-4.877h-4.877zM18.646 4v4.882h4.882V4zm-7.323 4.882H16.2V4h-4.877zm7.323 7.318h4.882v-4.877h-4.882zm0 7.323h4.882v-4.877h-4.882z' data-name='Path 478' transform='translate(.882 .882)' style='fill:%23014a62'/%3e%3c/svg%3e";

var GlobalSidebarContainer = styled.div(["display:flex;width:290px;flex-direction:column;border-radius:5px;font-family:muli;box-shadow:rgba(0,0,0,0.2) 0px 3px 6px 0px;background-color:#ffffff;padding-bottom:14px;@media (max-width:850px){display:none;}"]);
var ListItemContainer = styled.a(["display:flex;flex-direction:row;align-items:center;cursor:", ";text-decoration:none;padding:14px 20px;font-family:muli;color:", " !important;font-size:14px;font-weight:600;&:hover{background:#f7f8f9;}"], function (props) {
  return props.disable ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.color || '#1b1d1f';
});
var HCTitleLabel = styled.label(["margin-left:20px;cursor:pointer;"]);
var NotifIcon = styled(NotificationsNoneOutlined)(["color:#014a62;@media (max-width:1200px){margin:0 2px 0 -2px;}"]);

var analytic = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20'%3e%3cpath fill='none' d='M0 0h20v20H0z'/%3e%3cpath fill='%23014a62' d='m2.917 15.409 5-5.008 3.333 3.333 7.083-7.967-1.174-1.175-5.908 6.642L7.917 7.9l-6.25 6.259z'/%3e%3c/svg%3e";

var businessTrip = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='20.456' height='21.533'%3e%3cpath data-name='Path 14' d='M22.456 17.073V14.92l-8.613-5.384V3.615a1.615 1.615 0 1 0-3.23 0v5.921L2 14.92v2.153l8.613-2.692V20.3L8.46 21.918v1.615l3.768-1.077L16 23.533v-1.615L13.843 20.3v-5.919z' style='fill:%23024c62' transform='translate(-2 -2)'/%3e%3c/svg%3e";

var business = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3e%3cpath d='M0 0h24v24H0z' data-name='Path 459' style='fill:none'/%3e%3cpath d='M12 7V3H2v18h20V7zM6 19H4v-2h2zm0-4H4v-2h2zm0-4H4V9h2zm0-4H4V5h2zm4 12H8v-2h2zm0-4H8v-2h2zm0-4H8V9h2zm0-4H8V5h2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8zm-2-8h-2v2h2zm0 4h-2v2h2z' data-name='Path 460' style='fill:%23014a62'/%3e%3c/svg%3e";

var digidoc = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' height='24' width='24' fill='white'%3e%3cpath d='M0 0h24v24H0z' fill='none'/%3e%3cpath d='M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z' fill='%23014a62'/%3e%3c/svg%3e";

var finance = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='10.18' height='18'%3e%3cpath d='M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21A3.986 3.986 0 0 0 13 5.19V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z' transform='translate(-6.32 -3)' style='fill:%23014a62'/%3e%3c/svg%3e";

var group = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' id='Icon_-_Group' width='20' height='20'%3e%3cdefs%3e%3cstyle%3e.cls-2%7bfill:%23014a62%7d%3c/style%3e%3c/defs%3e%3cpath id='Path_1106' fill='none' d='M0 0h20v20H0z'/%3e%3cpath id='Path_1107' d='M10.333 2a8.333 8.333 0 1 0 8.333 8.333A8.336 8.336 0 0 0 10.333 2zm0 15A6.667 6.667 0 1 1 17 10.333 6.676 6.676 0 0 1 10.333 17z' class='cls-2' transform='translate(-.333 -.333)'/%3e%3ccircle id='Ellipse_79' cx='1.667' cy='1.667' r='1.667' class='cls-2' transform='translate(5 10)'/%3e%3ccircle id='Ellipse_80' cx='1.667' cy='1.667' r='1.667' class='cls-2' transform='translate(8.333 5)'/%3e%3ccircle id='Ellipse_81' cx='1.667' cy='1.667' r='1.667' class='cls-2' transform='translate(11.667 10)'/%3e%3c/svg%3e";

var jobPortal = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='20' height='19'%3e%3cpath d='M20 6h-3V4a1.993 1.993 0 0 0-2-2H9a1.993 1.993 0 0 0-2 2v2H4a1.993 1.993 0 0 0-2 2v11a1.993 1.993 0 0 0 2 2h16a1.993 1.993 0 0 0 2-2V8a1.993 1.993 0 0 0-2-2zM9 4h6v2H9zm11 15H4v-2h16zm0-5H4V8h3v2h2V8h6v2h2V8h3z' transform='translate(-2 -2)' style='fill:%23014a62'/%3e%3c/svg%3e";

var learning = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20'%3e%3cpath fill='none' d='M0 0h20v20H0z'/%3e%3cpath fill='%23014a62' d='m10 2.5-9.167 5 3.333 1.817v5L10 17.5l5.833-3.183v-5l1.667-.908v5.758h1.667V7.5zm5.683 5L10 10.6 4.316 7.5l5.683-3.1zm-1.517 5.825L10 15.6l-4.167-2.275v-3.1L10 12.5l4.167-2.275v3.1z'/%3e%3c/svg%3e";

var performance = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3e%3cpath d='M0 0h24v24H0z' data-name='Path 469' style='fill:none'/%3e%3cpath d='M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z' data-name='Path 470' style='fill:%23014a62'/%3e%3c/svg%3e";

var support = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20'%3e%3cpath fill='none' d='M0 0h20v20H0z'/%3e%3cpath fill='%23014a62' d='M15.833 11.666v3.333h-1.666v-3.333h1.667m-10 0v3.333H5a.836.836 0 0 1-.833-.833v-2.5h1.666M10 .833a7.5 7.5 0 0 0-7.5 7.5v5.833a2.5 2.5 0 0 0 2.5 2.5h2.5V10H4.167V8.333a5.833 5.833 0 1 1 11.667 0V10H12.5v6.667h3.333v.833H10v1.667h5a2.5 2.5 0 0 0 2.5-2.5V8.333a7.5 7.5 0 0 0-7.5-7.5z'/%3e%3c/svg%3e";

var talent = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3e%3cpath d='M0 0h24v24H0z' data-name='Path 465' style='fill:none'/%3e%3cpath d='M9 12a3.5 3.5 0 1 0-3.5-3.5A3.5 3.5 0 0 0 9 12zm0-5a1.5 1.5 0 1 1-1.5 1.5A1.5 1.5 0 0 1 9 7zm.05 10H4.77A10.374 10.374 0 0 1 9 16c.11 0 .23.01.34.01a4.58 4.58 0 0 1 1.64-1.81A11.726 11.726 0 0 0 9 14c-2.34 0-7 1.17-7 3.5V19h7v-1.5a2.734 2.734 0 0 1 .05-.5zm7.45-2.5c-1.84 0-5.5 1.01-5.5 3V19h11v-1.5c0-1.99-3.66-3-5.5-3zm1.21-1.82a2.5 2.5 0 1 0-2.42 0 2.448 2.448 0 0 0 2.42 0z' data-name='Path 466' style='fill:%23014a62'/%3e%3c/svg%3e";

var time = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='10' height='11.7' viewBox='0 0 20.029 23.367'%3e%3cpath d='M16.353 1H9.677v2.226h6.677zM11.9 15.466h2.226V8.789H11.9zm8.935-7.355 1.58-1.58a12.294 12.294 0 0 0-1.569-1.569l-1.58 1.58a10.014 10.014 0 1 0 1.569 1.569zm-7.82 14.031a7.789 7.789 0 1 1 7.785-7.789 7.784 7.784 0 0 1-7.785 7.789z' transform='translate(-3.001 -1.001)' style='fill:%23014a62'/%3e%3c/svg%3e";

var vendor = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' id='Vendor' width='20' height='20'%3e%3cdefs%3e%3cstyle%3e.cls-1%7bfill:none%7d%3c/style%3e%3c/defs%3e%3cpath id='Path_1210' d='M0 0h20v20H0z' class='cls-1'/%3e%3cg id='storefront-24px_3_'%3e%3cg id='Group_3697'%3e%3cpath id='Rectangle_1944' d='M0 0h20v20H0z' class='cls-1'/%3e%3c/g%3e%3c/g%3e%3cg id='Group_3698' transform='translate(1.671 2.5)'%3e%3cg id='Group_3698-2'%3e%3cpath id='Path_1229' fill='%23014a62' d='m18.584 7.908-.875-3.642A1.637 1.637 0 0 0 16.118 3H4.543a1.636 1.636 0 0 0-1.584 1.267l-.875 3.641a2.813 2.813 0 0 0 .517 2.4 3.2 3.2 0 0 0 .233.242v5.783A1.672 1.672 0 0 0 4.5 18h11.668a1.672 1.672 0 0 0 1.667-1.667V10.55a3.083 3.083 0 0 0 .233-.233 2.8 2.8 0 0 0 .516-2.409zm-2.492-3.25.876 3.642a1.13 1.13 0 0 1-.208.975.978.978 0 0 1-.783.392 1.042 1.042 0 0 1-1.008-.95l-.483-4.05zm-4.925.008H12.8l.45 3.767a1.12 1.12 0 0 1-.275.892.994.994 0 0 1-.792.342 1.06 1.06 0 0 1-1.017-1.092zM7.409 8.433l.458-3.767H9.5v3.909a1.071 1.071 0 0 1-1.074 1.092 1 1 0 0 1-.742-.342 1.184 1.184 0 0 1-.275-.892zM3.7 8.3l.842-3.633h1.642L5.7 8.717a1.048 1.048 0 0 1-1.008.95.959.959 0 0 1-.775-.392A1.1 1.1 0 0 1 3.7 8.3zm.8 8.033v-5.025a1.509 1.509 0 0 0 .192.025 2.608 2.608 0 0 0 1.867-.792 2.68 2.68 0 0 0 1.925.792 2.642 2.642 0 0 0 1.858-.775 2.731 2.731 0 0 0 1.908.775 2.646 2.646 0 0 0 1.867-.792 2.608 2.608 0 0 0 1.867.792 1.509 1.509 0 0 0 .192-.025v5.025z' transform='translate(-2.005 -3)'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

var hasModule = function hasModule(data, moduleName) {
  var _data$company_module_, _data$company_module_2;
  return (data == null ? void 0 : (_data$company_module_ = data.company_module_settings) == null ? void 0 : _data$company_module_.length) === 0 || (data == null ? void 0 : (_data$company_module_2 = data.company_module_settings) == null ? void 0 : _data$company_module_2.some(function (o) {
    return o.global_module.name === moduleName;
  }));
};
function getCookie(cName) {
  if (document.cookie.length > 0) {
    var cStart = document.cookie.indexOf(cName + '=');
    if (cStart !== -1) {
      cStart = cStart + cName.length + 1;
      var cEnd = document.cookie.indexOf(';', cStart);
      if (cEnd === -1) {
        cEnd = document.cookie.length;
      }
      return unescape(document.cookie.substring(cStart, cEnd));
    }
  }
  return '';
}
var getUserData = function getUserData() {
  if (getCookie('userData') !== '' && getCookie('userData') !== 'undefined') {
    return JSON.parse(getCookie('userData'));
  }
  return {};
};
var setCookie = function setCookie(cname, cvalue, exdays, REACT_APP_DOMAIN) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  var domain = REACT_APP_DOMAIN;
  document.cookie = cname + '=' + cvalue + ';' + expires + ';domain=' + domain + ';path=/';
};
var parseFormat = function parseFormat(date, full, language) {
  if (language === void 0) {
    language = 'english';
  }
  var _date = new Date(date);
  var options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  var fullOptions = {
    dateStyle: 'full',
    timeStyle: 'long'
  };
  var _indonesianDate = new Intl.DateTimeFormat('id-ID', full ? fullOptions : options).format(_date);
  var indonesianDate = _indonesianDate.toString('dddd dd MMM');
  var defaultDate = date && format(parseISO(date), full ? 'MMM d, yyyy hh:mm a' : 'MMM d, yyyy');
  return language === 'indonesian' ? indonesianDate : defaultDate;
};
var formatDate = function formatDate(date) {
  return format(date, 'yyyy-MM-dd');
};
var isObjectEmpty = function isObjectEmpty(object) {
  return object === undefined || object.length === 0;
};
var englishToIndo = function englishToIndo(subject, word, language) {
  if (language === 'indonesian') {
    return word + " " + subject;
  } else {
    return subject + "'s " + word;
  }
};

/**
 * array1 = [1, 2, 3]
 * array2 = [1, 4, 5]
 * return true
 *
 * array1 = [1, 2, 3]
 * array2 = [4, 5]
 * return false
 */
var isSubset = function isSubset(array1, array2) {
  if (array1 === void 0) {
    array1 = [];
  }
  if (array2 === void 0) {
    array2 = [];
  }
  if (array1.length === 0 || array2.length === 0) {
    return false;
  }
  for (var i = 0; i < array2.length; i++) {
    if (array1.includes(array2[i])) {
      return true;
    }
  }
  return false;
};
var DEFAULT_ADMIN_ROLE = ['organization-hr-admin', 'organization-administrator'];
var isAdministrator = function isAdministrator(language) {
  if (language === 'english') return true;
  var userData = getUserData();
  var isAdmin = isSubset(userData == null ? void 0 : userData.roles, DEFAULT_ADMIN_ROLE);
  return isAdmin;
};

function ListItem(_ref) {
  var _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_blank' : _ref$target,
    _ref$rel = _ref.rel,
    rel = _ref$rel === void 0 ? 'noopener noreferrer' : _ref$rel,
    _ref$hideMenu = _ref.hideMenu,
    hideMenu = _ref$hideMenu === void 0 ? [] : _ref$hideMenu,
    env = _ref.env,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'english' : _ref$language,
    supportLink = _ref.supportLink;
  var userData = getUserData();
  var companyId = userData.company_id;
  var _GetModularSettings = GetModularSettings(companyId),
    data = _GetModularSettings.data;

  // item[obj] yang tidak mempunyai element `hidden` berarti mandatory
  var item = [{
    to: (env.SOSMED_URL || env.REACT_APP_SOSMED) + '/page-under-development',
    logo: analytic,
    label: {
      english: 'Knowledge & Analytic',
      indonesian: 'Pengetahuan & Analitik'
    },
    hidden: true
  }, {
    to: (env.SOSMED_URL || env.REACT_APP_SOSMED) + "/company/" + companyId + "/detail",
    logo: business,
    label: {
      english: 'Company',
      indonesian: 'Instansi'
    }
  }, {
    to: env.USER_URL + 'digital-document',
    logo: digidoc,
    label: {
      english: 'Digital Document',
      indonesian: 'Dokumen Digital'
    }
  }, {
    to: env.USER_URL + 'attendance',
    logo: time,
    label: {
      english: 'Time',
      indonesian: 'Kehadiran'
    },
    hidden: !hasModule(data, 'time')
  }, {
    to: env.PERFORMANCE_URL,
    logo: performance,
    label: {
      english: 'Performance',
      indonesian: 'Kinerja'
    },
    hidden: !hasModule(data, 'performance')
  }, {
    to: env.LEARNING_URL,
    logo: learning,
    label: {
      english: 'Learning',
      indonesian: 'Pembelajaran'
    },
    hidden: !hasModule(data, 'learning')
  }, {
    to: env.TALENT_URL,
    logo: talent,
    label: {
      english: 'Talent',
      indonesian: 'Talenta'
    },
    hidden: !hasModule(data, 'talent')
  }, {
    to: (env.SOSMED_URL || env.REACT_APP_SOSMED) + '/page-under-development',
    logo: jobPortal,
    label: {
      english: 'Job Portal',
      indonesian: 'Portal Pekerjaan'
    },
    hidden: true
  }, {
    to: env.USER_URL + 'trip',
    logo: businessTrip,
    label: {
      english: 'Business Trip',
      indonesian: 'Perjalanan Bisnis'
    },
    hidden: !hasModule(data, 'business_trip')
  }, {
    to: env.USER_URL + 'bank-and-tax',
    logo: finance,
    label: {
      english: 'Financial',
      indonesian: 'Keuangan'
    },
    hidden: !hasModule(data, 'financial')
  }, {
    to: env.VENDOR_URL,
    logo: vendor,
    label: {
      english: 'Vendor',
      indonesian: 'Penjual'
    },
    hidden: !hasModule(data, 'vendor')
  }, {
    to: (env.SOSMED_URL || env.REACT_APP_SOSMED) + '/group',
    logo: group,
    label: {
      english: 'Group',
      indonesian: 'Grup'
    }
  }, {
    to: supportLink || 'https://web.whatsapp.com/send?phone=6285162976397',
    logo: support,
    label: {
      english: 'Support',
      indonesian: 'Bantuan'
    }
  }];
  return item.filter(function (itm) {
    return !hideMenu.includes(itm.label.english);
  }).map(function (_ref2, i) {
    var to = _ref2.to,
      logo = _ref2.logo,
      label = _ref2.label,
      _ref2$disable = _ref2.disable,
      disable = _ref2$disable === void 0 ? false : _ref2$disable,
      hidden = _ref2.hidden;
    return !hidden && /*#__PURE__*/React.createElement(ListItemContainer, {
      key: "" + i,
      href: disable ? '/' : to,
      target: target,
      rel: rel,
      disable: disable
    }, /*#__PURE__*/React.createElement("img", {
      src: logo,
      style: {
        height: 20,
        width: 20,
        objectFit: 'contain'
      }
    }), /*#__PURE__*/React.createElement(HCTitleLabel, {
      style: {
        cursor: "" + (disable && 'not-allowed')
      }
    }, label[language]));
  });
}

function GlobalSidebar(props) {
  var _props$language = props.language,
    language = _props$language === void 0 ? 'english' : _props$language;
  var FLEX_ROW = {
    display: 'flex',
    flexDirection: 'row'
  };
  var customStyle = {
    HCHeadingLabel: {
      color: '#1b1d1f',
      fontWeight: 'bold',
      fontSize: 21,
      marginLeft: '7.3px'
    }
  };
  var headerTitle = {
    english: 'Modules',
    indonesian: 'Modul'
  };
  return /*#__PURE__*/React.createElement(GlobalSidebarContainer, null, /*#__PURE__*/React.createElement("div", {
    style: _extends({}, FLEX_ROW, {
      margin: '12px 18px 3.8px 25px',
      alignItems: 'center',
      paddingBottom: '6px'
    })
  }, /*#__PURE__*/React.createElement("img", {
    src: header,
    style: {
      width: '20px',
      height: '20px'
    },
    alt: "outline-apps-icon"
  }), /*#__PURE__*/React.createElement("label", {
    style: customStyle.HCHeadingLabel
  }, headerTitle[language])), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginBottom: 6
    }
  }), /*#__PURE__*/React.createElement(ListItem, props));
}

var HolidayContainer = styled(Paper)(["width:", ";padding:", ";.title-wrapper{display:flex;align-items:center;margin-bottom:13px;}.icons{margin-right:12px;}.divider{margin-bottom:15px;}.color-label{border-radius:5px;width:8px;margin-right:16px;}.category{font-weight:600;margin-bottom:4px;-webkit-line-clamp:2;}.ellipsis-text{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;}.text-date{-webkit-line-clamp:1;}.bold{font-weight:600;}.grey{color:#a9a8a8;}.button-wrapper{display:flex;justify-content:center;}.left-icon{margin-right:24px;}.page-icon{background:#014a62;border-radius:5px;color:white;cursor:pointer;width:35px;height:30px;}.disable-page-icon{padding:6px;border-radius:5px;border:1.5px solid #a9a8a8;color:#a9a8a8;}.content{height:227px;overflow-x:auto;}.no-event{text-align:center;vertical-align:middle;}.mih-220{min-height:220px;}.center{display:flex;justify-content:center;align-items:center;}.content::-webkit-scrollbar{width:8px;}.content::-webkit-scrollbar-thumb{background:#a9a8a8;border-radius:10px;}.mb-6{margin-bottom:6px;}.span-skeleton{margin-bottom:10px;display:block;}.info{width:fit-content;}"], function (props) {
  return props.width || '290px';
}, function (props) {
  return props.padding || '12.3px';
});

var word$3 = {
  calendar: {
    english: 'Calendar',
    indonesian: 'Kalender'
  },
  noEvent: {
    english: 'No Event for',
    indonesian: 'Tidak Ada Kegiatan untuk'
  },
  allDay: {
    english: 'All Day',
    indonesian: 'Sepanjang Hari'
  },
  halfDay: {
    english: "Half Day",
    indonesian: "Setengah Hari"
  },
  businnesTrip: {
    english: 'Business Trip',
    indonesian: 'Perjalanan Bisnis'
  }
};

var HolidayData = function HolidayData(props) {
  var name = props.name,
    date = props.date,
    color = props.color;
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: name + ' (' + date + ')'
  }, /*#__PURE__*/React.createElement("div", {
    className: "title-wrapper",
    style: {
      alignItems: 'normal'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "color-label",
    style: {
      background: color
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "info"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: "category ellipsis-text"
  }, name), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: "grey text-date ellipsis-text"
  }, date))));
};
var HolidayLoading = function HolidayLoading(_ref) {
  var _ref$count = _ref.count,
    count = _ref$count === void 0 ? 2 : _ref$count;
  return /*#__PURE__*/React.createElement("div", {
    className: "mih-220"
  }, Array.from({
    length: count
  }).map(function (res, i) {
    return /*#__PURE__*/React.createElement(Skeleton, {
      key: i,
      count: 2,
      className: "mb-6",
      containerClassName: "span-skeleton"
    });
  }));
};
var HolidayNoData = function HolidayNoData(_ref2) {
  var date = _ref2.date,
    language = _ref2.language;
  return /*#__PURE__*/React.createElement("div", {
    className: "mih-220 center"
  }, /*#__PURE__*/React.createElement(Typography, {
    className: "grey text-16 no-event"
  }, word$3.noEvent[language], " ", parseFormat(date, false, language)));
};

function useGetCalendar(company, self, language) {
  var _useState = useState(formatDate(new Date())),
    date = _useState[0],
    setDate = _useState[1];
  var _useState2 = useState({}),
    dataCalendar = _useState2[0],
    setDataCalendar = _useState2[1];
  var _useQuery = useQuery(GET_TRIP_WIDGET, {
      variables: {
        company: company,
        date_start_bt: date + " 00:00:00",
        date_end_bt: date + " 23:59:59"
      },
      context: {
        headers: {
          'X-Hasura-Role': 'user'
        }
      },
      fetchPolicy: 'cache-and-network',
      skip: !company || !self,
      onCompleted: function onCompleted(data) {
        return setDataCalendar(function (prev) {
          return _extends({}, prev, data);
        });
      }
    }),
    loadingTrip = _useQuery.loading;
  var _useQuery2 = useQuery(GET_TIME_WIDGET, {
      variables: {
        company: company,
        self: self,
        date_start_holiday: date,
        date_end_holiday: date,
        date_start_event: date + " 00:00:00",
        date_end_event: date + " 23:59:59",
        date_start_leave: date,
        date_end_leave: date,
        date_start_todo: date + " 00:00:00",
        date_end_todo: date + " 23:59:59"
      },
      context: {
        headers: {
          'X-Hasura-Role': 'public'
        }
      },
      fetchPolicy: 'cache-and-network',
      skip: !company || !self,
      onCompleted: function onCompleted(data) {
        return setDataCalendar(function (prev) {
          return _extends({}, prev, data);
        });
      }
    }),
    loading = _useQuery2.loading;
  var result = useMemo(function () {
    var _data = [];
    var _loop = function _loop(el) {
      dataCalendar[el].forEach(function (res) {
        var _res$people_work_plac, _res$people_work_plac2, _res$time_leave_polic, _res$people_work_plac3, _res$people_work_plac4;
        var name = res.title;
        var date;
        var color;
        switch (el) {
          case 'holiday':
            color = '#EF4D5E';
            name = res.name;
            date = parseFormat(res.date);
            break;
          case 'leave':
            color = '#FFA000';
            name = ((_res$people_work_plac = res.people_work_placement) == null ? void 0 : (_res$people_work_plac2 = _res$people_work_plac.global_user) == null ? void 0 : _res$people_work_plac2.name) + "'s " + ((_res$time_leave_polic = res.time_leave_policy_child) == null ? void 0 : _res$time_leave_polic.name);
            date = (res.dateend === res.datestart ? parseFormat(res.datestart) : parseFormat(res.datestart) + " - " + parseFormat(res.dateend)) + ", " + (res.is_half ? word$3.halfDay[language] : word$3.allDay[language]);
            break;
          case 'event':
            color = '#4CAF50';
            date = parseFormat(res.start_date, true) + " - " + parseFormat(res.end_date, true);
            break;
          case 'trip':
            color = '#874caf';
            name = englishToIndo((_res$people_work_plac3 = res.people_work_placement) == null ? void 0 : (_res$people_work_plac4 = _res$people_work_plac3.global_user) == null ? void 0 : _res$people_work_plac4.name, word$3.businnesTrip[language], language);
            date = "" + (res.date_end === res.date_start ? parseFormat(res.date_start) : parseFormat(res.date_start) + " - " + parseFormat(res.date_end));
            break;
          case 'todo':
            color = '#039BE5';
            date = parseFormat(res.date, true);
            break;
        }
        _data.push({
          name: name,
          date: date,
          color: color
        });
      });
    };
    for (var el in dataCalendar) {
      _loop(el);
    }
    return _data;
  }, [dataCalendar]);
  var handlePage = function handlePage(page) {
    var _date = new Date(date);
    var newDate = (page === 'back' ? subDays : addDays)(_date, 1);
    setDate(formatDate(newDate));
  };
  return {
    date: date,
    data: result,
    loading: loading || loadingTrip,
    nextDate: function nextDate() {
      return handlePage();
    },
    previousDate: function previousDate() {
      return handlePage('back');
    }
  };
}

function WidgetHoliday(_ref) {
  var company = _ref.company,
    self = _ref.self,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'english' : _ref$language;
  var _useGetCalendar = useGetCalendar(company, self, language),
    data = _useGetCalendar.data,
    loading = _useGetCalendar.loading,
    date = _useGetCalendar.date,
    nextDate = _useGetCalendar.nextDate,
    previousDate = _useGetCalendar.previousDate;
  return /*#__PURE__*/React.createElement(HolidayContainer, null, /*#__PURE__*/React.createElement("div", {
    className: "title-wrapper"
  }, /*#__PURE__*/React.createElement(TodayIcon, {
    color: "primary",
    className: "icons"
  }), /*#__PURE__*/React.createElement(Typography, {
    className: "bold"
  }, word$3.calendar[language])), /*#__PURE__*/React.createElement(Divider, {
    className: "divider"
  }), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, loading ? /*#__PURE__*/React.createElement(HolidayLoading, null) : data.length === 0 ? /*#__PURE__*/React.createElement(HolidayNoData, {
    date: date,
    language: language
  }) : data.map(function (res, i) {
    return /*#__PURE__*/React.createElement(HolidayData, {
      key: i,
      name: res.name,
      date: res.date,
      color: res.color
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "button-wrapper"
  }, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    className: "left-icon page-icon",
    onClick: previousDate
  }), /*#__PURE__*/React.createElement(ChevronRightIcon, {
    className: "page-icon",
    onClick: nextDate
  })));
}

var NoConnSVG = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3e%3cdefs%3e%3cclipPath id='clip-path'%3e%3cpath d='m580.24 151.62-27.87 40.07a6.62 6.62 0 0 0 4.5 10.32l25.55 3.62a6.63 6.63 0 0 0 6.29-2.68l29.22-40.57a6.61 6.61 0 0 0-4.6-10.43l-26.9-3.12a6.61 6.61 0 0 0-6.19 2.79Z' style='fill:none'/%3e%3c/clipPath%3e%3cstyle%3e.cls-3%7bfill:%23f5f5f5%7d.cls-4%7bfill:%23014a62%7d.cls-5%7bfill:%23e1e1e1%7d.cls-14%2c.cls-15%2c.cls-6%7bfill:%23024a62%7d.cls-7%7bfill:%23ffdab8%7d.cls-8%7bfill:%23273236%7d.cls-9%7bfill:%23efd1ce%7d.cls-14%2c.cls-15%2c.cls-9%7bmix-blend-mode:multiply%7d.cls-15%7bopacity:.5%7d.cls-11%7bfill:%23252e35%7d.cls-12%7bfill:%238fd5e5%7d%3c/style%3e%3c/defs%3e%3cg style='isolation:isolate'%3e%3cg id='no_internet' data-name='no internet'%3e%3cpath class='cls-3' d='M265.84 333.94h-31v-6.87a6.88 6.88 0 0 0-6.88-6.88H151.5a6.88 6.88 0 0 0-6.88 6.88v6.87h-4.53a6.88 6.88 0 0 0-6.88 6.88 6.87 6.87 0 0 0 6.88 6.87h125.75a6.86 6.86 0 0 0 6.87-6.87 6.87 6.87 0 0 0-6.87-6.88ZM459.42 144.49h-62v-2.65a15.71 15.71 0 0 0-15.71-15.72H297a15.72 15.72 0 0 0-15.71-15.51h-59.2a15.72 15.72 0 0 0-15.72 15.72v18.16h-28a15.72 15.72 0 0 0 0 31.44h281.05a15.72 15.72 0 0 0 0-31.44ZM821.18 277.56h-14.35v-5.9a6.77 6.77 0 0 0-6.77-6.77h-15.52V263a6.78 6.78 0 0 0-6.78-6.77h-43.49a6.77 6.77 0 0 0-6.77 6.77v1.89H622.94a6.77 6.77 0 0 0-6.77 6.77v5.9h-25.28a6.77 6.77 0 1 0 0 13.54h230.29a6.77 6.77 0 1 0 0-13.54Z'/%3e%3cpath class='cls-4' d='M288.28 353.79c6.53-7.46 13.18-14.8 19.77-22.21l9.95-11 10-11c3.35-3.65 6.61-7.38 9.91-11.08s6.72-7.27 10.29-10.71 7.21-6.79 10.95-10.07 7.56-6.46 11.61-9.43l.44.42c-2.82 4.16-5.88 8.09-9 11.94s-6.36 7.63-9.68 11.31-6.76 7.24-10.33 10.66-7.19 6.82-10.72 10.3l-10.61 10.4-10.66 10.35c-7.16 6.84-14.26 13.75-21.48 20.54ZM216.72 522c6.53-7.46 13.17-14.8 19.76-22.21l10-11 10-11c3.35-3.65 6.62-7.38 9.91-11.08s6.72-7.27 10.29-10.71 7.21-6.8 11-10.07 7.56-6.47 11.62-9.43l.43.41c-2.82 4.16-5.88 8.1-9 11.95s-6.36 7.62-9.67 11.3-6.76 7.24-10.34 10.67-7.19 6.82-10.72 10.29l-10.7 10.37-10.66 10.34c-7.17 6.85-14.27 13.75-21.49 20.55ZM139.35 723.57c6.53-7.45 13.18-14.8 19.77-22.2l9.95-11 10-11c3.35-3.66 6.61-7.38 9.9-11.09s6.73-7.26 10.3-10.71 7.21-6.79 11-10.07 7.56-6.46 11.61-9.43l.44.42c-2.82 4.16-5.88 8.09-9 12s-6.36 7.62-9.68 11.3-6.76 7.24-10.33 10.67-7.19 6.82-10.72 10.29l-10.61 10.41-10.67 10.34c-7.2 6.79-14.31 13.7-21.52 20.5ZM424.12 714.07c6.53-7.45 13.17-14.8 19.76-22.2l10-11 10-11c3.34-3.66 6.61-7.38 9.9-11.09s6.73-7.26 10.29-10.71 7.2-6.79 10.93-10.07 7.56-6.46 11.62-9.43l.43.42c-2.82 4.16-5.87 8.09-9 12s-6.36 7.62-9.67 11.3-6.76 7.24-10.34 10.67-7.19 6.82-10.72 10.29l-10.6 10.41L446 694c-7.17 6.84-14.27 13.75-21.49 20.54ZM512 735.1c6.53-7.46 13.18-14.8 19.77-22.21l10-11 10-11c3.35-3.65 6.61-7.38 9.91-11.08s6.72-7.27 10.29-10.71 7.21-6.79 10.95-10.07 7.56-6.46 11.61-9.43l.44.42c-2.82 4.16-5.88 8.09-9 11.94s-6.36 7.63-9.68 11.31-6.76 7.23-10.33 10.66-7.19 6.82-10.72 10.3l-10.61 10.4L534 715c-7.16 6.84-14.26 13.75-21.48 20.54Z'/%3e%3cpath class='cls-5' d='M263.71 433.87c6.53-7.46 13.18-14.81 19.76-22.21l10-11 10-11c3.34-3.65 6.61-7.38 9.9-11.08s6.73-7.27 10.29-10.71 7.22-6.8 10.95-10.07 7.56-6.47 11.62-9.43l.43.41c-2.82 4.16-5.87 8.1-9 12s-6.36 7.62-9.67 11.3-6.76 7.24-10.34 10.67-7.19 6.82-10.72 10.29L296.3 403.4l-10.67 10.34c-7.17 6.85-14.27 13.75-21.49 20.54ZM192.14 602c6.53-7.45 13.18-14.8 19.76-22.2l10-11 10-11c3.34-3.66 6.61-7.38 9.9-11.09s6.73-7.26 10.29-10.71 7.22-6.79 11-10.07 7.55-6.46 11.61-9.43l.43.42c-2.82 4.16-5.87 8.09-9 11.94s-6.35 7.63-9.67 11.31-6.76 7.24-10.33 10.67-7.2 6.81-10.73 10.29l-10.6 10.4-10.67 10.35c-7.16 6.84-14.27 13.75-21.49 20.54ZM114.78 803.65c6.53-7.46 13.18-14.8 19.76-22.21l10-11 10-11c3.34-3.65 6.61-7.38 9.9-11.08s6.73-7.27 10.29-10.71 7.22-6.8 10.95-10.07 7.56-6.46 11.62-9.43l.43.42c-2.82 4.16-5.87 8.09-9 11.94s-6.36 7.63-9.67 11.31-6.76 7.23-10.34 10.66-7.22 6.82-10.72 10.29l-10.6 10.41-10.7 10.34c-7.17 6.85-14.27 13.75-21.49 20.55ZM399.54 794.15c6.53-7.46 13.18-14.8 19.76-22.21l10-11 10-11c3.35-3.65 6.61-7.38 9.9-11.08s6.73-7.27 10.29-10.71 7.22-6.8 11-10.07 7.56-6.46 11.61-9.43l.43.42c-2.81 4.16-5.87 8.09-9 11.94s-6.35 7.63-9.67 11.31-6.86 7.23-10.4 10.68-7.2 6.82-10.72 10.29l-10.61 10.41-10.67 10.3c-7.16 6.85-14.27 13.75-21.49 20.55ZM487.46 815.18c6.53-7.46 13.18-14.81 19.76-22.21l10-11 10-11c3.34-3.65 6.61-7.38 9.9-11.09s6.73-7.26 10.29-10.7 7.22-6.8 11-10.07 7.56-6.47 11.62-9.43l.43.41c-2.82 4.16-5.87 8.1-9 11.95s-6.36 7.62-9.67 11.3-6.79 7.24-10.42 10.66-7.19 6.82-10.72 10.29l-10.6 10.41-10.67 10.34c-7.17 6.85-14.27 13.75-21.49 20.54Z'/%3e%3cpath class='cls-6' d='M608.47 57.37a6.12 6.12 0 0 1-4.81-9.9c1.31-1.67 7.13-7.81 16.41-13.89 12-7.84 25-12.44 37.79-13.31 21.87-1.48 42.92 7.47 62.57 26.59a6.12 6.12 0 1 1-8.54 8.77C695 39.16 677.2 31.37 659.09 32.45c-13.49.82-24.84 6.51-32 11.15a70.43 70.43 0 0 0-13.8 11.4 6.11 6.11 0 0 1-4.82 2.37Zm18.78 13.22C628.66 69 641.52 54.8 660 54c12.6-.58 25.3 5.15 37.76 17a6.12 6.12 0 0 0 8.45-8.86c-15-14.29-30.71-21.15-46.78-20.41-23.07 1.06-38.54 17.53-41.43 20.82a6.12 6.12 0 1 0 9.22 8Zm14.54 15.62c1.18-2 8.35-9.28 17.86-10.3 8.06-.87 16.13 3 24 11.34a6.12 6.12 0 0 0 8.94-8.35c-13.23-14.15-25.92-16.05-34.23-15.16-14 1.51-24.29 11.56-27.05 16.2a6.11 6.11 0 0 0 2.12 8.39 6.12 6.12 0 0 0 8.38-2.12Zm20.69 1.62a11.75 11.75 0 1 0 11.75 11.75 11.74 11.74 0 0 0-11.75-11.75Z'/%3e%3cpath class='cls-7' d='m434.5 368 16.5 19.17L465.5 405l29-13.17-19.17-25.6-19.5-12.23-21.33 14zM314.17 686.33 298.5 704l15.67 15.17 26.66-19.5-26.66-13.34z'/%3e%3cpath class='cls-6' d='m286.33 701.33-38 75.34 6.48.76a22.78 22.78 0 0 0 11.89-1.79 22.87 22.87 0 0 0 8.18-6.17L319.67 716l-18.81-14.67Z'/%3e%3cpath class='cls-7' d='m727 667 19.17 19.5L735 699l-36.5-21.5L727 667z'/%3e%3cpath class='cls-6' d='m746.17 686.5 32-5.83 21-8.52a18.6 18.6 0 0 1 10.91-.94l5.23 1.12-61 57.34-9-9.73a49.11 49.11 0 0 1-11.07-19.48l-.68-2.3Z'/%3e%3cpath class='cls-8' d='M506.83 529.94V569H500L339 709l-5.38-3.07a58.44 58.44 0 0 1-25.43-29.31l133.43-156.87L488.5 516ZM506.83 569h10.42L700 686.5l5.33-1.73a139.28 139.28 0 0 0 25.25-11L739 669S623.75 552 601.25 531.25s-31.61-26.54-31.61-26.54l-32.39-23.52-30.42 47.91Z'/%3e%3cpath class='cls-9' d='m732.53 672.63-4.76 4a42.35 42.35 0 0 0-10 12.23l-8.89-5.24ZM301.41 700.72a48.36 48.36 0 0 1 20.95 1.59l10.5 3.18.26-10.24-11.31-9.87-8.25 1.62Z'/%3e%3cpath d='m489.15 536.37-8.81 1.79a145.44 145.44 0 0 0-53.15 22.43l-48.42 33 62.85-73.89 28.88-9.08Z' style='opacity:.5%3bmix-blend-mode:multiply%3bfill:%23273236'/%3e%3cpath class='cls-7' d='m516.5 296.75 41.12-84 20.13 6.87-32.63 86.26s-25.5-1.76-25.5-2.13-3.12-7-3.12-7Z'/%3e%3cpath class='cls-7' d='m557.62 212.75-.43-18.5 38.43-10.64 2.5 2.89v.5a15 15 0 0 1-1.85 8.21 13.81 13.81 0 0 1-1.23 1.88l-17.33 22.53ZM423.84 472.08l-49.66 60.33-17.17-13.83 48.83-68.17 18 21.67z'/%3e%3cpath class='cls-7' d='M361.42 568.07c-.23 3.4-.27 9.33-5.38 8.34-4.86-.93-3.46-7.53-3.18-11 .17-2.22.44-4.43.78-6.63s-.34-3.37-2.84-3c-4.32.71-7.52 3.8-10.62 6.63q-5.18 4.77-10.39 9.59c-2.61 2.45-7.72 5.24-9.39 0-1-3.1 2.73-5.77 4.61-7.61 3.71-3.63 7.72-7 11.28-10.83-4.38 1.71-8.59 4.47-12.81 6.58-2.16 1.09-4.35 2.15-6.55 3.15-1.79.81-3.36 1.37-5.05-.05a4.48 4.48 0 0 1-1.33-5.17c1.22-2.42 3.9-3 6.09-4.12 4.7-2.52 9.4-5.05 14.12-7.52-4.7 1-9.45 1.87-14.15 2.93-3.43.79-9.5.86-8.26-4.58 1-4.32 8.72-4.55 12.21-5.37l7.38-1.76c.86-.21 4.14-.48 4.7-1.41a14.41 14.41 0 0 0-3.48-1.17c-1.51-.53-3-1.1-4.49-1.68-1.67-.64-3.34-1.36-5.06-1.86-1.46-.41-3.05-.7-4.18-1.79-2-1.95-1.2-5.59 1.17-6.85s6.18.52 8.62 1.2c3.15.89 6.39 1.64 9.47 2.76s5.28 0 8.41-.74 6.41-1.47 9.59-2.31c2.36-.62 3.81-4.38 5.31-6.1 3.87-4.43 8.78.79 12.22 3 2.22 1.45 6 3.08 6.69 6 .5 2.14-1.66 4.77-2.65 6.45-1.47 2.5-2.7 5.13-4 7.72-1.38 2.76-3.28 5.6-4.16 8.57s-1 6.34-2 9.39-2.44 5.8-2.68 9.22'/%3e%3cpath class='cls-9' d='M405.29 469.63a51 51 0 0 1-3.47 27.75l-1.29 3 18.29-22.21-2.82-13.29Z'/%3e%3cpath class='cls-6' d='m581 496.83-37.13 25.75a80 80 0 0 1-45.53 14.25c-2 0-3.92-.08-5.88-.22l-5.27-.38a79.82 79.82 0 0 1-31.48-9.05L438 517.83s5.17-12.16 7.83-40c.17-1.77.32-3.66.45-5.65 1.91-29.26-.28-79.68-.28-79.68l5-5.33c3.44 2.19 7 4 11.41 4 11.9 0 17.23-6.63 17.82-18.39l16.28-8.78s36 41.67 49.32 73.83 35.17 59 35.17 59Z'/%3e%3cpath class='cls-6' d='M390.5 454.5a80.16 80.16 0 0 0 33.95 26.24l.22.09L447 449.34l4-25-5-31.88ZM509.5 296.75h4.15a86.78 86.78 0 0 1 39.85 9.69l-10 23.57a136.64 136.64 0 0 0-8.64 78.59l2.14 11.57L501.75 403 489 359.5Z'/%3e%3cpath class='cls-9' d='M434.5 368a94.82 94.82 0 0 0 40.38 8.23l5-.48.62-9.54-27.5-6.63-13.25 2.17Z'/%3e%3cpath class='cls-7' d='M472 307s15.83 21 20.33 39c1.53 6.13 2.51 10.61 3.12 13.86a8.86 8.86 0 0 1-6.13 10.14l-11.6 3.52a27.18 27.18 0 0 1-20.88-2.13l-2.14-1.16a35.09 35.09 0 0 1-14.8-15.5l-8.42-17.37.69-21.37 29.64-9.56Z'/%3e%3cpath class='cls-11' d='m441.44 354.74-2.69-13.23a21.13 21.13 0 0 1 2.75-13.26 21.16 21.16 0 0 1 11.5-9.36l7.08-2.38a24.54 24.54 0 0 0 6.08-3l7-4.83a6.67 6.67 0 0 0-3.51-6.58l-6.84-3.64a33.66 33.66 0 0 0-15.09-3.92l-5.84-.12a33.68 33.68 0 0 0-19.17 5.52l-3.67 2.41a33.62 33.62 0 0 0-9.55 9.5 33.61 33.61 0 0 0-5.63 19.13v1.25a33.71 33.71 0 0 0 6.85 19.86l1.79 2.35a33.53 33.53 0 0 0 12.5 10.03c2.65 1.26 5 2.36 5.12 2.36.25 0 4.42 1.17 4.42 1.17l10.65-2.95Z'/%3e%3cpath class='cls-7' d='m447.09 364.61-12.22-21.37a12.31 12.31 0 0 0 12.22 21.37Z'/%3e%3cpath class='cls-9' d='m441.1 359.36-5.3-9.24a5.33 5.33 0 0 0 5.3 9.24ZM557.62 212.75a10.14 10.14 0 0 1 9.38-6.85l7.19-.2h.86l6.62.38a8.3 8.3 0 0 0 4.72-1.14l-10-7.13-19 4.25Z'/%3e%3cpath class='cls-6' d='m580.24 151.62-27.87 40.07a6.62 6.62 0 0 0 4.5 10.32l25.55 3.62a6.63 6.63 0 0 0 6.29-2.68l29.22-40.57a6.61 6.61 0 0 0-4.6-10.43l-26.9-3.12a6.61 6.61 0 0 0-6.19 2.79Z'/%3e%3cpath class='cls-12' d='m583.56 152.67-25.12 35.54a1 1 0 0 0 .68 1.54l29.46 3.68a1 1 0 0 0 .93-.42l23.86-34.57a1 1 0 0 0-.65-1.53l-28.2-4.64a1 1 0 0 0-.96.4Z'/%3e%3cg style='clip-path:url(%23clip-path)'%3e%3cellipse class='cls-14' cx='558.95' cy='184.94' rx='10.25' ry='4.44' transform='rotate(-36.01 558.93 184.944)'/%3e%3cellipse class='cls-14' cx='601.13' cy='177.79' rx='3.33' ry='10.76' transform='rotate(-77.53 601.123 177.787)'/%3e%3cellipse class='cls-14' cx='599.3' cy='184.14' rx='3.33' ry='13.08' transform='rotate(-77.53 599.295 184.145)'/%3e%3cellipse class='cls-14' cx='595.25' cy='190.19' rx='3.33' ry='13.08' transform='rotate(-81.69 595.282 190.173)'/%3e%3cellipse class='cls-14' cx='589.12' cy='195.77' rx='3.33' ry='11.86' transform='rotate(-81.69 589.151 195.757)'/%3e%3c/g%3e%3cellipse class='cls-7' cx='558.95' cy='183.61' rx='10.25' ry='4.44' transform='rotate(-36.01 558.936 183.62)'/%3e%3cellipse class='cls-7' cx='601.57' cy='176.97' rx='3.33' ry='10.76' transform='rotate(-77.53 601.562 176.973)'/%3e%3cellipse class='cls-7' cx='599.74' cy='183.33' rx='3.33' ry='13.08' transform='rotate(-77.53 599.735 183.33)'/%3e%3cellipse class='cls-7' cx='595.69' cy='189.37' rx='3.33' ry='13.08' transform='rotate(-81.69 595.722 189.361)'/%3e%3cellipse class='cls-7' cx='589.56' cy='194.96' rx='3.33' ry='11.86' transform='rotate(-81.69 589.59 194.945)'/%3e%3cpath class='cls-11' d='M463.34 331.7a10.52 10.52 0 0 1 10.81-12.48 19.49 19.49 0 0 0-4 1.93 15.48 15.48 0 0 0-3.19 2.79 15.65 15.65 0 0 0-2.31 3.56 19.11 19.11 0 0 0-1.31 4.2Z'/%3e%3cellipse class='cls-11' cx='476.26' cy='329.32' rx='1.75' ry='7.21' transform='rotate(-38.28 476.299 329.34)'/%3e%3cellipse class='cls-9' cx='489' cy='349.17' rx='1.78' ry='3.17' transform='rotate(-25.22 489.057 349.189)'/%3e%3cellipse class='cls-12' cx='568' cy='196.98' rx='2.06' ry='3.75' transform='rotate(-85.43 568.02 196.969)'/%3e%3cpath class='cls-15' d='M447 449.34 433.8 468l3.53-9a142.47 142.47 0 0 0 7.49-26.27l2.1-11.34ZM487.19 536.23a79.82 79.82 0 0 1-31.48-9.05L438 517.83s5.17-12.16 7.83-40c.17-1.77.32-3.66.45-5.65a79.38 79.38 0 0 0 32.92 58.33Z'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

function NoConnection(_ref) {
  var onRefresh = _ref.onRefresh,
    _ref$imgWidth = _ref.imgWidth,
    imgWidth = _ref$imgWidth === void 0 ? '400' : _ref$imgWidth;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: NoConnSVG,
    width: imgWidth
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, "Oops, You Are Disconnected"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    style: {
      color: '#a9a8a8',
      marginBottom: 20
    }
  }, "Please check your internet connection"), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "large",
    color: "primary",
    onClick: onRefresh
  }, "Refresh"));
}

var WLBLogo = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='107' height='26'%3e%3cdefs%3e%3cstyle%3e.cls-1%7bfill:%23014a62%7d%3c/style%3e%3c/defs%3e%3cg id='Group_410' data-name='Group 410'%3e%3cg id='Group_410-2' data-name='Group 410'%3e%3cpath id='Path_364' d='M420.673 793.947c-2.738 3.908-10.673 6.364-15.757 3.294l-.192-.118a11.493 11.493 0 0 1-4.875-6.089l-.026-.2-.1-.752s-.443-2.474-1.028-4.9l-.257-1.393a3.215 3.215 0 0 1-.084-.4 3.616 3.616 0 0 1 .17-1.876 3.378 3.378 0 0 1 1.854-1.6h.01a4.451 4.451 0 0 1 1.4-.241h.009a3.127 3.127 0 0 1 2.544 1.257 4.087 4.087 0 0 1 .524 1.391s.136.529.32 1.233a94.848 94.848 0 0 0 1.191 5.148l.223.726.053.169.227.724s.782 2.177 4.023 2.01a4.64 4.64 0 0 0 4.414-2.9 5.937 5.937 0 0 0-.056-2.568l-1.173-5.694s-.783-2.959.894-4.3 4.917-1.061 5.643 1.4 1.509 6.922 1.509 6.922 1.278 4.849-1.46 8.757z' class='cls-1' data-name='Path 364' transform='translate(-382.317 -776.069)'/%3e%3cpath id='Path_365' d='m151.348 854.687-.074.11c-3.326 4.906-11.579 5.983-15.721 3.577s-5.025-7.35-5.025-7.35-1.176-4.38-1.553-6.912 2.451-4.137 4.542-3.619 2.63 3.529 2.63 3.529l1.34 5.658a5.944 5.944 0 0 0 1.035 2.354 4.676 4.676 0 0 0 5.241.8c3.018-1.2 2.809-3.5 2.809-3.5l-.1-.73-.026-.2-.1-.752s-.443-2.474-1.028-4.9l-.257-1.393a3.21 3.21 0 0 1-.084-.4 3.615 3.615 0 0 1 .17-1.875 3.378 3.378 0 0 1 1.854-1.6h.01a4.447 4.447 0 0 1 1.4-.241h.008a3.127 3.127 0 0 1 2.543 1.257 4.088 4.088 0 0 1 .524 1.39s.136.529.32 1.233a94.848 94.848 0 0 0 1.191 5.148l.223.726.053.169a11.419 11.419 0 0 1-1.925 7.521z' class='cls-1' data-name='Path 365' transform='translate(-128.94 -833.607)'/%3e%3cpath id='Path_366' d='M402.122 842.8a3.115 3.115 0 0 1-3.772-1.817 3.671 3.671 0 0 1 .17-1.89 3.385 3.385 0 0 1 1.854-1.612h.01a3.853 3.853 0 0 1 .493-.147 3.814 3.814 0 0 1 .906-.1h.009a3.12 3.12 0 0 1 2.544 1.267 2.419 2.419 0 0 1 .313.644c.02.062.038.126.052.192a3.072 3.072 0 0 1-2.579 3.463z' class='cls-1' data-name='Path 366' transform='translate(-382.317 -833.6)'/%3e%3c/g%3e%3cg id='Group_413' data-name='Group 413' transform='translate(46.514 1.986)'%3e%3cg id='Group_411' data-name='Group 411'%3e%3cpath id='Path_367' d='m906.981 808.543-3.358 9.92h-.765l-3.075-8.9-3.089 8.9h-.765l-3.373-9.92h.765l3.018 8.928 3.1-8.928h.694l3.089 8.942 3.047-8.942z' class='cls-1' data-name='Path 367' transform='translate(-892.555 -807.891)'/%3e%3cpath id='Path_368' d='M1138.936 853.858a3.521 3.521 0 1 1 3.514 3.755 3.519 3.519 0 0 1-3.514-3.755zm6.341 0a2.841 2.841 0 1 0-2.827 3.118 2.87 2.87 0 0 0 2.826-3.118z' class='cls-1' data-name='Path 368' transform='translate(-1124.632 -846.985)'/%3e%3cpath id='Path_369' d='M1289.4 850.1v.694c-.073 0-.147-.014-.221-.014-2.137 0-3.408 1.091-3.408 2.919v3.854h-.921v-7.4h.884v1.615c.587-1.068 1.858-1.668 3.666-1.668z' class='cls-1' data-name='Path 369' transform='translate(-1262.046 -846.985)'/%3e%3cpath id='Path_370' d='m1357.792 805.073-2.139 1.757v2.2h-.786v-10.518h.786v7.44l5.254-4.322h1.007l-3.539 2.99 3.885 4.407h-.975z' class='cls-1' data-name='Path 370' transform='translate(-1328.03 -798.455)'/%3e%3cpath id='Path_371' d='M1475.6 808.543h.831v9.268H1483v.652h-7.4z' class='cls-1' data-name='Path 371' transform='translate(-1441.756 -807.891)'/%3e%3cpath id='Path_372' d='M1599.2 805.991a.553.553 0 0 1 1.105 0 .553.553 0 1 1-1.105 0zm.2 2.154h.708v7.4h-.708z' class='cls-1' data-name='Path 372' transform='translate(-1558.073 -804.97)'/%3e%3cpath id='Path_373' d='M1619.407 799.653v1.077h2.366v.609h-2.352v6.788h-.708v-6.787h-1.36v-.609h1.36V799.6a1.888 1.888 0 0 1 2.055-2.041 2.211 2.211 0 0 1 1.459.482l-.283.539a1.7 1.7 0 0 0-1.148-.411c-.922-.004-1.389.507-1.389 1.484z' class='cls-1' data-name='Path 373' transform='translate(-1575.348 -797.556)'/%3e%3cpath id='Path_374' d='M1678.656 854.028h-6.617a3.05 3.05 0 0 0 3.257 2.948 3.159 3.159 0 0 0 2.461-1.034l.427.468a3.75 3.75 0 0 1-2.9 1.2 3.708 3.708 0 0 1-3.964-3.755 3.678 3.678 0 1 1 7.354-.028c-.003.06-.018.13-.018.201zm-6.6-.553h5.895a2.955 2.955 0 0 0-5.895 0z' class='cls-1' data-name='Path 374' transform='translate(-1626.111 -846.985)'/%3e%3c/g%3e%3cg id='Group_412' data-name='Group 412' transform='translate(.19 9.173)'%3e%3cpath id='Path_375' d='m904.5 999.089-1.5-1.417a5 5 0 0 1-3.615 1.346c-2.116 0-3.63-1.02-3.63-2.522 0-1.176.741-2.041 2.719-3.089-1.05-.992-1.359-1.587-1.359-2.352 0-1.261 1.066-2.111 2.734-2.111 1.529 0 2.518.737 2.518 1.97 0 .992-.649 1.686-2.41 2.622l2.966 2.806a5.863 5.863 0 0 0 .726-1.913l.9.255a6.464 6.464 0 0 1-.958 2.282l1.545 1.459zm-2.147-2.026-3.259-3.075c-1.73.907-2.255 1.531-2.255 2.409 0 1.077 1.05 1.785 2.61 1.785a3.927 3.927 0 0 0 2.905-1.119zm-4.217-6.023c0 .581.232.992 1.22 1.913 1.56-.822 2.07-1.318 2.07-2.026 0-.737-.572-1.233-1.576-1.233-1.08 0-1.713.553-1.713 1.346z' class='cls-1' data-name='Path 375' transform='translate(-895.758 -988.419)'/%3e%3cpath id='Path_376' d='M1075.415 997.365c0 1.7-1.439 2.693-4.193 2.693h-5.322v-9.92h5.02c2.571 0 3.949 1.006 3.949 2.579a2.359 2.359 0 0 1-1.377 2.182 2.472 2.472 0 0 1 1.923 2.466zm-7.53-5.782v2.735h2.816c1.377 0 2.158-.454 2.158-1.361s-.781-1.375-2.158-1.375zm5.525 5.6c0-.992-.811-1.431-2.311-1.431h-3.214v2.863h3.214c1.501-.003 2.311-.442 2.311-1.434z' class='cls-1' data-name='Path 376' transform='translate(-1055.996 -989.543)'/%3e%3cpath id='Path_377' d='M1237.582 1032.788h-6.531a2.492 2.492 0 0 0 2.7 1.814 3.143 3.143 0 0 0 2.26-.822l1.044 1.091a4.436 4.436 0 0 1-3.351 1.233c-2.79 0-4.6-1.63-4.6-3.883s1.824-3.869 4.3-3.869a3.881 3.881 0 0 1 4.209 3.911c0 .143-.013.355-.031.525zm-6.547-1.176h4.723a2.207 2.207 0 0 0-2.354-1.842 2.243 2.243 0 0 0-2.369 1.842z' class='cls-1' data-name='Path 377' transform='translate(-1209.699 -1025.49)'/%3e%3cpath id='Path_378' d='m1367.784 1029.785-3.543 8.177c-.694 1.715-1.658 2.239-2.919 2.239a3.132 3.132 0 0 1-2.026-.694l.708-1.3a1.92 1.92 0 0 0 1.3.524c.624 0 .992-.3 1.332-1.049l.128-.3-3.3-7.6h1.842l2.381 5.6 2.395-5.6z' class='cls-1' data-name='Path 378' transform='translate(-1332.314 -1026.838)'/%3e%3cpath id='Path_379' d='M1494.137 1032.222c0-2.267 1.9-3.869 4.507-3.869 2.635 0 4.523 1.6 4.523 3.869s-1.889 3.883-4.523 3.883c-2.603-.005-4.507-1.616-4.507-3.883zm7.031 0a2.52 2.52 0 1 0-2.524 2.366 2.336 2.336 0 0 0 2.524-2.366z' class='cls-1' data-name='Path 379' transform='translate(-1459.313 -1025.49)'/%3e%3cpath id='Path_380' d='M1664.022 1031.669v4.336h-1.771v-4.105c0-1.346-.666-2-1.8-2a2.01 2.01 0 0 0-2.111 2.281v3.826h-1.771v-7.567h1.686v.978a3.291 3.291 0 0 1 2.607-1.063 2.957 2.957 0 0 1 3.16 3.314z' class='cls-1' data-name='Path 380' transform='translate(-1612.427 -1025.49)'/%3e%3cpath id='Path_381' d='M1801.461 980.106v10.515h-1.7v-.978a3.12 3.12 0 0 1-2.508 1.077 3.876 3.876 0 0 1 0-7.751 3.1 3.1 0 0 1 2.438 1.02v-3.883zm-1.743 6.731a2.256 2.256 0 1 0-2.253 2.367 2.212 2.212 0 0 0 2.253-2.367z' class='cls-1' data-name='Path 381' transform='translate(-1741.165 -980.106)'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

var _createAxiosInterceptor = function _createAxiosInterceptor(url) {
  var axiosCreate = axios.create({
    baseURL: url,
    headers: {
      Accept: 'application/json',
      'Accept-Language': 'es',
      'Content-Type': 'application/json'
      // Authorization: `Bearer ${getUserData()?.oauth?.access_token}`
    },

    withCredentials: true
  });
  axiosCreate.interceptors.response.use(function (response) {
    return response.data;
  }, function (error) {
    console.log(error);
  });
  return axiosCreate;
};
var Service = function Service(rest_url) {
  return _createAxiosInterceptor(rest_url);
};
var searchByKeywordAndType = function searchByKeywordAndType(rest_url, keyword, type, addedParam) {
  if (keyword === void 0) {
    keyword = '';
  }
  if (type === void 0) {
    type = 'all';
  }
  if (addedParam === void 0) {
    addedParam = {};
  }
  // type 'all', 'users', 'jobs', 'learning', 'company', 'teams'
  var parameters = {
    params: {
      query: keyword,
      type: type
    }
  };
  if (isObjectEmpty(keyword)) {
    delete parameters.query;
  }
  var searchUrl = "/search";
  return Service(rest_url).get(searchUrl, parameters, addedParam);
};
var getListUserBlockedMe = function getListUserBlockedMe(rest_url) {
  var _getUserData;
  var userId = (_getUserData = getUserData()) == null ? void 0 : _getUserData.id;
  var url = "users/detail/" + userId + "/users-blocked-me";
  return Service(rest_url).get(url);
};
var getUnreadNotification = function getUnreadNotification(rest_url) {
  var url = '/global/notification/get/count';
  return Service(rest_url).get(url);
};

function useGetUnreadNotification(restUrl) {
  var _useState = useState(0),
    count = _useState[0],
    setCount = _useState[1];
  useEffect(function () {
    var active = true;
    getUnreadNotification(restUrl).then(function (response) {
      var _response$unread;
      if (!active) return;
      setCount((_response$unread = response == null ? void 0 : response.unread) != null ? _response$unread : 0);
    });
    return function () {
      active = false;
    };
  }, []);
  return count;
}

var HeaderContainer = styled.div(["display:flex;justify-content:space-between;margin:0 auto;padding:10px 0;@media only screen and (min-width:320px) and (max-width:767px){padding:10px 22px;}@media only screen and (min-width:768px) and (max-width:1200px){padding:10px 48px;}position:relative;z-index:3;max-width:", "px;align-items:center;"], function (props) {
  return props.maxWidth;
});
var OptionsContainer = styled.div(["z-index:1;position:relative;width:756px;@media (max-width:1199px){width:65vw;}"]);
var RightOptionsContainer = styled.div(["display:flex;align-items:center;justify-content:flex-end;@media (min-width:1200px){justify-content:space-between;width:270px;}"]);
var HeaderStyled = styled.div(["background:#fff;display:inline-block;width:100%;position:sticky;top:0;z-index:6;"]);
var LoggedInAvatar = styled(Avatar)(["width:24px !important;height:24px !important;cursor:pointer;"]);

var useBlockMe = function useBlockMe(restUrl) {
  var _useState = useState(false),
    blockLoading = _useState[0],
    setBlockLoading = _useState[1];
  var _useState2 = useState([]),
    blocker = _useState2[0],
    setBlocker = _useState2[1];
  var _useState3 = useState(false),
    isLoadedBlock = _useState3[0],
    setIsLoadedBlock = _useState3[1];
  useEffect(function () {
    var active = true;
    setBlockLoading(true);
    getListUserBlockedMe(restUrl).then(function (res) {
      if (!active) return;
      var blocked = res.data.map(function (item) {
        return item.user_id;
      });
      setBlocker(blocked);
    }, function (err) {
      console.error(err);
    }).finally(function () {
      if (!active) return;
      setBlockLoading(false);
      setIsLoadedBlock(true);
    });
    return function () {
      active = false;
    };
  }, []);
  return [blocker, isLoadedBlock, blockLoading];
};

/**
 * Hook that alerts clicks outside of the passed ref
 */
function useOutsideAlerter(ref, a) {
  useEffect(function () {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        a();
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

/**
 * Component that alerts if you click outside of it
 */
function OutsideAlerter(props) {
  var wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, props.onClickOutside);
  return /*#__PURE__*/React.createElement("div", {
    ref: wrapperRef
  }, props.children);
}

var routes = {
  ALL_SEARCH_RESULT: {
    path: '/search-result/all/'
  },
  PEOPLE_SEARCH_RESULT: {
    path: '/search-result/people/'
  },
  COMPANIES_SEARCH_RESULT: {
    path: '/search-result/company/'
  },
  TEAM_SEARCH_RESULT: {
    path: '/search-result/group/'
  },
  LEARNING_SEARCH_RESULT: {
    path: '/search-result/learning/'
  },
  JOB_SEARCH_RESULT: {
    path: '/search-result/job/'
  }
};

var SearchResultsWrapper = styled.div(["display:flex;flex-direction:row;justify-content:space-between;margin:20px 0;margin-bottom:40px;.search-result-wrapper{display:flex;flex-direction:column;width:80%;}.search-result-category{display:flex;align-items:center;font-weight:600;font-style:normal;font-stretch:normal;text-align:left;color:#014a62;border-right:solid #e8e6e1;border-width:thin;width:140px;justify-content:center;}.search-result-count{font-weight:bold;font-style:normal;font-stretch:normal;line-height:1.44;letter-spacing:normal;text-align:left;color:#014a62;}.search-result-item{display:flex;flex-direction:row;padding-bottom:2px;font-weight:300;font-style:normal;font-stretch:normal;line-height:1.47;letter-spacing:normal;text-align:left;color:#a9a8a8;padding-left:20px;margin-bottom:8px;margin-top:8px;}"]);
var ResultInformation = styled.div(["padding-left:20px;width:400px;"]);
var ViewAll = styled.div(["bottom:0;width:100%;border-top:solid #e8e6e1;border-width:thin;justify-content:center;display:flex;justify-items:center;font-family:'Muli-Regular',sans-serif;font-size:12px;font-weight:600;font-style:normal;font-stretch:normal;text-align:center;padding:20px 0;box-shadow:0 3px 6px 0 rgba(0,0,0,0.16);background-color:#fff;a{font-size:12px;font-weight:600;line-height:1.5;}"]);
var Wrapper = styled.div([".component_search_result{width:100%;background-color:#fff;max-height:430px;min-height:130px;box-shadow:0 3px 6px 0 rgba(0,0,0,0.16);border-radius:5px;margin-top:5px;position:absolute;@media only screen and (min-width:320px) and (max-width:767px){left:50%;transform:translate(-50%);width:90vw;}}.component_search_option_items{min-height:130px;max-height:360px;overflow-y:auto;}.component_search_spin{padding:20px;text-align:center;}.circle-skeleton-wrapper{width:50px;margin-right:12px;}.circle-skeleton{height:50px;}.text-skeleton-wrapper{width:90%;}.text-skeleton{margin-bottom:10px;}"]);

var img = "data:image/png;base64,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";

var EmptyState = function EmptyState(_ref) {
  var message1 = _ref.message1,
    image = _ref.image,
    message2 = _ref.message2,
    button = _ref.button,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '450' : _ref$width;
  return (
    /*#__PURE__*/
    // bisa ditambahkan wrapper diluar ini sesuai desain yg diinginkan
    React.createElement("div", {
      style: {
        alignSelf: 'center',
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: !image ? img : image,
      alt: "no-data",
      width: width,
      style: {
        margin: 'auto auto 24px'
      }
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, message1), /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      color: "textSecondary"
    }, message2), button && /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 20
      }
    }, button))
  );
};

var word$2 = {
  search: {
    english: 'Search',
    indonesian: 'Cari'
  },
  seeAll: {
    english: 'See All',
    indonesian: 'Lihat Semua'
  },
  noResult: {
    english: 'No results found',
    indonesian: 'Tidak ada hasil yang ditemukan'
  },
  noResultDesc: {
    english: "It seems we can't find any results based on your search",
    indonesian: 'Sepertinya kami tidak dapat menemukan hasil apa pun berdasarkan pencarian Anda'
  },
  people: {
    english: 'People',
    indonesian: 'Orang'
  },
  companies: {
    english: 'Companies',
    indonesian: 'Instansi'
  },
  learnings: {
    english: 'Learnings',
    indonesian: 'Pembelajaran'
  },
  groups: {
    english: 'Groups',
    indonesian: 'Kelompok'
  }
};

function GlobalSearch(_ref) {
  var classes = _ref.classes,
    restUrl = _ref.restUrl,
    env = _ref.env,
    language = _ref.language;
  var _useState = useState(''),
    keyword = _useState[0],
    setKeyword = _useState[1];
  var _useState2 = useState(0),
    typingTimeOut = _useState2[0],
    setTypingTimeout = _useState2[1];
  var _useState3 = useState(false),
    loading = _useState3[0],
    setLoading = _useState3[1];
  var _useState4 = useState([]),
    categories = _useState4[0],
    setCategories = _useState4[1];
  var _useState5 = useState(false),
    showSearchResult = _useState5[0],
    setShowSearchResult = _useState5[1];
  var _useState6 = useState({}),
    searchResult = _useState6[0],
    setSearchResult = _useState6[1];
  var _useBlockMe = useBlockMe(restUrl),
    blockedMe = _useBlockMe[0],
    blockLoaded = _useBlockMe[1];
  var properCategory = {
    users: word$2.people[language],
    // jobs : 'Jobs',
    company: word$2.companies[language],
    learning: word$2.learnings[language],
    teams: word$2.groups[language]
  };
  var searchAttr = {
    users: ['id', 'name', 'avatar', 'people_work_placements'],
    jobs: ['id', 'title', '', ''],
    company: ['id', 'brand_name', 'logo', 'industry_type'],
    learning: ['slug', 'title', 'thumbnail', 'global_user'],
    teams: ['id', 'name', 'avatar', 'description']
  };
  var searchLink = {
    users: function users(id) {
      return [env.REACT_APP_SOSMED + "/profile/" + id + "/detail", routes.PEOPLE_SEARCH_RESULT.path];
    },
    jobs: function jobs() {
      return ['', ''];
    },
    company: function company(id) {
      return [env.REACT_APP_SOSMED + "/company/" + id + "/post", routes.COMPANIES_SEARCH_RESULT.path];
    },
    learning: function learning(slug) {
      return [env.REACT_APP_LEARNING + '/learning_course/' + slug, routes.LEARNING_SEARCH_RESULT.path];
    },
    teams: function teams(id) {
      return [env.REACT_APP_SOSMED + "/group/" + id + "/discussion", routes.TEAM_SEARCH_RESULT.path];
    }
  };
  var onSearch = function onSearch(word) {
    if (word.trim()) {
      searchByKeywordAndType(restUrl, word.trim(), 'all').then(function (response) {
        setCategories(Object.getOwnPropertyNames(response.data));
        var filteredUser = response.data.users.filter(function (item) {
          return !(blockedMe != null && blockedMe.includes(item.id));
        });
        var filteredResponse = _extends({}, response.data, {
          users: filteredUser
        });
        setSearchResult(filteredResponse);
      }).catch(function (e) {
        return console.error('Something went Wrong', e);
      }).finally(function () {
        return setLoading(false);
      });
    }
  };
  var quickSearch = function quickSearch(e) {
    var word = e.target.value;
    setKeyword(word);
    if (typingTimeOut) {
      clearTimeout(typingTimeOut);
    }
    setTypingTimeout(setTimeout(function () {
      if (word !== '') {
        setLoading(true);
        setShowSearchResult(true);
        setCategories([]);
        onSearch(word);
      } else {
        setShowSearchResult(false);
      }
    }, 1000));
  };
  var onClosePopup = function onClosePopup() {
    return setShowSearchResult(keyword !== '');
  };
  var onFocus = function onFocus() {
    return setShowSearchResult(keyword !== '');
  };
  var isNotfound = Object.entries(searchResult).every(function (i) {
    return i[1].length === 0;
  });
  var OptionItems = isNotfound ? /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 24
    }
  }, /*#__PURE__*/React.createElement(EmptyState, {
    message1: word$2.noResult[language],
    message2: word$2.noResultDesc[language],
    width: "200"
  })) : categories.map(function (category, id) {
    if (properCategory[category] && searchResult[category] && searchResult[category].length > 0) {
      return /*#__PURE__*/React.createElement(SearchResultsWrapper, {
        key: id
      }, /*#__PURE__*/React.createElement("div", {
        className: "search-result-category",
        style: {
          borderStyle: 'none',
          borderRightStyle: 'solid'
        }
      }, /*#__PURE__*/React.createElement("span", {
        onClick: function onClick() {
          return setShowSearchResult(false);
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        style: {
          fontWeight: 600
        },
        variant: "body2",
        component: Link,
        href: env.REACT_APP_SOSMED + searchLink[category]('')[1] + '?keyword=' + keyword
      }, /*#__PURE__*/React.createElement("div", null, properCategory[category])))), /*#__PURE__*/React.createElement("div", {
        className: "search-result-wrapper"
      }, searchResult[category] && searchResult[category].slice(0, 3).map(function (result, id) {
        var _result$searchAttr$ca, _result$searchAttr$ca2, _result$searchAttr$ca3, _result$searchAttr$ca4, _result$searchAttr$ca5, _result$searchAttr$ca6, _result$searchAttr$ca7, _result$searchAttr$ca8, _result$searchAttr$ca9, _result$searchAttr$ca10, _result$searchAttr$ca11, _result$searchAttr$ca12;
        return /*#__PURE__*/React.createElement("div", {
          className: "search-result-item",
          key: id
        }, /*#__PURE__*/React.createElement(Avatar
        // size={40}
        , {
          src: result[searchAttr[category][2]]
        }), /*#__PURE__*/React.createElement(ResultInformation, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
          style: {
            fontWeight: 600
          },
          component: Link,
          variant: "body2",
          href: searchLink[category] && searchLink[category](result[searchAttr[category][0]])[0]
        }, result[searchAttr[category][1]] && result[searchAttr[category][1]].length > 60 ? result[searchAttr[category][1]].slice(0, 50) + '...' : result[searchAttr[category][1]])), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption"
        }, category !== 'users' && category !== 'learning' && result[searchAttr[category][3]] ? result[searchAttr[category][3]].length > 110 ? result[searchAttr[category][3]].slice(0, 100) + '...' : result[searchAttr[category][3]] : '', category === 'users' && ((_result$searchAttr$ca = result[searchAttr[category][3]]) != null && (_result$searchAttr$ca2 = _result$searchAttr$ca[0]) != null && (_result$searchAttr$ca3 = _result$searchAttr$ca2.company_job_profile) != null && _result$searchAttr$ca3.title ? ((_result$searchAttr$ca4 = result[searchAttr[category][3]]) == null ? void 0 : (_result$searchAttr$ca5 = _result$searchAttr$ca4[0]) == null ? void 0 : (_result$searchAttr$ca6 = _result$searchAttr$ca5.company_job_profile) == null ? void 0 : _result$searchAttr$ca6.title) + ' at ' : ''), category === 'users' && ((_result$searchAttr$ca7 = (_result$searchAttr$ca8 = result[searchAttr[category][3]]) == null ? void 0 : (_result$searchAttr$ca9 = _result$searchAttr$ca8[0]) == null ? void 0 : (_result$searchAttr$ca10 = _result$searchAttr$ca9.company_profile) == null ? void 0 : _result$searchAttr$ca10.brand_name) != null ? _result$searchAttr$ca7 : '-'), category === 'learning' && ((_result$searchAttr$ca11 = (_result$searchAttr$ca12 = result[searchAttr[category][3]]) == null ? void 0 : _result$searchAttr$ca12.name) != null ? _result$searchAttr$ca11 : '-'))));
      })));
    }
  });
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(TextField, {
    variant: "outlined",
    placeholder: word$2.search[language],
    size: "small",
    className: classes.inputSearch,
    value: keyword,
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(SearchIcon, {
        color: "action",
        style: {
          width: 20,
          height: 20
        }
      }, "search")),
      classes: {
        input: classes.search
      }
    },
    fullWidth: true,
    onChange: quickSearch,
    disabled: !blockLoaded,
    onFocus: onFocus
  }), /*#__PURE__*/React.createElement(OutsideAlerter, {
    onClickOutside: onClosePopup
  }, /*#__PURE__*/React.createElement(Fade, {
    in: showSearchResult
  }, /*#__PURE__*/React.createElement("div", {
    className: "component_search_result"
  }, /*#__PURE__*/React.createElement("div", {
    className: "component_search_option_items"
  }, loading ? Array.from({
    length: 3
  }).map(function (res, i) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        padding: 20,
        paddingBottom: i === 2 ? 20 : 0
      },
      key: i
    }, /*#__PURE__*/React.createElement(Skeleton, {
      circle: true,
      containerClassName: "circle-skeleton-wrapper",
      className: "circle-skeleton"
    }), /*#__PURE__*/React.createElement(Skeleton, {
      count: 2,
      containerClassName: "text-skeleton-wrapper",
      className: "text-skeleton"
    }));
  }) : OptionItems), !loading && !isNotfound && /*#__PURE__*/React.createElement(ViewAll, null, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return setShowSearchResult(false);
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    component: Link,
    href: env.REACT_APP_SOSMED + routes.ALL_SEARCH_RESULT.path + '?keyword=' + keyword
  }, word$2.seeAll[language] + " \"" + keyword + "\"")))))));
}

var DrawerContainer = styled.div(["width:300px;"]);
var HeaderWrapper$1 = styled.div(["display:flex;padding:16px 24px 20px;cursor:pointer;&:hover{background:#f7f8f9;}"]);

function LeftDrawer(_ref) {
  var open = _ref.open,
    setOpen = _ref.setOpen,
    logoComponent = _ref.logoComponent,
    env = _ref.env,
    language = _ref.language;
  return /*#__PURE__*/React.createElement(Drawer, {
    anchor: "left",
    open: open === 'left',
    onClose: function onClose() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React.createElement(DrawerContainer, null, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '20px 20px 10px'
    }
  }, logoComponent), /*#__PURE__*/React.createElement(ListItem, {
    env: env,
    language: language
  })));
}

var word$1 = {
  AccountSetting: {
    english: 'Account Setting',
    indonesian: 'Pengaturan Akun'
  },
  Administrator: {
    english: 'Administrator',
    indonesian: 'Administrator'
  },
  CompanyGroup: {
    english: 'Company Group',
    indonesian: 'Grup Instansi'
  },
  ManageVendor: {
    english: 'Manage Vendor',
    indonesian: 'Kelola Penjual'
  },
  Help: {
    english: 'Help',
    indonesian: 'Bantuan'
  },
  Logout: {
    english: 'Logout',
    indonesian: 'Keluar'
  },
  Home: {
    english: 'Home',
    indonesian: 'Beranda'
  },
  Message: {
    english: 'Message',
    indonesian: 'Pesan'
  },
  Followers: {
    english: 'Followers',
    indonesian: 'Pengikut'
  },
  Notifications: {
    english: 'Notifications',
    indonesian: 'Notifikasi'
  }
};

function RightDrawer(_ref) {
  var open = _ref.open,
    setOpen = _ref.setOpen,
    userData = _ref.userData,
    userPosition = _ref.userPosition,
    env = _ref.env,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'english' : _ref$language,
    globalModuleData = _ref.globalModuleData,
    onLogOut = _ref.onLogOut,
    notifComponent = _ref.notifComponent;
  var REACT_APP_SOSMED = env.REACT_APP_SOSMED,
    REACT_APP_HC_ADMIN = env.REACT_APP_HC_ADMIN,
    REACT_APP_HC_HOLDING = env.REACT_APP_HC_HOLDING,
    REACT_APP_DOMAIN = env.REACT_APP_DOMAIN,
    HOME_URL = env.HOME_URL,
    REACT_APP_CHAT = env.REACT_APP_CHAT;
  var isShowAdministrator = useMemo(function () {
    return isAdministrator(language);
  }, [language]);
  var topMenu = [{
    label: word$1.Home[language],
    icon: /*#__PURE__*/React.createElement(HomeOutlined, {
      color: "primary"
    }),
    href: HOME_URL
  }, {
    label: word$1.Followers[language],
    icon: /*#__PURE__*/React.createElement(PeopleAltOutlined, {
      color: "primary"
    }),
    href: REACT_APP_SOSMED + "followers/" + (userData == null ? void 0 : userData.id) + "/"
  }, {
    label: word$1.Message[language],
    icon: /*#__PURE__*/React.createElement(EmailOutlined, {
      color: "primary"
    }),
    href: REACT_APP_CHAT
  }, {
    label: word$1.Notifications[language],
    icon: notifComponent,
    href: REACT_APP_SOSMED + "notification/" + env.NOTIF_PATH
  }];
  var bottomMenu = [{
    title: word$1.AccountSetting[language],
    url: REACT_APP_SOSMED + '/account-settings'
  }].concat(isShowAdministrator && [{
    title: word$1.Administrator[language],
    url: REACT_APP_HC_ADMIN,
    role: 'organization-hr-admin'
  }] || [], [{
    title: word$1.CompanyGroup[language],
    url: REACT_APP_HC_HOLDING,
    hidden: !hasModule(globalModuleData, 'holding'),
    role: 'holding-administrator'
  }, {
    title: word$1.ManageVendor[language],
    url: REACT_APP_SOSMED + '/vendorList',
    hidden: !hasModule(globalModuleData, 'vendor')
  }, {
    title: word$1.Help[language],
    url: 'https://crm.wlb.co.id/forms/ticket',
    isNewTab: true
  }]);
  var toLink = function toLink(link, role) {
    setCookie('currentRole', role, 1000, REACT_APP_DOMAIN);
    setTimeout(function () {
      window.open(link, '_blank');
    }, 500);
  };
  return /*#__PURE__*/React.createElement(Drawer, {
    anchor: "right",
    open: open === 'right',
    onClose: function onClose() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React.createElement(DrawerContainer, null, /*#__PURE__*/React.createElement(HeaderWrapper$1, {
    onClick: function onClick() {
      return window.location.href = REACT_APP_SOSMED + "/profile/" + (userData == null ? void 0 : userData.id) + "/detail";
    }
  }, /*#__PURE__*/React.createElement(Avatar, {
    src: userData.avatar
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: 8
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    gutterBottom: true,
    style: {
      fontWeight: 600
    }
  }, userData.name), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    style: {
      color: '#A9A8A8'
    }
  }, userPosition))), topMenu.map(function (res, i) {
    return /*#__PURE__*/React.createElement(ListItemContainer, {
      key: i,
      href: res.href
    }, res.icon, /*#__PURE__*/React.createElement(HCTitleLabel, null, res.label));
  }), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: '14px 0'
    }
  }), bottomMenu.map(function (res, i) {
    return !res.hidden && /*#__PURE__*/React.createElement(ListItemContainer, {
      key: i,
      href: res.role ? null : res.url,
      onClick: function onClick() {
        return res.role && toLink(res.url, res.role);
      },
      target: res.isNewTab && '_blank',
      rel: "noopener noreferrer"
    }, res.title);
  }), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: '14px 0'
    }
  }), /*#__PURE__*/React.createElement(ListItemContainer, {
    color: "#EF4D5E",
    onClick: onLogOut
  }, word$1.Logout[language])));
}

function HotAreaComponent(_ref) {
  var idTarget = _ref.idTarget,
    onClick = _ref.onClick,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    "aria-describedby": idTarget,
    style: {
      display: 'inline-flex',
      fontFamily: 'muli'
    },
    onClick: onClick
  }, children);
}

var HeaderWrapper = styled.a(["display:flex;flex-direction:row;text-decoration:none;padding:6px 16px;margin:10px 0px;font-family:Muli;cursor:pointer;align-items:center;&:hover{background-color:rgba(0,0,0,0.04);}.avatar{width:50px;height:50px;}.user-info{margin-left:16px;.user-name{font-size:16px !important;line-height:20px !important;color:#039be5;margin:0 0 4px 0;font-weight:bold !important;overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;}.position{color:#a9a8a8;margin:0;font-size:12px;line-height:16px !important;overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;}}"]);
var ListMenuWrapper = styled.div(["padding:10px 0px;margin:0;display:flex;flex-direction:column;a{font-family:Muli;cursor:pointer;padding:4px 16px;color:#039be5;font-size:14px;text-decoration:none;line-height:17.6px !important;&:hover{background-color:rgba(0,0,0,0.04);}}"]);

function Header$1(_ref) {
  var userLoginId = _ref.userLoginId,
    userLoginName = _ref.userLoginName,
    userLoginAvatar = _ref.userLoginAvatar,
    userLoginPosition = _ref.userLoginPosition,
    REACT_APP_SOSMED = _ref.REACT_APP_SOSMED;
  return /*#__PURE__*/React.createElement(HeaderWrapper, {
    href: REACT_APP_SOSMED + "/profile/" + userLoginId + "/detail"
  }, /*#__PURE__*/React.createElement(Avatar, {
    src: userLoginAvatar,
    className: "avatar",
    alt: "user-login-avatar"
  }), /*#__PURE__*/React.createElement("div", {
    className: "user-info"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "user-name"
  }, userLoginName), /*#__PURE__*/React.createElement("p", {
    className: "position"
  }, userLoginPosition)));
}

function ListMenu(_ref) {
  var list = _ref.list,
    REACT_APP_DOMAIN = _ref.REACT_APP_DOMAIN;
  var toLink = function toLink(link, role) {
    setCookie('currentRole', role, 1000, REACT_APP_DOMAIN);
    setTimeout(function () {
      window.open(link, '_blank');
    }, 500);
  };
  return /*#__PURE__*/React.createElement(ListMenuWrapper, null, list.map(function (res, i) {
    return !res.hidden && /*#__PURE__*/React.createElement("a", {
      href: res.role ? null : res.url,
      target: res.isOpenNewTab && '_blank',
      rel: "noopener noreferrer",
      key: res.title + "-" + i,
      onClick: function onClick() {
        return res.role && toLink(res.url, res.role);
      }
    }, res.title);
  }));
}

var DEFAULT_ANCHOR = {
  vertical: 'bottom',
  horizontal: 'right'
};
var DEFAULT_TRANSFORM = {
  vertical: 'top',
  horizontal: 'right'
};

function LogoutButton(_ref) {
  var onLogout = _ref.onLogout,
    language = _ref.language;
  return /*#__PURE__*/React.createElement(ListMenuWrapper, null, /*#__PURE__*/React.createElement("a", {
    onClick: onLogout
  }, word$1.Logout[language]));
}

var useLoginPopupStyles = makeStyles({
  paperPopover: {
    boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
    width: 270
  }
});
function UserLoginPopup(_ref) {
  var _ref$anchorOrigin = _ref.anchorOrigin,
    anchorOrigin = _ref$anchorOrigin === void 0 ? DEFAULT_ANCHOR : _ref$anchorOrigin,
    _ref$transformOrigin = _ref.transformOrigin,
    transformOrigin = _ref$transformOrigin === void 0 ? DEFAULT_TRANSFORM : _ref$transformOrigin,
    env = _ref.env,
    onLogout = _ref.onLogout,
    userLoginId = _ref.userLoginId,
    userLoginName = _ref.userLoginName,
    userLoginAvatar = _ref.userLoginAvatar,
    userLoginPosition = _ref.userLoginPosition,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '__user_login_popup__' : _ref$id,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'english' : _ref$language,
    globalModuleData = _ref.globalModuleData,
    children = _ref.children;
  var REACT_APP_SOSMED = env.REACT_APP_SOSMED,
    REACT_APP_HC_ADMIN = env.REACT_APP_HC_ADMIN,
    REACT_APP_HC_HOLDING = env.REACT_APP_HC_HOLDING,
    REACT_APP_DOMAIN = env.REACT_APP_DOMAIN;
  var classes = useLoginPopupStyles();
  var isShowAdministrator = useMemo(function () {
    return isAdministrator(language);
  }, [language]);
  var _useState = useState(null),
    anchorEl = _useState[0],
    setAnchorEl = _useState[1];
  var handleClickTrigger = function handleClickTrigger(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleClosePopup = function handleClosePopup() {
    setAnchorEl(null);
  };
  var open = Boolean(anchorEl);
  var listMenu = [{
    title: word$1.AccountSetting[language],
    url: REACT_APP_SOSMED + '/account-settings',
    isOpenNewTab: false
  }].concat(isShowAdministrator && [{
    title: word$1.Administrator[language],
    url: REACT_APP_HC_ADMIN,
    isOpenNewTab: false,
    role: 'organization-hr-admin'
  }] || [], [{
    title: word$1.CompanyGroup[language],
    url: REACT_APP_HC_HOLDING,
    isOpenNewTab: false,
    hidden: !hasModule(globalModuleData, 'holding'),
    role: 'holding-administrator'
  }, {
    title: word$1.ManageVendor[language],
    url: REACT_APP_SOSMED + '/vendorList',
    isOpenNewTab: false,
    hidden: !hasModule(globalModuleData, 'vendor')
  }, {
    title: word$1.Help[language],
    url: 'https://crm.wlb.co.id/forms/ticket',
    isOpenNewTab: true
  }]);
  var idTarget = open ? id : undefined;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HotAreaComponent, {
    onClick: handleClickTrigger,
    idTarget: idTarget
  }, children), /*#__PURE__*/React.createElement(Popover, {
    id: idTarget,
    open: open,
    anchorEl: anchorEl,
    onClose: handleClosePopup,
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin,
    classes: {
      paper: classes.paperPopover
    }
  }, /*#__PURE__*/React.createElement(Header$1, {
    userLoginId: userLoginId,
    userLoginAvatar: userLoginAvatar,
    userLoginName: userLoginName,
    userLoginPosition: userLoginPosition,
    REACT_APP_SOSMED: REACT_APP_SOSMED
  }), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(ListMenu, {
    list: listMenu,
    REACT_APP_DOMAIN: REACT_APP_DOMAIN
  }), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(LogoutButton, {
    language: language,
    onLogout: onLogout
  })));
}

var useStyles$3 = makeStyles(function () {
  return {
    search: {
      background: '#f7f8f9',
      padding: '10px 14.4px 10.1px 17.8px',
      '&::placeholder': {
        color: '#a9a8a8',
        fontSize: '13px'
      }
    },
    inputSearch: {
      background: '#f7f8f9'
    },
    paperPopover: {
      boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
      width: 270
    }
  };
});
function GlobalHeader(_ref) {
  var env = _ref.env,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 1195 : _ref$maxWidth,
    _ref$renderNotif = _ref.renderNotif,
    renderNotif = _ref$renderNotif === void 0 ? undefined : _ref$renderNotif,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'english' : _ref$language;
  var restUrl = env.rest_url,
    wlbRestUrl = env.wlb_rest_url;
  var classes = useStyles$3();
  var userData = getUserData();
  var _GetModularSettings = GetModularSettings(userData == null ? void 0 : userData.company_id),
    data = _GetModularSettings.data;
  var count = useGetUnreadNotification(wlbRestUrl);
  var onLogOut = function onLogOut() {
    setCookie('userData', '', 1000, env.REACT_APP_DOMAIN);
    setTimeout(function () {
      window.location = env.SSO_URL;
    }, 500);
  };
  var iconStyle = {
    color: 'rgb(1, 74, 98)',
    cursor: 'pointer',
    height: 24,
    width: 'auto'
  };
  var logoCompany = {
    height: 42,
    width: 'auto'
  };
  var isMobileScreen = useMediaQuery('(max-width: 1200px)');
  var _useState = useState(false),
    openDrawer = _useState[0],
    setOpenDrawer = _useState[1];
  var onClickDrawer = function onClickDrawer(anchor) {
    return setOpenDrawer(anchor);
  };
  var logoComponent = /*#__PURE__*/React.createElement("a", {
    href: env.REACT_APP_SOSMED
  }, userData != null && userData.company_logo ? /*#__PURE__*/React.createElement("img", {
    alt: "wlb-logo",
    src: userData.company_logo,
    width: "107px",
    style: logoCompany
  }) : /*#__PURE__*/React.createElement("img", {
    alt: "wlb-logo",
    src: WLBLogo,
    height: "auto",
    width: "107px"
  }));
  var notifComponent = /*#__PURE__*/React.createElement(Badge, {
    badgeContent: count,
    color: "error"
  }, /*#__PURE__*/React.createElement(NotifIcon, null));
  var userPosition = (userData == null ? void 0 : userData.position_name) + " " + word.at[language] + " " + (userData == null ? void 0 : userData.company_name);
  return /*#__PURE__*/React.createElement(HeaderStyled, null, /*#__PURE__*/React.createElement(HeaderContainer, {
    maxWidth: maxWidth
  }, isMobileScreen ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    onClick: function onClick() {
      return onClickDrawer('left');
    },
    size: "small"
  }, /*#__PURE__*/React.createElement(MenuIcon, {
    fontSize: "small",
    color: "primary"
  })), /*#__PURE__*/React.createElement(LeftDrawer, {
    open: openDrawer,
    setOpen: setOpenDrawer,
    logoComponent: logoComponent,
    env: env,
    language: language
  })) : logoComponent, /*#__PURE__*/React.createElement(OptionsContainer, null, /*#__PURE__*/React.createElement(GlobalSearch, {
    classes: classes,
    env: env,
    restUrl: restUrl,
    language: language
  })), /*#__PURE__*/React.createElement(RightOptionsContainer, null, !isMobileScreen && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    href: env.HOME_URL
  }, /*#__PURE__*/React.createElement(HomeOutlined, {
    style: iconStyle
  })), /*#__PURE__*/React.createElement("a", {
    href: env.REACT_APP_SOSMED + "followers/" + (userData == null ? void 0 : userData.id) + "/"
  }, /*#__PURE__*/React.createElement(PeopleAltOutlined, {
    style: iconStyle
  })), /*#__PURE__*/React.createElement("a", {
    href: env.REACT_APP_CHAT
  }, /*#__PURE__*/React.createElement(EmailOutlined, {
    style: iconStyle
  })), renderNotif != null ? renderNotif : /*#__PURE__*/React.createElement("a", {
    href: env.REACT_APP_SOSMED + "notification/" + env.NOTIF_PATH
  }, notifComponent)), isMobileScreen ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoggedInAvatar, {
    src: userData == null ? void 0 : userData.avatar,
    alt: "user-logged-icon",
    onClick: function onClick() {
      return onClickDrawer('right');
    }
  }), /*#__PURE__*/React.createElement(RightDrawer, {
    open: openDrawer,
    setOpen: setOpenDrawer,
    userData: userData,
    userPosition: userPosition,
    env: env,
    globalModuleData: data,
    language: language,
    onLogOut: onLogOut,
    notifComponent: notifComponent
  })) : /*#__PURE__*/React.createElement(UserLoginPopup, {
    userLoginId: userData == null ? void 0 : userData.id,
    userLoginName: userData == null ? void 0 : userData.name,
    userLoginAvatar: userData == null ? void 0 : userData.avatar,
    userLoginPosition: userPosition,
    env: env,
    onLogout: onLogOut,
    language: language,
    globalModuleData: data
  }, /*#__PURE__*/React.createElement(LoggedInAvatar, {
    src: userData == null ? void 0 : userData.avatar,
    alt: "user-logged-icon"
  })))));
}
var word = {
  at: {
    english: 'at',
    indonesian: 'di'
  }
};

var PrimitiveOrgChart = styled.div(["position:relative;table{table-layout:fixed;margin:auto;padding:0;border-collapse:collapse;border-spacing:0;}td{vertical-align:top;}.node{padding:var(--orgchart-node-padding,30px 10px);}.staffLeft{float:right;}.staffRight{float:left;}.graph{position:absolute;top:0;left:0;z-index:-1;}.graph path{fill:none;stroke:var(--orgchart-stroke-color,#000000);stroke-width:var(--orgchart-stroke-width,1px);}"]);
var SVG_NS = 'http://www.w3.org/2000/svg';
var OrgChart = function OrgChart(props) {
  var data = props.data,
    render = props.render,
    _props$chartId = props.chartId,
    chartId = _props$chartId === void 0 ? 'orgchart' : _props$chartId,
    _props$staffProperty = props.staffProperty,
    staffProperty = _props$staffProperty === void 0 ? 'staff' : _props$staffProperty,
    _props$idProperty = props.idProperty,
    idProperty = _props$idProperty === void 0 ? 'id' : _props$idProperty,
    _props$childrenProper = props.childrenProperty,
    childrenProperty = _props$childrenProper === void 0 ? 'children' : _props$childrenProper,
    _props$strokeStylePro = props.strokeStyleProperty,
    strokeStyleProperty = _props$strokeStylePro === void 0 ? 'strokeStyle' : _props$strokeStylePro;
  var containerRef = React.useRef();
  var svgRef = React.useRef();
  var refreshLines = function refreshLines() {
    /** @type {HTMLDivElement} */
    var container = containerRef.current;
    /** @type {SVGSVGElement} */
    var svg = svgRef.current;
    var containerRect = container.getBoundingClientRect();
    var scale = 1 / (containerRect.width / container.offsetWidth);
    var paths = Array.from(svg.childNodes);
    var prev = paths.length;
    var idx = 0;
    var queue = [[null, data]];
    svg.style.width = containerRect.width + 'px';
    svg.style.height = containerRect.height + 'px';
    while (queue.length) {
      var _queue$pop = queue.pop(),
        parentId = _queue$pop[0],
        node = _queue$pop[1];
      var id = node[idProperty];
      var children = node[childrenProperty];
      var strokeStyle = node[strokeStyleProperty];
      if (children) {
        for (var _idx = 0, len = children.length; _idx < len; _idx++) {
          var child = children[_idx];
          queue.push([id, child]);
        }
      }
      if (!parentId) {
        continue;
      }
      var parentEl = container.querySelector(".container[data-id=\"" + chartId + parentId + "\"]");
      var nodeEl = container.querySelector(".container[data-id=\"" + chartId + id + "\"]");
      var parentRect = parentEl.getBoundingClientRect();
      var nodeRect = nodeEl.getBoundingClientRect();
      var parentX = parentRect.left - containerRect.left;
      var parentY = parentRect.top - containerRect.top;
      var nodeX = nodeRect.left - containerRect.left;
      var nodeY = nodeRect.top - containerRect.top;
      var d = 'M' + (parentX + parentRect.width / 2) * scale + ' ' + (parentY + parentRect.height) * scale + ' V' + (nodeY * scale - 16) + ' H' + (nodeX + nodeRect.width / 2) * scale + ' V' + nodeY * scale;

      /** @type {SVGPathElement} */
      var pathEl = void 0;
      if (idx < prev) {
        pathEl = paths[idx];
      } else {
        pathEl = document.createElementNS(SVG_NS, 'path');
        svg.appendChild(pathEl);
      }
      pathEl.setAttributeNS(null, 'd', d);
      pathEl.style.strokeDasharray = strokeStyle === 'dotted' ? '2px' : '';
      idx++;
    }
    for (; idx < prev; idx++) {
      var excess = paths[idx];
      excess.remove();
    }
  };
  React.useEffect(function () {
    refreshLines();

    // eslint-disable-next-line no-undef
    var callback = function callback() {
      return requestAnimationFrame(refreshLines);
    };
    window.addEventListener('resize', callback);
    return function () {
      return window.removeEventListener('resize', callback);
    };
  });
  var renderNode = function renderNode(node) {
    var children = node[childrenProperty] || [];
    var leftAssistants = [];
    var rightAssistants = [];
    var divisions = [];
    var assistantIdx = 0;
    var hasAssistants = false;
    var hasLeftAssistants = false;
    var hasRightAssistants = false;
    var hasDivisions = false;
    for (var idx = 0, len = children.length; idx < len; idx++) {
      var child = children[idx];
      if (child[staffProperty]) {
        if (assistantIdx % 2 === 0) {
          leftAssistants.push(child);
          hasLeftAssistants = true;
        } else {
          rightAssistants.push(child);
          hasRightAssistants = true;
        }
        assistantIdx += 1;
        hasAssistants = true;
      } else {
        divisions.push(child);
        hasDivisions = true;
      }
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "group"
    }, /*#__PURE__*/React.createElement("table", {
      className: "parent"
    }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
      className: "node"
    }, /*#__PURE__*/React.createElement("div", {
      className: "container",
      "data-id": "" + chartId + node[idProperty]
    }, render(node))), /*#__PURE__*/React.createElement("td", null)), hasAssistants && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, hasLeftAssistants && /*#__PURE__*/React.createElement("div", {
      className: "staffLeft"
    }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, leftAssistants.map(function (child, idx) {
      return /*#__PURE__*/React.createElement("tr", {
        key: idx
      }, /*#__PURE__*/React.createElement("td", null, renderNode(child)));
    }))))), /*#__PURE__*/React.createElement("td", {
      className: "gap"
    }), /*#__PURE__*/React.createElement("td", null, hasRightAssistants && /*#__PURE__*/React.createElement("div", {
      className: "staffRight"
    }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, rightAssistants.map(function (child, idx) {
      return /*#__PURE__*/React.createElement("tr", {
        key: idx
      }, /*#__PURE__*/React.createElement("td", null, renderNode(child)));
    })))))))), hasDivisions && /*#__PURE__*/React.createElement("table", {
      className: "children"
    }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, divisions.map(function (child, idx) {
      return /*#__PURE__*/React.createElement("td", {
        key: idx
      }, renderNode(child));
    })))));
  };
  return /*#__PURE__*/React.createElement(PrimitiveOrgChart, {
    ref: containerRef,
    id: chartId
  }, renderNode(data), /*#__PURE__*/React.createElement("svg", {
    ref: svgRef,
    className: "graph"
  }));
};
var MemoizedOrgChart = /*#__PURE__*/React.memo(OrgChart);

var clamp = function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
};

/**
 *
 * @param {fn} onChange
 * @param {object} handlers {onScrubStart: () => void; onScrubEnd: () => void}
 * @param {string} dir 'ltr' | 'rtl'
 * @returns {object} | { ref, active }
 */
var useMove = function useMove(onChange, handlers, dir) {
  if (dir === void 0) {
    dir = 'ltr';
  }
  var ref = useRef();
  var mounted = useRef(false);
  var isSliding = useRef(false);
  var frame = useRef(0);
  var _useState = useState(false),
    active = _useState[0],
    setActive = _useState[1];
  var _useState2 = useState(''),
    eventType = _useState2[0],
    setEventType = _useState2[1];
  useEffect(function () {
    mounted.current = true;
  }, []);
  useEffect(function () {
    var onScrub = function onScrub(_ref) {
      var x = _ref.x,
        y = _ref.y;
      window.cancelAnimationFrame(frame.current);
      frame.current = window.requestAnimationFrame(function () {
        if (mounted.current && ref.current) {
          ref.current.style.userSelect = 'none';
          var rect = ref.current.getBoundingClientRect();
          if (rect.width && rect.height) {
            var _x = clamp((x - rect.left) / rect.width, 0, 1);
            onChange({
              x: dir === 'ltr' ? _x : 1 - _x,
              y: clamp((y - rect.top) / rect.height, 0, 1)
            });
          }
        }
      });
    };
    var bindEvents = function bindEvents() {
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', stopScrubbing);
      document.addEventListener('touchmove', onTouchMove);
      document.addEventListener('touchend', stopScrubbing);
    };
    var unbindEvents = function unbindEvents() {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', stopScrubbing);
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', stopScrubbing);
    };
    var startScrubbing = function startScrubbing() {
      if (!isSliding.current && mounted.current) {
        isSliding.current = true;
        typeof (handlers == null ? void 0 : handlers.onScrubStart) === 'function' && handlers.onScrubStart();
        setActive(true);
        bindEvents();
      }
    };
    var stopScrubbing = function stopScrubbing() {
      if (isSliding.current && mounted.current) {
        isSliding.current = false;
        setActive(false);
        unbindEvents();
        setTimeout(function () {
          typeof (handlers == null ? void 0 : handlers.onScrubEnd) === 'function' && handlers.onScrubEnd();
        }, 0);
      }
    };
    var onMouseDown = function onMouseDown(event) {
      setEventType(event.type);
      startScrubbing();
      event.preventDefault();
    };
    var onMouseMove = function onMouseMove(event) {
      setEventType(event.type);
      onScrub({
        x: event.clientX,
        y: event.clientY,
        type: event.type
      });
    };
    var onTouchStart = function onTouchStart(event) {
      setEventType(event.type);
      if (event.cancelable) {
        event.preventDefault();
      }
      startScrubbing();
    };
    var onTouchMove = function onTouchMove(event) {
      setEventType(event.type);
      if (event.cancelable) {
        event.preventDefault();
      }
      onScrub({
        x: event.changedTouches[0].clientX,
        y: event.changedTouches[0].clientY
      });
    };
    ref.current.addEventListener('mousedown', onMouseDown);
    ref.current.addEventListener('touchstart', onTouchStart, {
      passive: true
    });
    return function () {
      if (ref.current) {
        ref.current.removeEventListener('mousedown', onMouseDown);
        ref.current.removeEventListener('touchstart', onTouchStart);
      }
    };
  }, [dir, onChange]);
  var isMoving = ['touchmove', 'mousemove'].includes(eventType);
  return {
    ref: ref,
    active: active,
    isMoving: isMoving
  };
};

var useStyles$2 = makeStyles(function () {
  return {
    root: {
      backgroundColor: '#fff',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontFamily: 'muli',
      paddingTop: 20,
      position: 'sticky',
      top: 0,
      zIndex: 1
    },
    title: {
      fontSize: 12,
      fontWeight: '600',
      color: '#014A62',
      margin: 0
    }
  };
});
var Header = function Header(_ref) {
  var title = _ref.title,
    onClose = _ref.onClose;
  var classes = useStyles$2();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.title
  }, title || 'Widget'), /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClose,
    size: "small"
  }, /*#__PURE__*/React.createElement(CloseIcon, null)));
};

var useStyles$1 = makeStyles(function () {
  return {
    section: {
      marginTop: 24
    },
    sectionHeader: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 16
    },
    sectionLabel: {
      fontSize: 14,
      margin: 0
    },
    seeMoreLabel: {
      fontSize: 14,
      marginTop: '18px 0 0',
      color: '#039BE5',
      cursor: 'pointer'
    }
  };
});
var Section = function Section(_ref) {
  var label = _ref.label,
    action = _ref.action,
    children = _ref.children,
    seeMoreLabel = _ref.seeMoreLabel,
    onSeeMore = _ref.onSeeMore;
  var classes = useStyles$1();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.section
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.sectionHeader
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.sectionLabel
  }, label), action), children, seeMoreLabel && /*#__PURE__*/React.createElement("p", {
    className: classes.seeMoreLabel,
    onClick: onSeeMore
  }, seeMoreLabel));
};

var Calendar = function Calendar(_ref) {
  var _data$slice;
  var company = _ref.company,
    self = _ref.self,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'english' : _ref$language;
  var _useGetCalendar = useGetCalendar(company, self, language),
    data = _useGetCalendar.data,
    loading = _useGetCalendar.loading,
    date = _useGetCalendar.date,
    nextDate = _useGetCalendar.nextDate,
    previousDate = _useGetCalendar.previousDate;
  var _useState = useState(4),
    limit = _useState[0],
    setLimit = _useState[1];
  var seeMoreLabel = (data == null ? void 0 : data.length) > 4 ? limit === 4 ? lang.seeMore[language] : lang.seeLess[language] : '';
  return /*#__PURE__*/React.createElement(HolidayContainer, {
    width: "100%",
    padding: "0px",
    elevation: 0
  }, /*#__PURE__*/React.createElement(Section, {
    label: word$3.calendar[language],
    seeMoreLabel: seeMoreLabel,
    onSeeMore: function onSeeMore() {
      return setLimit(limit === 4 ? data == null ? void 0 : data.length : 4);
    },
    action: /*#__PURE__*/React.createElement(ActionCalendar, {
      onPrev: previousDate,
      onNext: nextDate
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "mih-220"
  }, loading && /*#__PURE__*/React.createElement(HolidayLoading, null), !loading && (data == null ? void 0 : data.length) === 0 && /*#__PURE__*/React.createElement(HolidayNoData, {
    language: language,
    date: date
  }), !loading && (data == null ? void 0 : (_data$slice = data.slice(0, limit)) == null ? void 0 : _data$slice.map(function (res, i) {
    return /*#__PURE__*/React.createElement(HolidayData, {
      key: i,
      name: res.name,
      date: res.date,
      color: res.color
    });
  })))));
};
var ActionCalendar = function ActionCalendar(_ref2) {
  var onPrev = _ref2.onPrev,
    onNext = _ref2.onNext;
  return /*#__PURE__*/React.createElement("div", {
    className: "button-wrapper"
  }, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    className: "left-icon page-icon",
    onClick: onPrev
  }), /*#__PURE__*/React.createElement(ChevronRightIcon, {
    className: "page-icon",
    onClick: onNext
  }));
};
var lang = {
  seeMore: {
    indonesian: 'Lihat Lebih Banyak',
    english: 'See More'
  },
  seeLess: {
    indonesian: 'Lihat Lebih Sedikit',
    english: 'See Less'
  }
};

var useStyles = makeStyles(function () {
  return {
    wrapper: {
      position: 'absolute',
      top: 0
    },
    track: {
      position: 'fixed',
      right: 0
    },
    rail: {
      width: 1,
      position: 'relative'
    },
    button: {
      position: 'absolute',
      right: '-20px',
      padding: '13px 15px',
      borderRadius: '100px 0px 0px 100px',
      display: 'flex',
      justifyContent: 'flex-start'
    },
    icon: {
      width: 19,
      height: 19
    },
    title: {
      margin: 0,
      fontSize: 16
    },
    drawer: {
      width: 350,
      padding: '0px 20px 20px',
      fontFamily: 'muli'
    }
  };
});
var FloatingMenu = function FloatingMenu(props) {
  var _props$hidden = props.hidden,
    hidden = _props$hidden === void 0 ? false : _props$hidden,
    scrub = props.scrub,
    _props$topOffset = props.topOffset,
    topOffset = _props$topOffset === void 0 ? 160 : _props$topOffset,
    _props$bottomOffset = props.bottomOffset,
    bottomOffset = _props$bottomOffset === void 0 ? 40 : _props$bottomOffset,
    _props$defaultPositio = props.defaultPosition,
    defaultPosition = _props$defaultPositio === void 0 ? 1 : _props$defaultPositio,
    onScrubStart = props.onScrubStart,
    onScrubEnd = props.onScrubEnd,
    children = props.children;
  if (hidden) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  var classes = useStyles();
  var _useState = useState(defaultPosition),
    value = _useState[0],
    setValue = _useState[1];
  var _useState2 = useState(false),
    openDrawer = _useState2[0],
    setOpenDrawer = _useState2[1];

  // optional
  var handlers = {
    onScrubStart: onScrubStart,
    onScrubEnd: onScrubEnd
  };
  var _useMove = useMove(function (_ref) {
      var y = _ref.y;
      return scrub && setValue(1 - y);
    }, handlers),
    ref = _useMove.ref,
    isMoving = _useMove.isMoving,
    active = _useMove.active;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.track,
    style: {
      top: topOffset
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classes.rail,
    style: {
      height: "calc(100vh - " + (topOffset + bottomOffset) + "px)"
    }
  }, /*#__PURE__*/React.createElement(Button, {
    disableElevation: true,
    variant: "contained",
    color: "primary",
    className: classes.button,
    onClick: function onClick() {
      return !isMoving && setOpenDrawer(true);
    },
    style: {
      bottom: "calc(" + value * 100 + "% - 25px)",
      cursor: isMoving && active ? 'grabbing' : 'pointer'
    }
  }, /*#__PURE__*/React.createElement(WidgetsIcon, {
    className: classes.icon
  }))))), /*#__PURE__*/React.createElement(Drawer, {
    anchor: "right",
    open: openDrawer,
    onClose: function onClose() {
      return setOpenDrawer(false);
    },
    classes: {
      paper: classes.drawer
    }
  }, /*#__PURE__*/React.createElement(Header, _extends({}, props, {
    onClose: function onClose() {
      return setOpenDrawer(false);
    }
  })), children));
};
FloatingMenu.Calendar = Calendar;
FloatingMenu.Section = Section;

export { AssignFilter, AttachmentCard, AttachmentItem, DateRangePicker, EmptyState, Filter, FloatingMenu, GetModularSettings, GlobalHeader, GlobalSidebar, MicrolearningPopup, NoConnection, MemoizedOrgChart as OrgChart, UploadButton, WidgetHoliday, getFileIcon, getFileType, useDebounced, useMove };
